/**
 * Docket Alarm
 * Javascript Utility Functions - General to all pages.
 */

// Import DOMPurify. We can use it to sanitize any potentially problematic value, such as html formatted
// errors from the backend while still being safe from potential injection attacks
import * as DOMPurify from 'dompurify';

// Register the Service worker
navigator.serviceWorker.register('/sw.js', {scope: '/'})
	.then((reg) => console.log("Successfully registered with root scope!"))
	.catch((err) => console.error("Registration failed:", err));

// configure DOMPurify to accept only certain html elements
DOMPurify.setConfig({ALLOWED_TAGS: ['h4', 'p', 'div', 'span']});

// Make sure we have console
if (!window.console) {
	window.console = {};
	console = {};
}
if (!window.console.log) {
	window.console.log = function () { };
	console.log = function () { };
}

// TODO: I think we can/should delete this, but haven't tested.
// Google Analytics - analytics.js
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');

// Google Tag Manager
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KNKW5TW');

ga('create', 'UA-2119060-7', 'auto');  // Replace with your property ID.

// Hubspot Logged In User Identification.
var _hsq = window._hsq = window._hsq || [];
if(user_logged_in) {
	_hsq.push(["identify",{email: user_logged_in}]);
}

// Create a method for mouseover check
// use by doing $element.mouseIsOver();
jQuery.fn.mouseIsOver = function () {
    return $(this).parent().find($(this).selector + ":hover").length > 0;
};

/**
 * Track an event on Google Analytics.
 * @param category The event Category, a string
 * @param action
 * @param label
 */
function analytics_track(category, action, label) {
	if(window.location.origin.search("://localhost:8080") != -1) {
		// Don't track localhost activity.
		return
	}
	ga('send', 'event', category, action, label);
}
function analytics_dimension(logged_in, org_type, billing_type, paywall_expired) {
	ga('set', {
		'dimension1':  logged_in && logged_in.length ? "true": "false",
		'dimension2':  (org_type || '').toString(),
		'dimension3':  (billing_type || '').toString(),
		'dimension4':  paywall_expired.toString(),
	});
	// Send ipMeta data if we're on production.
	if(/localhost:\d+/.test(window.location.host) == false) {
		ga('require', 'ipMeta', {
			apiKey: 'f9b0200b34ede3d1b4bf5db5d70f57c468c60278e117520204bc549e4e265b1c',
			serviceProvider: 'dimension1',
			networkDomain: 'dimension2',
			networkType: 'dimension3',
		});
		ga('ipMeta:loadNetworkFields');
	}
	ga('send', 'pageview');
}

//////////////////
// Utility Functions

// Strings
String.prototype.strip = function() {
	return this.replace(/^\s+|\s+$/g,"");
};
String.prototype.replaceAll = function(to_find, with_this) {
  return this.replace(new RegExp(to_find, 'g'), with_this);
};
if (typeof String.prototype.startsWith != 'function') {
  String.prototype.startsWith = function (str) {
    return this.slice(0, str.length) == str;
  };
}
if (typeof String.prototype.endsWith != 'function') {
    String.prototype.endsWith = function(suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

// Basic string hashing function taken from an SO post.
function gen_string_hash(s) {
	var hash = 0, i, chr, len;
	if(s.length == 0){
		return hash;
	}
	for(i = 0, len = s.length; i < len; i++) {
		chr = s.charCodeAt(i);
		hash = hash * 31 + chr;
		hash |= 0; // Convert to 32 bit integer
	}
	return hash;
}

// Capitalizes a string
function capitalize(str) {
	return str.replace(/\w\S*/g, function _rep_cap(txt){
		return txt.charAt(0).toUpperCase() + 
			txt.substr(1).toLowerCase();
		});
}

/**
 * Abbreviate the given words based on a simple heuristic.
 **/
function get_abbreviation(t) {
	// Split up spaces and punctuation.
	return t.split(/[\s;:,]+/ig).map(function (e) {
		// Remove stopwords altogether.
		if(e.search(/^(a|an|are|as|at|be|but|by|for|if|in|into|is|it|of|on|such|that|the|their|then|there|these|they|this|to|was|with|or|and|will|)?$/ig) == 0) {
			return "";
		}
		// Find first vowel.
		var vowel = e.search(/[aeiouy]/ig);
		// Find consonant after vowel.
		var consonant = e.substring(vowel).search(/[^aeiouy]/ig);
		return consonant == -1 ? e:
			vowel + consonant + 2 >= e.length ? e:
			e.substring(0, vowel + consonant + 1) + ".";
	}).filter(function (e) {
		return e && e.length;
	}).join(" ");
}

function plural_have(n) {
	var n_s = number_with_commas(n || 0);
	return n_s.toString() + (n == 1 ? " has" : " have");
}

/**
 * @returns The plural of the input text if n != 1.
 */
function plural(n, text) {
	if(n == 1) {
		// Not plural, don't pluralize.
		return text;
	}
	// We can probably do a lot better, see:
	// https://web2.uvcs.uvic.ca/elc/studyzone/330/grammar/irrplu.htm
	// https://stackoverflow.com/questions/18902608/generating-the-plural-form-of-a-noun
	// Not sure why "ing" is excluded, adding back in "proceeding_s_".
	if(text.endsWith("ed") || (text.endsWith("ing") && !text.endsWith("ceeding"))) {
		return text;
	}
	// For: bankruptcies, "entry-->entries", reply
	if(text.endsWith("cy") || text.endsWith("party") || text.endsWith("ntry")  || text.endsWith("eply")) {
		return text.slice(0, -1) + "ies";
	}
	return text + (text.endsWith("s") ? "'" : "s");
}
function plural_n(n, text) {
	var n_s = number_with_commas(n || 0);
	return n_s.toString() + " " + plural(n, text);
}


function escape_html(m) {
    if(typeof m == "number" || typeof m == "boolean") {
        return m.toString();
    } else if(m === null || m === undefined) {
    	console.warn("Trying to escape 'null' html.");
		return null;
	}
	return m.replace(/&/gm, "&amp;"
		).replace(/"/gm,"&quot;").replace(/'/gm, "&#39;"
		).replace(/</gm, "&lt;").replace(/\\/gm, "&#92;"
		).replace(/"/gm, "&quot;").replace(/'/gm, "&#39;");
}

/**
 * Turn a list of items into a human readable list.
 */
function human_list(items, ltype) {
	ltype = ltype || "and";
	return !items || items.length == 0 ? "":
			items.length == 1 ? items[0]:
			items.length == 2 ? items.join(" " + ltype + " "):
			items.slice(0, items.length-1).join(", ") + " " +
				ltype + " " + items[items.length-1];
}

/**
 * Puts a date object into more human readable terms.
 */
function humanize_time(t) {
	t = (new Date() - t) / 1000;
	var sign = t > 0 ? " ago" : " from now";
	t = Math.abs(t);
	return t < 10 ? "just now":
		t < 50 ? Math.floor(t).toString() + " seconds" + sign:
		t < 120 ? "a minute" + sign:
		t < 60*60 ? Math.floor(t/60).toString() + " minutes" + sign:
		t < 2*60*60 ? "an hour" + sign:
		t < 22*60*60 ? Math.floor(t/60/60).toString() + " hours" + sign:
		t < 2*24*60*60 ? "a day" + sign:
		t < 30*24*60*60 ? Math.floor(t/60/60/24).toString() + " days" + sign:
		"more than a month" + sign;
}

function humanize_time_utc(t) {
	if(!t) {
		return '';
	}
	if(typeof t == 'string') {
		t = new Date(t);
	}
	var t_time = t.getTime();
	if(isNaN(t_time)) {
		return '';
	}
	// UTC to local date time correction.
    t = new Date(t_time - t.getTimezoneOffset()*60*1000);
    return humanize_time(t);
}

/**
 *    By comparing a time value with the current time, we would return human readable time.
 *    For eg, while comparing a time value with current date, this function could return values from
 *    Year all the way to Seconds. Like "1 year, 1 month ago" OR "1 week, 5 days from now".
 *    The humanize_time function above only returns 1 interval. like "1 year ago" or "1 month from now"
 * @param value: The datetime value that we want to evaluate
 * @param interval_limit: number of time intervals that we want to return
 * @returns {string|*}
 */
function humanize_time_granular(value, interval_limit){
	var t_c = [
		{
			"interval": "year",
			"calc": 60 * 60 * 24 * 365
		},
		{
			"interval": "month",
			"calc": 60 * 60 * 24 * 30
		},
		{
			"interval": "week",
			"calc": 60 * 60 * 24 * 7
		},
		{
			"interval": "day",
			"calc": 60 * 60 * 24
		},
		{
			"interval": "hour",
			"calc": 60 * 60
		},
		{
			"interval": "minute",
			"calc": 60
		},
		{
			"interval": "second",
			"calc": 1
		}
	];

	if (isNaN(Date.parse(value))){
		return  value;
	}
	var date_val = Date.parse(value);
	var date_now = Date.now();
	var delta = date_now - date_val;

	//The time interval is in past or in future?
	var sign = delta > 0 ? " ago" : " from now";
	delta = Math.abs(delta);

	//Convert delta from milliseconds to seconds
	delta = delta / 1000;
	var calculated_time = [];
	var time_val = "";
	/*
	Dividing the time delta with time intervals from year to minute and pushing the intervals
	to the list for later use
	*/
	for(var i =0; i < t_c.length; i ++){
		if (delta <= 0){
			break;
		}
		var interval = t_c[i].interval;
		var calc = t_c[i].calc;
		var time_calc = Math.floor(delta / calc);
		if(time_calc > 0) {
			time_val = time_calc + " " + interval + (time_calc > 1 ? "s" : "");
			//pushing the intervals to list
			calculated_time.push(time_val);
			delta = delta - (calc * time_calc);
		}
	}
	//This is where we decide how many items from the list we want to OR can display
	//to the user. Our default is only 2 intervals but if the time delta is very short then we
	//might end up showing only 1 interval
	var calc_limit = Math.min(calculated_time.length, interval_limit || 2);
	//Slicing the array and concatinating them to create meaningful time interval
	var time_interval = calculated_time.slice(0, calc_limit).join(', ') + sign;
	return time_interval;
}

/**
 * Checking if a string is a number is more complex than one would think.
 * @param my_str
 * @returns {boolean} true if the string is represented as a number.
 */
function is_number(my_str) {
  return !isNaN(Number(my_str)) && (Boolean(my_str) || my_str == 0);
}

function number_with_commas(x) {
	// Split up decimal.
    var parts = x.toString().split(".");
	if (typeof x != "number" || Math.abs(x) >= 10000) {
		// Add commas over 10k.
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	// Make at least two decimals.
	if(parts.length > 1 && parts[1].length == 1){
		parts[1] += '0';
	}
    return parts.join(".");
}
function number_with_abbrev(x, decimals) {
	if(decimals === undefined)  {
		decimals = 2;
	}
	var sign = '';
	if(x < 0) {
		sign = '-';
		x = -x;
	}
	// Less than 100k, give the number
	return sign + (
		x < 1e5 ? number_with_commas(x):
		// Keep the same sig digits, even though we mess with the decimals.
		x < 1e6 ? (x/1e3).toFixed(decimals < 3 ? 0 : decimals - 3) + "k":
		x < 1e9 ? (x/1e6).toFixed(decimals) + "M":
				  (x/1e9).toFixed(decimals) + "B");
}
function roundNumber(num, dec) {
	if(dec === undefined) {
		dec = 0;
	}
	return Math.round(num*Math.pow(10,dec))/Math.pow(10,dec);
}

/**
 * Return a Unique ID
 **/
function uniqueid() {
	// The first value must be a-zA-Z.
	var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
	var t = possible.charAt(Math.floor(Math.random() * possible.length));
	// After the first, we can include numbers.
	possible += "0123456789";
	for(var i = 0; i < 4; i++ ) {
		t += possible.charAt(Math.floor(Math.random() * possible.length));
	}
	// If this ID already exists, then try again.
	return $("#" + t).length ? uniqueid() : t;
}

/**
 * Should be called whenever we're inserting a user editable link directly 
 * into the DOM. Prevents security issues.
 */
function sanitize_dom_url(s) {
	if(typeof s == "number") {
		s = s.toString();
		console.log("sanitize_dom_url given a number: " + s);
	}
	return s.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;")
		.replace(/\?/g, "&#63;");
}

// Arrays
function sum_array(array, init) {
	// Unfortunately, it's impossible to write this as a prototype on IE8.
	
	var total = init === undefined ? 0 : init;
	for(var i = 0; i < array.length; i++) {
		total += array[i];
	}
	return total;
}
Array.max = function( array ){
    return Math.max.apply( Math, array );
};
 
Array.min = function( array ){
    return Math.min.apply( Math, array );
};

/**
 * Dedup an array.
 * @param array An array of anything of the same type (e.g., can't mix ints and strings).
 * @returns {*[]} The deduplicated array in the same order.
 */
function unique_array(array) {
	var o = {}, a = [];
    for (var i = 0; i < array.length; i++) {
		var v = array[i];
		var k = v === undefined || v === null ? "":
			v.toString() + " :: " + typeof v;
		if(o[k] === undefined) {
			o[k] = true;
			a.push(v);
		}
	}
    return a;
}

/**
 * Join jquery objects, and wrap them in an html element. This function
 * makes it easier to combine multiple jquery objects in an array.
 * @param inArray An array of jquery objects
 * @param cls     The html class of the parent array.
 * @param tag	  The html tag of the parent array (default: span)
 * @returns {jQuery|HTMLElement}
 */
function join_jquery(inArray, cls, tag) {
	if(!tag) {
		tag = "span";
	}
	var $html = $("<" + tag + " class='" + (cls ||'') + "'></" + tag +
		">").empty();
	for(var i = 0; i < inArray.length; i++) {
		$html.append(inArray[i])
	}
	return $html;
}

/**
 * Turn any text into an html object, safely escaping any characters.
 * Useful mostly to for shorthand, rather than creating giant strings.
 * @param text	The text you want to turn into an object.
 * @param tag	The HTML tag that will wrap the text (default: <span>).
 * @param cls	The HTML class of the object.
 * @param data	A javascript dict of any "data" that you want stored in the HTML
 * 				object. Can be retrieved with jquery .data(..) command.
 * @param attrs	Any HTML attributes you want applied to the wrapped object.
 * @returns {string}
 */
function wrap_html(text, tag, cls, data, attrs) {
	if(!tag) {
		tag = "span"
	}
	var extra = cls ? " class='" + cls + "'" : "";
	var k = null;
	if(data) {
		if(typeof data == "object") {
			for(k in data) {
				var val = data[k];
				if(val == null) {
					console.warn("wrap_html data element is null: " + k);
				} else {
					extra += " data-" + escape_html(k) + "='" + escape_html(val) + "'";
				}
			}
		} else {
			console.warn("Data not an object.");
		}
	}
	if(attrs) {
		for(k in attrs) {
			extra += " " + escape_html(k) + "='" +
				escape_html(attrs[k]) + "'";
		}
	}
	return "<" + tag + extra + ">" + text + "</" + tag + ">";
}

/**
 * See wrap_html for documentation, this function just rearranges some
 * parameters for convenience. Use whichever is easiest.
 * @param tag
 * @param cls
 * @param text
 * @param data
 * @param attrs
 * @returns {string}
 */
function html_tag(tag, cls, text, data, attrs) {
	return wrap_html(text, tag, cls, data, attrs);
}

/**
 * Given a Docket Alarm search query, wrap the query in parenthesis so it
 * can be nicely used with other search query chunks. For example, given
 * the query "Hello There", this will return "(Hello There)".
 * @param q The query you want to wrap.
 * @param always Always wrap the query, even if it already has parenthesis.
 * @param wrap_char Specify a character to use for wrapping, default to parenthesis.
 */
function wrap_query(q, always, wrap_char) {
	var need_wrap = always || q.search(/[\s()]/) != -1;
	// Wrap in parenthesis or other char, if needed.
	return need_wrap ? (
		wrap_char ? wrap_char + q + wrap_char : "(" + q + ")"
	) : q;
}

/**
 *  Create hierarchical html from a lists of nested dictionaries. Useful for
 *  sidebars, action bars, and other items where the html is cumbersome.
 Format:
    // Must send a list of dictionaries
    create_html_from_json([{
        // Each dictionary item can have a type
        type : 'link', // can also be list, see below, horizontal-rule.
        title : 'My Case Alerts', // User displayed title
        icon : 'fas fa-bells', // Font awesome icon classes
        href : '/foo/#analytics', // A link to hyperlink to.
        klass: 'dashboard', // Any additional classes to add
        tip : 'View all of the cases.', // Powertip
 		tip_class: 'class_name', // The class name of the powertip.
 		gutter : { // Element that appears to the right in the gutter on hover.
 			text: 'Element Text',
 			icon: 'Element Icon',
 			tip: 'Tooltip',
 			tag: 'a' // defaults to a.
 		}
    },{
        // Nested lists can be of type "list"
        type : 'list',
        title : 'Support',
        // You can style nested lists the same as links
        icon : 'fas fa-question',
        // These nested items work the same way as the others.
        items : [{
            // Select Dropdown
            title : 'Quick Start Guide',
            type : 'select',
            options : [{
                k:"select option value",
                v:"select option user display value"},
            ...],
        },{
            // ADVANCED Usage, use a script instead of a link.
            type : 'link',
            title : 'Video Tutorials',
            // Instead of a link, this is a script that is run when clicked:
            // CAUTION: This executes a javascript command and may be unsafe
            // if relying on user input. Don't do anything fancy here.
            script : 'show_salesforce_chat_window'
        }}
    ]);
 **/
function create_html_from_json(sidebar) {
    // We allow certain javascript functions to be run, but for security,
    // make sure only certain functions are run. This is more of a double
    // safety measure than a real
    var allowed_functions = /^show_/i;
    function create_icon_html(icon) {
    	if(!icon) {
    		return '';
		}
		if(icon.search(/^fa[rsdbl]?\s+fa[rsdbl]?-/) != -1) {
			// Handle font-awesome images.
			return wrap_html("", "i", icon + " icon");
		} else if(icon.search(/\.(png|jpg)$/) != -1) {
			// Handle normal image icons.
			return "<img class='icon' src='" + icon + "'>";
		} else if(icon.search(/\.svg$/) != -1) {
			// Handle SVG images.
			return "<img class='icon svg' src='" + icon + "'>";
		}
		return '';
	}
	function create_tip_data(tip, tip_klass) {
    	return tip ? {'powertip': wrap_html(tip, "span", "menutip " +
				(tip_klass || ''))} : {};
	}
    function create_one(s, depth) {
        if(!s || s.hide) {
            return null;
        }
        if(s.type == 'horizontal-rule') {
            return wrap_html("", "hr", s.klass || "");
        }
        // Add an optional icon.
        var icon = create_icon_html(s.icon);
        // The title is HTML, you must do your own HTML safety encoding.
        var title = s.title && s.title.length ?
            wrap_html(s.title, 'div', 'text') : "";
        // Titles are h3 or a by default.
        var t_tag = s.title_tag ? s.title_tag : s.type == 'header' ? "h3" : "a";
        var t_klass = "title";
        var count = s.count ? wrap_html(s.count, "div", "count") : "";
        // The gutter goes after the count / floats right.
        var gutter = s.gutter ? wrap_html(
        	create_icon_html(s.gutter.icon) + (s.gutter.text||''),
			s.gutter.tag || "a",
				"gutter " + (s.gutter.klass || ""),
			create_tip_data(s.gutter.tip, s.gutter.tip_class),
			s.gutter.href ? {href : s.gutter.href}:null
		):"";
        // The title may have a tooltip.
		var icon_title = wrap_html(icon + title, 'span',
			'icon_title ' + (s.icon_title_class || ''));

		// Create the data element.
		var t_data = create_tip_data(s.tip, s.tip_class) || {};
		for(var k in (s.data || {})) {
			t_data[k] = s.data[k]
		}

        var $title = icon.length || title.length ?
            $(wrap_html(icon_title + count, t_tag, t_klass, t_data)): "";
        var items = [];
        switch(s.type) {
			case 'list':
                var opener_cls = "opener fas fa-chevron-right";
                if(s.href) {
                	$title.attr("href", s.href);
                	if(s.href.search("#") == -1 || s.target) {
                        $title.attr("target", s.target || "_blank");
                    }
				}
                items.push($title);
                items.push(wrap_html("", "i", opener_cls));
                items.push(join_jquery(s.items.map(function (list_item) {
                    return $("<li></li>")
						.addClass((list_item && list_item.li_klass) || '')
						.append(create_one(list_item, depth + 1));
                }), s.start ? s.start : 'closed', 'ul'));
                break;
            case 'link':
                if(s.href && $title) {
                    $title.attr("href", s.href);
                    if(s.href.search("#") == -1 || s.target) {
                        $title.attr("target", s.target || "_blank");
                    }
                } else if(s.script && window[s.script] &&
                        allowed_functions.test(s.script)) {
                    // Allow scripts to be run.
                    $title.click(function () {
                        window[s.script].apply(s.arguments || []);
                    })
                } else if(s.script) {
                    console.error("Using banned script: " + s.script.toString());
                }
                items.push($title);
                break;
            case 'select':
            	items.push($title);
                items.push(join_jquery((s.options || []).map(function _opt(o) {
                    return "<option value='" + escape_html(o.value || o.k) +
                            "'>" + (o.label || o.v) + "</option>";
                }), "", "select"));
                break;
			case 'header':
				items.push($title);
				break;
			default:
				console.error("create_html_from_json Unknown type: " + s.type);
        }
        items.push(gutter);
        return join_jquery(items, s.type + " " + (s.klass ||""),
            "div");
    }
    return join_jquery(sidebar.map(function (s) {
        return create_one(s, 0);
    }), "top", "div");
}
var _default_json_html_tip_settings = {
	smartPlacement: false,
	placement : 'ne',
	popupClass : 'small_powertip',
}
function _add_collapse_expanders($object, toggle) {
		var ptip = {
		popupClass: 'motion_filter_tip small_powertip',
		smartPlacement: true,
	}
	$("<div></div>").addClass("expanders")
		.append($("<i></i>")
			.attr('title', 'Collapse All')
			.addClass("fad fa-chevrons-up").click(function () {
				toggle($object.find(".opener:visible"), false);
			})).powerTip(ptip)
		.append($("<i></i>")
			.attr('title', 'Expand All')
			.addClass("fad fa-chevrons-down").click(function () {
				toggle($object.find(".opener"), true);
			})).powerTip(ptip)
		// Insert directly into the JSON html Chooser. We may want to generalize this.
		.prependTo($object.find(".top > .list"));
}
/**
 * Setup load/hide toggles on object created from create_html_from_json.
 * @param $object The top level
 * @param get_track_category The google analytics category to use for tracking
 * clicks. Can be a string, or a function that returns a string. If null, no tracking.
 * @param tip_settings
 * @param add_expanders True to add expand all/collapse all.
 * @returns {(function(*): (boolean|undefined))|*} Return a function that can toggle on/off a given list.
 */
function json_html_expander($object, get_track_category, tip_settings, add_expanders) {
	if(!tip_settings) {
		tip_settings = _default_json_html_tip_settings;
	}
	// If a string, then convert to a function.
	var get_track =
		!get_track_category || typeof get_track_category == "string"?
			function _def_get_track() { return get_track_category; }:
			get_track_category;

	function toggle($this, force_val) {
		// We clicked on the opener or title. Find the title.
		var $parent = $this.parent();
		var $title = $parent.find("> .title");
		// Lists can have links too, make sure we're the target.
		var href = $this.attr("href");
		if(href && href.length && $this[0].tagName == "A") {
			// Bubble up to the higher level click handler.
			return true;
		}
		// Set the title to open.
		$title.toggleClass("open", force_val);
		// Set the
		$parent.find("> ul").toggleClass("closed",
			force_val === true ? false : force_val === false ? true : undefined);
		var $op = $title.find(".opener");
		$op.hasClass("fa-plus") || force_val == true?
			$op.removeClass("fa-plus").addClass("fa-minus"):
		$op.hasClass("fa-minus")  || force_val == false ?
				$op.removeClass("fa-minus").addClass("fa-plus"): '';
		var track_category = get_track();
		if(track_category) {
			analytics_track(track_category, "Toggle", $title.text());
		}
	}
	if(add_expanders) {
		_add_collapse_expanders($object, toggle)
	}

    $object.find(".list > .title, .list > .opener").click(function _opener_clicked() {
        return toggle($(this));
    }).end().find(".link > .title").click(function _title_clicked() {
    	var track_category = get_track();
        if(track_category) {
            analytics_track(track_category, "Click", $(this).text());
        }
        return true;
    }).end().find(".title[data-powertip]").powerTip(tip_settings).end();
	return toggle;
}

/*
* A very basic markdown renderer. Supports italic, bold, and lists.
 */
function create_html_from_markdown(t) {
	var re_bold = /\*\*([^\s*][^*]*[^\s*])\*\*(?=[^\w]|$)/ig;
    var re_italic = /\*([^\s*][^*]*[^\s*])\*(?=[^\w]|$)/ig;
	var re_headings = /(^|\r?\n)(#+)\s+([^\r\n]*)/ig;
	var re_list = /(^|\r?\n)([ \t]*)([\-*])\s+([^\r\n]*)/ig;

	t = t.replace(re_bold, "<b>$1</b>");
	t = t.replace(re_italic, "<i>$1</i>");
	t = t.replace(re_headings, function _rep_headings(m, p1, p2, p3) {
		var level = p2.length;
		return p1 + "<h" + level + ">" + p3 + "</h" + level + ">";
	});
	t = t.replace(re_list, function _rep_list(m, p1, spaces, dot, rest) {
		// Create the list dot style.
		var style = 'list-style-type:' + (dot=='*' ? "disc" : "square")+";";
		// Figure out the indentation and add the appropriate style.
		var num_indent = (spaces.length || 0) + 1;
		style += 'margin-left: ' + (num_indent * 20) + "px;";
		// Create the list item
		var li = wrap_html(rest,  "li", null, null, { style : style });
		// Create the ul element.
		return wrap_html(li, "ul");
	});
	t = t.replace(/\u000A|\n/ig, "<br>");
	return t;
}

//////////////////////////////////
// Javascript Events
function makeCustomEvent(event_identifier) {
	// Create the event.
	var event = document.createEvent('Event');
	// Make the event bubble-able and cancel-able.
	event.initEvent(event_identifier, true, true);
	// Return it
	return event;
}
function onEvent(event_identifier, listener) {
	document.addEventListener(event_identifier, listener, false);
}
function dispatchEvent(event) {
	return document.dispatchEvent(event);
}

/**
 * Open a URL in the browser. Accepts a true/false to open in a new tab,
 * simulating "CTRL" click functionality.
 * @param url		The URL you want to open.
 * @param ctrlKey	True to open in new tab.
 */
function open_url(url, ctrlKey) {
	if(ctrlKey) {
		// Support opening in new tab.
		var win = window.open(url, '_blank');
		// null check due to aggressive pop-up blockers
		if(win) win.focus();
	} else {
		// Open normally.
		window.location = url;
	}
}

// Debounce: If a function is called twice in a timeout, it executes only once.
function debouncer( func , timeout, retval ) {
   var timeoutID = null;
   return function () {
      var scope = this , args = arguments;
      if(timeoutID) {
      	clearTimeout( timeoutID );
	  }
      timeoutID = setTimeout( function () {
          func.apply( scope , Array.prototype.slice.call( args ) );
      }, timeout || 200);
	  if(retval != undefined) {
		  if (typeof retval == 'function') {
			  return retval.apply( scope , Array.prototype.slice.call(args));
		  }
		  return retval;
	  }
   }
}

// Regex
RegExp.escape= function(s) {
    return s ? s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : s;
};


// Tables
/**
 * Create an html table
 * array: an array of objects, representing the rows.
 * headings: a list of strings representing the headings.
 * func: Function that takes (object, object_row_index) as input. Returns a
 * list of cells.
 **/
function create_html_table(array, headings, func) {
	if(!func) {
		func = function (x, x_i) { return x; };
	}
	var headingclass = headings.map(function (th) {
		return th.toLowerCase().replace(/[^\w_\- ]+/ig, '')
			.strip()
			.replaceAll(" ", "_");
	});
	var table = "<table><tr>" + headings.map(function (th, th_i) {
		return wrap_html(th, "th", headingclass[th_i]);
	}).join("") + "</tr>";
	for(var i = 0; i < array.length; i++) {
		var td_vals = func(array[i], i);
		table += "<tr>" + td_vals.map(function (td, td_i) {
			var colspan = td_i == td_vals.length -1 && td_vals.length < headings.length ?
				' colspan="' + (headings.length - td_vals.length + 1) + '"':'';
			return "<td class='" + headingclass[td_i] + "'" + colspan + ">" + td + "</td>";
		}).join("") + "</tr>";
	}
	return table + "</table>";
}

// DOM Classes
function getClassList(el) {
	// The classList attribute is not always available on SVG elements.
	return (el.getAttribute("class") || '').split(/\s+/);
}
function addClass(el, cls) {
	cls = cls.strip();
	var has_class = getClassList(el).filter(function (c) { 
		return c.strip() == cls; 
	}).length > 0;
	if(has_class) {
		return;
	}
	var new_class = (el.getAttribute("class") || '') + ' ' + cls;
	return el.setAttribute("class", new_class);
}
function removeClass(el, cls) {
	cls = cls.strip();
	var classList = getClassList(el).filter(function (c) { 
		return c.strip() != cls; 
	});
	return el.setAttribute("class", classList.join(" "));
}
function toggleClass(el, cls, val) {
	cls = cls.strip();
	if(val === undefined) {
		val = getClassList(el).filter(function (c) { 
			return c.strip() == cls; 
		}).length == 0;
	}
	if (val){
		addClass(el, cls);
	} else {
		removeClass(el, cls);
	}
}

function getParentElement(el) {
	// Parent Element is not available on SVG elements.
	return el.parentElement ? el.parentElement : el.parentNode;
}

// Localstorage
// If the browser does not support real session storage, fake it with a global.
var _backup_localstorage = {};
function _get_store(persistTabs) {
	// Use the naive implementation that uses a global variable.
	if(typeof(Storage) === "undefined") {
		return _backup_localstorage;
	}
	if(persistTabs) {
		// Use local storage that works across tabs / windows, if it exists.
		try {
			return localStorage;
		} catch (e) {
			// We may not have localStorage in an iFrame.
			console.info("No localStorage, using sessionStorage");
		}
	}
	try {
		// Use session storage, that persists only in this tab / window.
		return sessionStorage;
	} catch (e) {
		console.warn("No Session Storage, using backup.");
	}
	return _backup_localstorage;
}
/**
 * Save a key, value pair for expire_seconds long. 
 *	key: 				A string.
 * 	val: 				May be an object as long as it can be stringified.
 * 	expire_seconds: 	If null, save it for the entire session duration. 
 *  persistTabs:		If True, data will be saved across tabs.
 */
function sessionSet(key, val, expire_seconds, persistTabs) {
	val = {
		expire : expire_seconds ? 
			(new Date()).getTime() + 1000*expire_seconds : null,
		val : val
	};
	var stringified = JSON.stringify(val);
	if (val && (!stringified || stringified.search('"val"') == -1)) {
		console.log("Could not save '" + key + "' in local cache.");
		return false;
	}
		
	// Save the value.
	try {
		_get_store(persistTabs)[key] = stringified;
	} catch (err) {
		console.warn("Cannot save session data: " + err);
		return false;
	}
	return true;
}
function sessionGet(key, persistTabs) {
	var val = _get_store(persistTabs)[key];
	if (!val) {
		return null;
	}
	try {
		val = JSON.parse(val);
		if(val.expire === undefined) {
			return null;
		}
		if (val.expire && (new Date()).getTime() > val.expire) {
			// Expired.
			return null;
		}
		return val.val;
	} catch(err) {
		console.log("Could not load " + key + ": " + err);
		return null;
	}
}
function sessionClear(key, persistTabs) {
	if(typeof(Storage) === "undefined") {
		if(key) {
			if(_backup_localstorage[key]) {
				delete _backup_localstorage[key];
			}
		} else {
			_backup_localstorage = {};
		}
	} else {
		if(key) {
			sessionSet(key, null, 1, persistTabs);
		} else {
			if(localStorage && (persistTabs || persistTabs === undefined)) {
				localStorage.clear();
			}
			if(sessionStorage &&
					(persistTabs === false || persistTabs === undefined)) {
				sessionStorage.clear();
			}
		}
	}
}

// Live loading
function load_css(link) {
    // Load fontawesome, used by custom analytics.
    $('<link>')
		.appendTo('head')
		.attr({
			type: 'text/css',
			rel: 'stylesheet',
			crossorigin: "anonymous",
			href: link
	});
}

var has_drawing_js = false;
var _getting_drawing = false;
/**
 * A big complex function for loading a few js files. This should be
 * re-implemented using promises.
 * @param done
 * @param failed
 */
function load_drawing_js(done, failed) {
	if(has_drawing_js) {
		if(done) {
			setTimeout(done, 0);
		}
		return;
	}
	if(_getting_drawing) {
		function wait_complete() {
			if(_getting_drawing) {
				setTimeout(wait_complete, 100);
				return;
			}
			if(has_drawing_js && done) {
				done();
			} else if(!has_drawing_js && fail) {
				fail(this);
			}
		}
		setTimeout(wait_complete, 100);
		return;
	}

	_getting_drawing = true;
	var files_to_get = [
		"/site_media/d3.v3.min.js",
		"/site_media/d3.layout.min.js",
		"/site_media/rickshaw.js",
		"/site_media/sankey.js", // This is only needed for sankey charts.
		"/site_media/colorbrewer.js",
		"/site_media/drawing.js"];
	function get_script(file_index) {
		var file = files_to_get[file_index];
		$.getScript(file, function _get_script_success() {
			if(file_index >= files_to_get.length - 1) {
				// Got all scripts.
				has_drawing_js = true;
				_getting_drawing = false;
				if(done) {
					done();
				}
			} else {
				// Get the next script, only after finishing this one.
				get_script(file_index+1);
			}
		}).fail(function ( jqxhr, settings, exception ) {
			_getting_drawing = false;
			if(failed) {
				failed(this);
			}
		});
	}
	// Get the scripts through a semi-recursive function.
	get_script(0);
}

/////////////////////
// Inputs and Textarea
// Set's the cursor in an input or textarea.
$.fn.selectRange = function(start, end) {
    if(end === undefined) {
        end = start;
    }
    return this.each(function() {
        if('selectionStart' in this) {
            this.selectionStart = start;
            this.selectionEnd = end;
        } else if(this.setSelectionRange) {
            this.setSelectionRange(start, end);
        } else if(this.createTextRange) {
            var range = this.createTextRange();
            range.collapse(true);
            range.moveEnd('character', end);
            range.moveStart('character', start);
            range.select();
        }
    });
};

// Windowing
function get_window_height() {
	// Returns browser window height
	return (typeof window.innerHeight != 'undefined' ? window.innerHeight : document.body.offsetHeight);
}

function getScrollbarWidth(doc) {
	// Return the width of a scrollbar.
	if(!doc) {
		doc = document.body;
	}
	var cached_width = doc.getAttribute('data-ScrollBarWidth');
	if (cached_width) {
		return cached_width;
	}
	var outer = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.width = "100px";
	outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

	doc.appendChild(outer);

	var widthNoScroll = outer.offsetWidth;
	// force scrollbars
	outer.style.overflow = "scroll";

	// add innerdiv
	var inner = document.createElement("div");
	inner.style.width = "100%";
	outer.appendChild(inner);        

	var widthWithScroll = inner.offsetWidth;

	// remove divs
	outer.parentNode.removeChild(outer);
	cached_width = widthNoScroll - widthWithScroll
	doc.setAttribute('data-ScrollBarWidth', cached_width)
	return cached_width;
}

/////////////////////
// User Messages and Alerts.
function init_powertip_defaults() {
	$.fn.powerTip.defaults.fadeInTime = 100;
	$.fn.powerTip.defaults.fadeOutTime = 50;
	$.fn.powerTip.defaults.closeDelay = 50;
}

var current_loader_show_type = null;
function show_success_usermsg(in_html, show_type) {
	analytics_track("user_msg", "info", show_type || in_html);
	show_confirm_usermsg({
		title : 'Success',
		subtitle : in_html,
		hide_cancel : true,
		dialog_class : 'membership_success'
	});
}

/**
 * Show the user an error message.
 * @param in_html	The HTML you want to display to the user.
 * @param show_type	A unique ID distinguishing this error message from others.
 * @param $target	(Optional) If you want to display the error near a
 * 					button or other HTML element, you can specify it here.
 * 					Otherwise it will display at the top of the page.
 */
function show_error_usermsg(in_html, show_type, $target) {
	show_usermsg(in_html, $target || null, "error");
	current_loader_show_type = show_type;
}

/**
 * Show a message to the user that dissappears after a set time period.
 * @param text		The HTML you want to display.
 * @param $target	(Optional) If you want to display the error near a
 * 					button or other HTML element, you can specify it here.
 * 					Otherwise it will display at the top of the page.
 * @param level		Can be: "error", "warning", "info". (default: "info")
 * @param timeout	(Optional) How long to display (defaults 5 to 8 Secs).
 * @returns {jQuery|HTMLElement}
 */
function show_usermsg(text, $target, level, timeout) {
	analytics_track("user_msg", level || "info", text);
	level = level ? level.toLowerCase() : 'info';
	var body_tip = false;
	if($target && $target.parents("#powerTip").length) {
		// The target is within a powerTip, we need to show a body tip.
		$target = null;
	}
	if(!$target) {
		$target = $("body");
		body_tip = true;
	}
	// A unique identifier for this instance.
	var tip_id = Math.random().toString();
	// Wrap the tip if we doing an body tip for alignment.
	var tip_html = body_tip ? 
		"<a class='close' href='#'>Close <i class='fas fa-xmark-large'></i></a>" +
		"<div class='usermsg_parent'>" + text + "</div>" : text;
	var all_classes = 'usermsg_tip ';
	if(level) {
		all_classes += level + ' ';
	}
	if(body_tip) {
		all_classes += "noarrows bodytip ";
	}
	// Timeout defaults.
	if(!timeout) {
		// Timeout defaults depend on the level.
		timeout = level == 'error' ? 8000:
			level == 'warning' ? 5000:
			level == 'info' ? 5000:
			5000;
	}
	
	// Set the tip data and id.
	$target.data('tip_id', tip_id).data('powertip', tip_html);
	
	if(body_tip && $("#powerTip.bodytip").is(":visible")) {
		// If a tip is already open, just change it.
		$("#powerTip").html(tip_html);
	} else {
		// Hide the existing tooltip. WARNING: if there is a fadeOutTime,
		// it won't hide immediately, and the tooltips won't hide.
		$.powerTip.hide(null, true);

		// Create a new tip.
		$target.powerTip({
			popupClass : all_classes,
			manual: true, // Manually close it.
			fadeOutTime: 500,
			smartPlacement: !body_tip,
			placement : body_tip ? 'n' : undefined,
			mouseOnToPopup : true
		});
		$.powerTip.show($target);
		$.powerTip.reposition($target);
	}
	// $.powerTip.reposition($target);
	var timer = setTimeout(function () {
		var $usertip = $("#powerTip.usermsg_tip");
		if($usertip.is(":visible") && $target.data('tip_id') == tip_id) {
			$usertip.hide('slow');
			$.powerTip.hide($target);
		}
	}, timeout);
	if(body_tip) {
		var left_right = $target.width() > 1080 ? 
			($target.width() - 1080) / 2 : 5;
		$("#powerTip").css({
			'top':"5px",
			'left':left_right,
			'right':left_right,
		}).find("a.close").click(function () {
			$.powerTip.destroy($target);
			$("#powerTip.usermsg_tip").hide('slow');
			clearTimeout(timer);
			return false;
		});
	}
	// Manually close the tip after a second.
	return $target;
}

/**
 * Easily show a user a yes/no modal dialog box. But you can customize to
 * show any type of modal form.
 * @param options	A dictionary with the following format: {
 *     title: 		The title you want to display on the dialog.
 *     subtitle: 	The subtitle you want to display on the dialog.
 *     okay: 		A function that is called when the user hits "okay"
 *     cancel:		A function that is called when the user hits "cancel"
 *     okay_msg:	The text of the okay button (default: "Okay")
 *     cancel_msg:	The text of teh cancel button (default: "Cancel").
 *     form:		A list that you can use to add further options to
 *     				the yes/no dialog. Each element in the list is a
 * 					dictionary representing a form element. It has the form: {
 * 					    type:     Can be: select, checkbox, password, or text.
 * 					    name:     The html name attribute of the form element.
 * 					    label:    (Optional) A label to show near the form
 * 					    		  element, or for text types, as placeholder.
 * 					   	powertip: Any powertip text you want to display when
 * 					   			  the user hovers over the form element.
 * 					   	checked:  true/false for checkbox types.
 * 					   	select:   A list of {value:'',label:''} objects to
 * 					   			   show as options for select types.
 * 					}
 *     dialog_options: This function calls another more general function
 *     				   borderless_dialog. You can pass an object in here
 *     				   that will have further control over the dialog.
 * }
 * @returns {*}
 */
function show_confirm_usermsg(options) {
	if(options === undefined || options === null) {
		options = {};
	}
	var title = options.title || "";
	var subtitle = options.subtitle || "";
	var okay = options.okay || function () { };
	var cancel = options.cancel || function () { };
	var okay_msg = options.okay_msg || "Okay";
	var cancel_msg = options.cancel_msg || "Cancel";
	var hide_okay = options.hide_okay ? true : false;
	var hide_cancel = options.hide_cancel ? true : false;
	var dialog_class = options.dialog_class;
	var dialog_options = options.dialog_options || {};
	var form = options.form || [];
	var $warning_msg = $("<div id='warning_msg'>" +
		"<div class='title'></div>" +
		"<div class='warning'></div>" +
		"<form class='form'></form>" +
		"<a href='#' class='okay'>Okay</a>" +
		"<a href='#' class='cancel'>Cancel</a></div>");

	function _one_widget(f) {
		var ftype = f.type ? f.type :
			f.name.search(/password/ig) == -1 ? 'text' : 'password';
		var form_html = "<div class='show_confirm_usermsg_form " + ftype + "'" +
			(f.powertip ? " data-powertip='" + escape_html(f.powertip) + "'": "") + ">";
		var name = escape_html(f.name);
		if(ftype == "select") {
			if(f.label) {
				// Give the label a class so we can style it.
				form_html += "<label class='" + name + "'>" + f.label + "</label>";
			}
			form_html += "<select name='" + name + "'>" +
			f.select.map(function (s) {
				return "<option value='" + s.value + "'" +
					(s.disabled ? " disabled" : "") +
					(s.selected ? " selected":"") + ">" + s.label + "</option>";
			}).join("") + "</select>";
		} else if(ftype == 'checkbox') {
			var uid = uniqueid();
			form_html += "<input type='checkbox' id='" + uid + "' " +
				(f.checked ? "checked ": "") +
				"name='" + name + "'>";
			if(f.label) {
				form_html += "<label for='" + uid + "'>" + f.label + "</label>";
			}
		} else if(ftype == 'textarea') {
			form_html += '<textarea placeholder="' + f.label +
				'" name="' + name + '" readonly class="medium_input"></textarea>';
		} else if(ftype == 'link') {
			// Build the href value.
			var href = f.href ? 'href="' + f.href + '" ' : '';
			form_html += '<a ' + href + ' class="' + escape_html(f.klass) + '">' + f.a + "</a>"
		} else {
			form_html += '<input type="' + ftype + '" placeholder="' + f.label +
				'" name="' + name + '" readonly class="medium_input">';
		}
		form_html += "</div>";
		return form_html;
    }

	// We need a hidden submit button so "enter" works.
	var form_html = '<input type=submit style="display:none;">' +
		// Add all the widgets.
		form.map(_one_widget).join("");

	if(dialog_class){
		if(!dialog_options.classes){
			dialog_options.classes = {};
		}
		dialog_options.classes["ui-dialog"] = dialog_class;
	}
	var $dialog = borderless_dialog($warning_msg, dialog_options);
	$dialog.dialog("open");
	
	function do_close($diag, func) {
		try {
			if(!$dialog.dialog("isOpen"))
				return;
		} catch(e) {
			// This is an old handler for a previous dialog.
			return;
		}
		if(func) {
			var $form = $dialog.find("form");
			var vals = $form.serializeArray();
			var vals_d = {};
			for(var v_i=0; v_i<vals.length; v_i++) {
				vals_d[vals[v_i].name] = vals[v_i].value;
			}
			if(func($form, vals_d) !== false) {
				$dialog.dialog("destroy").remove();
			}
		}
		return false;
	}
	
	$dialog
		.find(".title").text(title).end()
		.find(".warning").html(subtitle).end()
		.find(".form").html(form_html).unbind("submit").submit(function () {
			return do_close($dialog, okay);
		}).find("input").focus(function () {
				$(this).removeAttr("readonly");
			}).end().end()
		.find(".okay").text(okay_msg).click(function() {
            return do_close($dialog, okay);
        }).toggle(!hide_okay).end()
		.find(".cancel").text(cancel_msg).click(function() {
            return do_close($dialog, cancel);
        }).toggle(!hide_cancel).end()
		.find("[data-powertip]").powerTip();

	// Hack: Add additional function which allows for adding widgets to the form.
	$dialog.add_widget = function add_widget(f) {
		$dialog.find(".form").append(_one_widget(f));
	}
	return $dialog;
}

/**
 * Get a URL to a gravatar image of a person.
 * @param email  The person's email.
 * @param size   The size of the image that you want.
 * @returns {string}
 */
function get_gravatar(email, size) {
    // MD5 (Message-Digest Algorithm) by WebToolkit
	if(!email) {
		throw "No Gravatar email provided";
	}
    if(!size) {
    	size = 80;
	}
    var MD5=function(s){function L(k,d){return(k<<d)|(k>>>(32-d))}function K(G,k){var I,d,F,H,x;F=(G&2147483648);H=(k&2147483648);I=(G&1073741824);d=(k&1073741824);x=(G&1073741823)+(k&1073741823);if(I&d){return(x^2147483648^F^H)}if(I|d){if(x&1073741824){return(x^3221225472^F^H)}else{return(x^1073741824^F^H)}}else{return(x^F^H)}}function r(d,F,k){return(d&F)|((~d)&k)}function q(d,F,k){return(d&k)|(F&(~k))}function p(d,F,k){return(d^F^k)}function n(d,F,k){return(F^(d|(~k)))}function u(G,F,aa,Z,k,H,I){G=K(G,K(K(r(F,aa,Z),k),I));return K(L(G,H),F)}function f(G,F,aa,Z,k,H,I){G=K(G,K(K(q(F,aa,Z),k),I));return K(L(G,H),F)}function D(G,F,aa,Z,k,H,I){G=K(G,K(K(p(F,aa,Z),k),I));return K(L(G,H),F)}function t(G,F,aa,Z,k,H,I){G=K(G,K(K(n(F,aa,Z),k),I));return K(L(G,H),F)}function e(G){var Z;var F=G.length;var x=F+8;var k=(x-(x%64))/64;var I=(k+1)*16;var aa=Array(I-1);var d=0;var H=0;while(H<F){Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=(aa[Z]|(G.charCodeAt(H)<<d));H++}Z=(H-(H%4))/4;d=(H%4)*8;aa[Z]=aa[Z]|(128<<d);aa[I-2]=F<<3;aa[I-1]=F>>>29;return aa}function B(x){var k="",F="",G,d;for(d=0;d<=3;d++){G=(x>>>(d*8))&255;F="0"+G.toString(16);k=k+F.substr(F.length-2,2)}return k}function J(k){k=k.replace(/rn/g,"n");var d="";for(var F=0;F<k.length;F++){var x=k.charCodeAt(F);if(x<128){d+=String.fromCharCode(x)}else{if((x>127)&&(x<2048)){d+=String.fromCharCode((x>>6)|192);d+=String.fromCharCode((x&63)|128)}else{d+=String.fromCharCode((x>>12)|224);d+=String.fromCharCode(((x>>6)&63)|128);d+=String.fromCharCode((x&63)|128)}}}return d}var C=Array();var P,h,E,v,g,Y,X,W,V;var S=7,Q=12,N=17,M=22;var A=5,z=9,y=14,w=20;var o=4,m=11,l=16,j=23;var U=6,T=10,R=15,O=21;s=J(s);C=e(s);Y=1732584193;X=4023233417;W=2562383102;V=271733878;for(P=0;P<C.length;P+=16){h=Y;E=X;v=W;g=V;Y=u(Y,X,W,V,C[P+0],S,3614090360);V=u(V,Y,X,W,C[P+1],Q,3905402710);W=u(W,V,Y,X,C[P+2],N,606105819);X=u(X,W,V,Y,C[P+3],M,3250441966);Y=u(Y,X,W,V,C[P+4],S,4118548399);V=u(V,Y,X,W,C[P+5],Q,1200080426);W=u(W,V,Y,X,C[P+6],N,2821735955);X=u(X,W,V,Y,C[P+7],M,4249261313);Y=u(Y,X,W,V,C[P+8],S,1770035416);V=u(V,Y,X,W,C[P+9],Q,2336552879);W=u(W,V,Y,X,C[P+10],N,4294925233);X=u(X,W,V,Y,C[P+11],M,2304563134);Y=u(Y,X,W,V,C[P+12],S,1804603682);V=u(V,Y,X,W,C[P+13],Q,4254626195);W=u(W,V,Y,X,C[P+14],N,2792965006);X=u(X,W,V,Y,C[P+15],M,1236535329);Y=f(Y,X,W,V,C[P+1],A,4129170786);V=f(V,Y,X,W,C[P+6],z,3225465664);W=f(W,V,Y,X,C[P+11],y,643717713);X=f(X,W,V,Y,C[P+0],w,3921069994);Y=f(Y,X,W,V,C[P+5],A,3593408605);V=f(V,Y,X,W,C[P+10],z,38016083);W=f(W,V,Y,X,C[P+15],y,3634488961);X=f(X,W,V,Y,C[P+4],w,3889429448);Y=f(Y,X,W,V,C[P+9],A,568446438);V=f(V,Y,X,W,C[P+14],z,3275163606);W=f(W,V,Y,X,C[P+3],y,4107603335);X=f(X,W,V,Y,C[P+8],w,1163531501);Y=f(Y,X,W,V,C[P+13],A,2850285829);V=f(V,Y,X,W,C[P+2],z,4243563512);W=f(W,V,Y,X,C[P+7],y,1735328473);X=f(X,W,V,Y,C[P+12],w,2368359562);Y=D(Y,X,W,V,C[P+5],o,4294588738);V=D(V,Y,X,W,C[P+8],m,2272392833);W=D(W,V,Y,X,C[P+11],l,1839030562);X=D(X,W,V,Y,C[P+14],j,4259657740);Y=D(Y,X,W,V,C[P+1],o,2763975236);V=D(V,Y,X,W,C[P+4],m,1272893353);W=D(W,V,Y,X,C[P+7],l,4139469664);X=D(X,W,V,Y,C[P+10],j,3200236656);Y=D(Y,X,W,V,C[P+13],o,681279174);V=D(V,Y,X,W,C[P+0],m,3936430074);W=D(W,V,Y,X,C[P+3],l,3572445317);X=D(X,W,V,Y,C[P+6],j,76029189);Y=D(Y,X,W,V,C[P+9],o,3654602809);V=D(V,Y,X,W,C[P+12],m,3873151461);W=D(W,V,Y,X,C[P+15],l,530742520);X=D(X,W,V,Y,C[P+2],j,3299628645);Y=t(Y,X,W,V,C[P+0],U,4096336452);V=t(V,Y,X,W,C[P+7],T,1126891415);W=t(W,V,Y,X,C[P+14],R,2878612391);X=t(X,W,V,Y,C[P+5],O,4237533241);Y=t(Y,X,W,V,C[P+12],U,1700485571);V=t(V,Y,X,W,C[P+3],T,2399980690);W=t(W,V,Y,X,C[P+10],R,4293915773);X=t(X,W,V,Y,C[P+1],O,2240044497);Y=t(Y,X,W,V,C[P+8],U,1873313359);V=t(V,Y,X,W,C[P+15],T,4264355552);W=t(W,V,Y,X,C[P+6],R,2734768916);X=t(X,W,V,Y,C[P+13],O,1309151649);Y=t(Y,X,W,V,C[P+4],U,4149444226);V=t(V,Y,X,W,C[P+11],T,3174756917);W=t(W,V,Y,X,C[P+2],R,718787259);X=t(X,W,V,Y,C[P+9],O,3951481745);Y=K(Y,h);X=K(X,E);W=K(W,v);V=K(V,g)}var i=B(Y)+B(X)+B(W)+B(V);return i.toLowerCase()};
    return 'https://www.gravatar.com/avatar/' + MD5(email) + '.jpg?s=' + size +
		"&default=identicon";
}

///////////////////////
// Improve the addClass method so it triggers a custom event.
(function _add_addClass_method(){
    // Your base, I'm in it!
    var originalAddClassMethod = jQuery.fn.addClass;
    var originalRemoveClassMethod = jQuery.fn.removeClass;

    jQuery.fn.addClass = function(){
        // Execute the original method.
        var result = originalAddClassMethod.apply(this, arguments);
        // trigger a custom event
        jQuery(this).trigger('cssClassChanged');
        // return the original result
        return result;
    };
    jQuery.fn.removeClass = function(){
        // Execute the original method.
        var result = originalRemoveClassMethod.apply(this, arguments);
        // trigger a custom event
        jQuery(this).trigger('cssClassChanged');
        // return the original result
        return result;
    };
})();

///////////////////////////////////////////////////////////////////////////////
// Send Support or Marketing Inquiry

function setup_marketing_inquiry_form($form, redirect_url, required) {
	if(!required) {
		required = ['name', 'email'];
	}
	$form.ajaxForm({
		beforeSubmit:  	function (data, $form, options) {
			for(var i = 0; i < required.length; i++) {
				var r = data.filter(function (d) { 
					return d.name == required[i] && d.value && d.value.length; 
				});
				if(!r.length) {
					if(required[i] == 'email' && user_logged_in) {
						data.push({
							name: 'email',
							value: user_logged_in
						});
					} else if(required[i] == 'name' && user_logged_in) {
						var nm = ((user_first_name || '') + " " +
							(user_last_name || '')).strip();
						data.push({
							name: 'name',
							value: nm
						});
					} else {
						show_error_usermsg("Please enter your " + required[i] +
							" to continue.", "email_support");
						return false;
					}
				}
			}
			// Create an HTML version of the message.
			var html_message = data.map(function (o) {
				return capitalize(o.name) + ": " + o.value;
			}).join("<br>\n");
			data.push({
				name : 'message_html',
				value : html_message,
			});
			// Add a simple length. Serves to prevent bots from submitting the
			// form w/o at least looking at the js. For spammers that see this,
			// note that this messsage just goes to an internal folder. We won't
			// pass it on to the recepient in the email.
			data.push({
				name : 'message_html_len',
				value : html_message.length,
			});
			
			$form
				.find(".loader").show().end()
				.find("input[type=submit]").addClass("disabled");
		},  
		success: function(data, statusText, xhr, $form) {
			var $btn = $form.find(".loader").hide().end()
				.find("input[type=submit]").removeClass("disabled");
			// Give the user a message
			if(data.success) {
				if(redirect_url && typeof redirect_url == "function") {
					redirect_url(data, $form);
				} else if(redirect_url) {
					window.location = redirect_url;
				} else {
					$form.html("<h3 class='done_submit'>Thank you.<br> We'll " +
						"get back to you shortly.</h3>");
				}
			} else {
				show_error_usermsg(data.error, "email_support", $btn);
			}
		},  
		type:     	'post', // Can override method attribute
		dataType:   'json'  // 'xml', 'script', or 'json' (expected server response type)  
	})
	.find("input").each(function () {
		// The validation engine requires everything to have an id.
		var $this = $(this);
		if(!$this.attr('id')) {
			!$this.attr('id', "more_info_email_" + $this.attr('name'))
		}
	}).end()
	.validationEngine({
		onValidationComplete:function(form, valid) {
			if(valid)
				return true;
			setTimeout(function () {
				form.validationEngine('hideAll');
			}, 3000);
			return false;
		}
	});
}

/**
 * Setup a jquery object so when a user clicks on it, it copies something to
 * the clipboard. Does not work on Safari mobile, but degrades nicely.
 * @param target_selector	The selector or jquery object for the items that
 * 							you want to be copyable.
 * @param get_text			A function that takes the jquery object
 * 							as input and return the text you want copied.
 * @param copied_message	A message to display when copy completes
 * 							(default: Copied!).
 */
function copy_to_clipboard(target_selector, get_text, copied_message) {
	var $targets = $(target_selector);
	function show_tip($targ, text) {
		// Show a tooltip that we've completed the copy.
		$targ.data('powertip', text).powerTip({
			manual: true, // We'll manually close it.
			fadeOutTime: 500,
			smartPlacement: true,
		});
		$.powerTip.show($targ);
		// Manually close the tip after a second.
		setTimeout(function (){ 
			$.powerTip.hide($targ);
			// Remove the data so they don't see it when they hover again.
			$targ.data('powertip', '');
		}, 1500);
	}
	$targets.click(function () {
		var $targ = $(this);
		var text = get_text($targ);
		copy_to_clipboard_inner(text, function () {
			show_tip($targ,copied_message ||  "Copied!");
		}, function () {
			show_tip($targ,"Press CTRL+C to Finish Copying")
		});
		return false;
	});
}

/**
 * Browser compatible way to copy text to clipboard.
 * 		See https://stackoverflow.com/a/30810322/234270
 * @param text The text you want to copy.
 * @param success Success callback function.
 * @param error Error callback function.
 */
function copy_to_clipboard_inner(text, success, error) {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(text).then(function () {
			success();
		}, function (err) {
			error(err);
		});
	} else {
		// Fallback method.
		var textArea = document.createElement("textarea");
		textArea.value = text;

		// Avoid scrolling to bottom
		textArea.style.top = "0";
		textArea.style.left = "0";
		textArea.style.position = "fixed";

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			var successful = document.execCommand('copy');
			successful ? success() : error("Did not copy.");
		} catch (err) {
			error(err);
		}
		document.body.removeChild(textArea);
	}
}


/**
 * Find the first parent with the given tag name
 */
function get_parent_with_tag(child, tag) {
	if(!child || child.length == 0)
		return null;
	tag = tag.toLowerCase();
	var parent = child.parent();
	while(parent.length == 1 && parent[0].nodeName.toLowerCase() != tag)
		parent = parent.parent();
	return parent ? parent : null;
}
function get_parent_with_class(child, cls) {
	if(!child || child.length == 0)
		return null;
	var parent = child.parent();
	while(parent.length == 1 && !$(parent[0]).hasClass(cls))
		parent = parent.parent();
	return parent ? parent : null;
}

///////////////////////////////////////////////////////////////////////////////
// Custom Jqueery UI Changes
function show_modal(item, title, in_width, in_height, dialogClass) {
	var data = {
		modal : true,
		resizable : false,
		/*show : 'fade', Show things faster w/o an effect*/
		width : in_width,
		height : in_height,
		draggable : false
	};
	if(title) {
		data.title = title;
	}
	if(dialogClass) {
		data.dialogClass = dialogClass;
	}
	$(item).dialog(data);
	// Prevent any input fields from getting focus. Jqueryui gives them 
	// focus for some reason messing up placesholders.
	$(item).find('input, textarea, select').blur();
}

function modal_progress_start(id, title, cancel) {
	if(!id) id = 'modal_progress';
	// Create the modal dialog immediately for the file list progress bar.
	var $exist = $("body #" + id + ".download_progress_overlay");
	if($exist.length){
		$exist
			.find(".title").text(title).end()
			.find(".status").text("").end()
			.find(".perc").text("").end()
			.find(".error").text("").end();
	} else {
		$("body").append("<div id='" + id + "' class='download_progress_overlay'>" +
			"<div class='title'>" + title + "</div><div class='perc'></div>" +
			"<div class='status'></div><div class='substatus'></div>" +
			"<div class='progress'><div class='bar'></div></div>" +
			"<div class='error'></div>" +
			"<a href='#' class='cancel'>Cancel</a></div>");
	}
	var $dialog = borderless_dialog("#" + id).dialog("open")
		.find(".cancel").removeClass("done").off("click").end();
	if(!cancel) {
		cancel = function () {
			$dialog.dialog('close');
			return false;
		};
	}
	return $dialog.find(".cancel, .done").click(cancel).end();
}

/**
 * Update the progress bar
 * @param id The progress bar id used in start.
 * @param perc The current progress percent (0.0 to 100.0)
 * @param stat A status message
 * @param substatus A sub status message.
 */
function modal_progress_set(id, perc, stat, substatus) {
	if(!id) id = 'modal_progress';
	var $dialog = $("#" + id);
	if(stat != null)
		$dialog.find(".status").text(stat).end();
	if(substatus != null)
		$dialog.find(".substatus").text(substatus).end();
	if(perc != null) {
		$dialog
			.find(".perc").text(perc.toFixed(0) + "%").end()
			.find(".progress .bar").width(perc.toFixed(3) + "%").end();
	}
}

/**
 * Add an error message to the error list in the modal.
 * @param id
 * @param error
 */
function modal_progress_error(id, error) {
	if(!id) id = 'modal_progress';
	var $dialog = $("#" + id);
	var $error = $("<div></div>").html(DOMPurify.sanitize(error));
	$dialog.find(".error").append($error);
}

/**
 * Close a modal progress bar window.
 * @param id
 */
function modal_progress_close(id) {
	if(!id) id = 'modal_progress';
	$("#" + id).dialog('close');
}

// A rich select menu allows us to generate nicer looking drop down menus.
$.widget( "custom.richselectmenu", $.ui.selectmenu, {
  _renderItem: function( ul, item ) {
	var li = $( "<li>" );
	var wrapper = $( "<div>", { text: item.label } );

	if ( item.disabled ) {
	  li.addClass( "ui-state-disabled" );
	}

	var el = item.element;
	if(el.attr("data-description").length) {
		$( "<span>", {
		  "class": "description"
		}).text(el.attr( "data-description" )).appendTo( wrapper );
	}
	if(el.attr("data-fas") && el.attr("data-fas").length){
		$("<i>", {"class": "fas " + el.attr("data-fas")}).prependTo( wrapper );
		wrapper.addClass("has_fas");
	}
	return li.append( wrapper ).appendTo( ul );
  }
});

// The standard jqueryio progress bar only increments in integers e.g., 1%, 2%,
// etc. This can look choppy on progress bars with more than 100px wide. Below,
// modify jqueryui widget to support fractional percents, eg. 1.123%, 8.821%.
$.widget("ui.progressbar", $.ui.progressbar, {
    _refreshValue: function() {
    	// Call the parent class.
        this._super();
        // Get the current percentage.
        var percentage = this._percentage();
		if(percentage > 0.0 && percentage < 100.0) {
			// Use up to 3 decimal places for the percent.
			this.valueDiv.width( percentage.toFixed( 3 ) + "%" );
		}
    }
});

/**
 * Download a given set of text as a file.
 * @param filename The filename that you want to download.
 * @param text The contents of the file.
 * @param mimetype (Optional) The mime type of the file.
 */
function download_file(filename, text, mimetype) {
	if(!mimetype) {
		mimetype = 'text/plain;charset=utf-8';
	}
	// Create the element.
	var element = document.createElement('a');
	element.setAttribute('href', 'data:' + mimetype + ',' + 
		encodeURIComponent(text));
	element.setAttribute('download', filename);
	element.style.display = 'none';
	// Insert and click on the elemnt to download it.
	document.body.appendChild(element);
	element.click();
	// Remove the element.
	document.body.removeChild(element);
}

/**
 * Sanitize filenames
 * npmjs.com/package/sanitize-filename
 **/
var illegalRe = /[\/?<>\\:*|"]/g;
var controlRe = /[\x00-\x1f\x80-\x9f]/g;
var reservedRe = /^\.+$/;
var windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
function safe_filename(input, replacement, max_len) {
	if(!input) {
		throw "No file name given.";
	}
	if(!max_len) {
		// Maximum length of file on windows.
		max_len = 250;
	}
	if(!replacement) {
		replacement = '_';
	}
	var out = input
		.replace(illegalRe, replacement)
		.replace(controlRe, replacement)
		.replace(reservedRe, replacement)
		.replace(windowsReservedRe, replacement)
		// Remove extra spaces.
		.replace(/\s+/g, " ");
	if(out.length > max_len) {
		// Cut it up by periods, try to find the extension.
		var split = out.split(".");
		// Assume the extension is last.
		var ext = split[split.length - 1];
		// Put all but the extension together
		out = split.slice(0, -1).join(".")
			// Cut the first part down so it fits into max_len
			.slice(0, max_len - 2 - ext.length)
			// Add the period and the extension itself.
			+ "." + ext;
	}
	return out;
}

/**
 * Run a number of functions in parallel.
 * @param fns An array of functions that take a single argument, "done" that
 * should be called when they are done.
 * @param max_parallel The maximum number of functions to run at once.
 * @param done A function that takes no arguments and will be called when
 * all of the functions have finished processing.
 * @returns {_cancel} A function that can be called to stop processing.
 */
function map_parallel(fns, max_parallel, done) {
	var is_canceled = false;
	var started_i = -1, num_running = 0;
	function do_idx(i) {
		if(is_canceled) {
			return;
		}
		// Sanity check.
		if(i >= fns.length) {
			console.log("Moving past end of array.");
			return;
		}
		// Run the function.
		num_running += 1;
		fns[i](function _done() {
			// Free the worker when we're done.
			num_running -= 1;
			if(started_i < fns.length - 1) {
				// Start the next item for this worker.
				started_i += 1;
				do_idx(started_i);
			} else if(!is_canceled && num_running <= 0) {
				// We're totally done, mark it as such.
				done();
			}
		});
	}

	// Start up to max_parallel workers.
	for(var i = 0; i < Math.min(max_parallel, fns.length); i ++) {
		started_i += 1;
		if(started_i >= fns.length) {
        	// Can occur if the functions are synchronous.
			break;
        }
		do_idx(started_i);
	}
	// Return a cancel function for it to stop.
	return function _cancel() {
		is_canceled = true;
	}
}

function create_download_dialog() {
	var previous_dialog = document.getElementById("download_files_overlay");
	if(previous_dialog){
		console.warn("Found an existing dialog for batch download. " +
			"Closing it in order to avoid duplicates.");
		borderless_dialog(previous_dialog).dialog("close").remove();
		previous_dialog.remove();
	}
	$("body").append("<div id='download_files_overlay'>" +
		"<div class='title'>Batch Download</div><div class='perc'></div>" +
		"<div class='status'></div><div class='substatus'></div>" +
		"<div class='progress'><div class='bar'></div></div>" +
		"<div class='error'></div>" +
		"<a href='#' class='cancel'>Cancel</a></div>");
	var $dialog = borderless_dialog("#download_files_overlay");
	$dialog.dialog("open");
	return $dialog;
}

/**
 * A helper function for the bulk downloader. Returns a "file" object that can
 * be used in the bulk downloader to summarize a document.
 * @param $dialog
 * @param file_info The original file information that would normally be passed into download_File.
 * @param ai_options
 * @returns {{filename, function: function, group_key: string, group: group}}
 */
function download_to_ai_task($dialog, file_info, ai_options) {
	// Give it a different name to prevent naming conflicts..
	var renamed = file_info.filename.substring(0, file_info.filename.lastIndexOf(".") + 1) + " - Summarized";

	/**
	 * Pretty print failure messages.
	 * @param items
	 * @returns {{line: null, failures: Array}}
	 */
	function fail_info(items) {
		var fails = {}, num = 0;
		var fail_list = [];
		items.forEach(function _get_fails(item) {
			var i = item.file;
			if(i.error) {
				fail_list.push(item);
				if(fails[i.error]) {
					fails[i.error] += 1;
				} else {
					fails[i.error] = 1;
				}
			}
		});
		var deduped = Object.keys(fails);
		var line = deduped.length == 0 ? null:
			deduped.length == 1 ? ["Failed to summarize: " + Object.keys(fails)[0], fail_list.length]:
				["Failed to summarize", fail_list.length];
		return {
			line: line,
			failures : fail_list
		}
	}
	// We return a  "file" structure, this is something that is used by the download_files function below.
	return {
		filename : renamed,
		original_file_info : file_info,
		group_key : 'summary',
		function : function _on_doc_summarize(callback) {
			ai_task_document_summarize(file_info, false, function(summary) {
				callback(summary);
			}, function _error(error) {
				callback({success:false, error: error});
			}, ai_options);
		},
		group : function _combine_summaries(items, callback) {
			$dialog
				.find(".status").text("Compiling").end()
				.find(".substatus").text("Compiling summary for " + plural_n(items.length, "item")).end();
			var successes = items.filter(function (i) { return i.file.success; });
			var f_info = fail_info(items);
			var info = [["Summarized", successes.length]];
			if(f_info.line) {
				info.push(f_info.line);
			}
			info.push(["Date Generated", (new Date()).toLocaleString()]);
			info.push(["Source Page", window.location.href]);
			function full_filing(o) {
				var o_filing = o.filing;
				if(o.exhibit) {
					// This is an exhibit. It may be a filing+exhibit, or just an exhibit.
					return o_filing ? o_filing + "-" + o.exhibit : o.exhibit;
				} else if(!o_filing && o.link) {
					// If there's a link, give an anchor tag.
					return "Document";
				}
				return o_filing || "";
			}

			// Extract the prompts from the successes
			var prompts = [], prompt_dedup = {};
			successes.forEach(function (i) {
				var prompt = i.file.prompt;
				var p_key = prompt && prompt.key ? prompt.key: "summary";
				var prompt_model_key = i.file.model + p_key;
				if(prompt_dedup[prompt_model_key]) {
					// Increment the count if we've already seen this prompt.
					prompt_dedup[prompt_model_key].count += 1;
				} else {
					// Flatten/join if prompt is an array:
					var p = prompt && prompt.template && Array.isArray(prompt.template) ?
						prompt.template.join("\n  \n"):
						// Older way:
						i.file.prompt_template ? i.file.prompt_template:
						prompt && prompt.template ? prompt.template || '':
						'';
					prompts.push({
						key : p_key,
						model : i.file.model,
						template_cell : p,
						count : 1
					});
					prompt_dedup[prompt_model_key] = prompts[prompts.length - 1];
				}
			});

			export_data_to_excel("Filings Summary", [{
				name : 'Summarizations',
				info : info,
				listing_cols : ["Court", "Docket", "Filing-Exhibit", "Link", "Pleading Tags", "Filename",
					"AI Summary", "Model: Task", "Tokens"],
				listing : successes.map(function (i) {
					// The original value has a lot of the info.
					var o = i.file_info.original_file_info;
					// For now, we provide very simpl tags.
					var tags = (o?.analyze?.parser_types || []).map(function (t) {
						return t.type + (t.identifier ? " - " + t.identifier : "");
					}).join(", ");
					// Be careful with the prompt. May not be a dict.
					var p_key = i.file.prompt && i.file.prompt.key ? i.file.prompt.key: "summary";
					var model_key = i.file.model + ": " + p_key;
					return [o.court, o.docket, full_filing(o), [o.link, "Link"],
						tags, o.filename || "File", i.file.result,
						model_key, i.file.total_tokens || ""];
				})
			}]
			.concat(prompts.length ? [{
				name : 'Tasks',
				info : [["Types of Tasks Performed", prompts.length]],
				listing_cols : ["Model", "Task", "Template", "Number of Uses"],
				listing : prompts.map(function (p) {
					return [p.model, p.key, p.template_cell, p.count];
				})
			}]:[]).concat(f_info.failures.length ? [{
				name : 'Documents Not Summarized',
				info : info,
				listing_cols : ["Court", "Docket", "Filing-Exhibit", "Link", "Filename", "Error Message"],
				listing : f_info.failures.map(function (i) {
					var o = i.file_info.original_file_info;
					return [o.court, o.docket, full_filing(o), [o.link, "Link"], o.filename || "File", i.file.error];
				})
			}]:[]), function (success, raw_resp) {
				if(success) {
					callback("Summarized Filings.xlsx", new Uint8Array(raw_resp));
				} else {
					show_error_usermsg("Error Summarizing: " + e);
				}
			});
		},
	}
}

/**
 * Get the options for the AI system, returns true if synchronous.
 * @param callback
 */
function ai_task_options(callback) {
	// Pull from the cache if we have it.
	var ai_options = sessionGet("ai_options");
	if(ai_options) {
		callback(ai_options);
		return true;
	}
	// Otherwise, we need to get it from the server.
	$.getJSON("/ocr/ai_options.ajax", function (resp) {
		if(resp.success) {
			sessionSet("ai_options", resp);
		}
		callback(resp);
	});
	return false;
}

/**
 * Get a document's GPT summary. Not all accounts have this ability,
 * may raise an error.
 * @param file_info A data structure that contians the document's id, or court/docket/filing/exhibit.
 * @param force
 * @param callback
 * @param $error_el Either a jquery element to show errors in, or a function
 * 	to call with the error.
 * @param ai_options Additional parameters to pass to the AI system.
 */
function ai_task_document_summarize(file_info, force, callback, $error_el, ai_options) {
    // Default to a summary.
	var task_key = ai_options && ai_options.task || 'summary';
    if(file_info.analyze && file_info.analyze.gpt && [task_key] && !force) {
        callback(file_info.analyze.gpt[task_key]);
        return;
    }
    var doc_id = file_info.doc_id || file_info.id;
    // Specify the document by id or by court/docket/filing/exhibit.
    var data = doc_id ? {id:doc_id} : {court:file_info.court, docket:file_info.docket, filing:file_info.filing, exhibit:file_info.exhibit};

    if(force) {
        data.force = true;
    }
	for(var k in ai_options) {
		if(ai_options[k] !== undefined && ai_options[k] !== null) {
			data[k] = ai_options[k];
		}
	}

    $.post('/ocr/ai_analyze.ajax', data, null, "json")
    .success(function(result) {
        if(!result.success) {
			if(typeof $error_el == "function") {
				$error_el(result.error);
			} else {
            	show_usermsg(result.error, $error_el);
			}
        } else {
			// A bit of a hack, but save the result in the file_info object.
			if(!file_info.analyze) { file_info.analyze = {}; }
			if(!file_info.analyze.gpt) { file_info.analyze.gpt = {}; }
            file_info.analyze.gpt[task_key] = result;

            callback(result);
        }
    }).error(function () {
		if(typeof $error_el == "function") {
			$error_el("Error getting GPT summary");
		} else {
        	show_usermsg("Error getting GPT summary.", $error_el);
		}
    });
}

/**
 * Download a list of files. Automatically shows progress messages to the users.
 * Parameters allow for downloading list of files, or generating on the fly.
 * @param files can be one of two types.
 * A list of objects, each with the following properties.
 *        filename:    the filename to use. If no filename is specified here, you
 *                    must specify one in the HTTP download request as x-filename.
 *        download: the download link to the file.
 *        function: A function called to generate the file, instead of the download link.
 *        group_key: if grouping files together, then use this key to group this file.
 *        group: If grouping together, a function that will accept a list of items to group callback with a file.
 * A function which generates a list of dictionaries.
 *        files($dialog, function callback(generated_files) { } )
 *    If a user cancels the dialog, then $dialog.data('cancel', true)
 * @param zipfilename	The filename of the output zip file.
 * @param download_parallel If true, download 3 documents at once.
 * @author speedplane
 */
function download_files(files, zipfilename, download_parallel) {
	// Create the modal dialog immediately for the file list progress bar.
	var $dialog = create_download_dialog();
	$dialog
		.find(".cancel, .done").click(function () {
			close_dialog();
			// We propogate the click if we're done, we stop it if we cancel.
			return $(this).hasClass("done") ? true : false;
		}).end()
		.find(".status").text("Initializing ... ").end();
	// Give the user the ability to cancel.
	var canceled = false;
	function close_dialog() {
		canceled = true;
		$dialog
			.dialog("close")
			.remove()
			.data('canceled', true);
	}
	function add_error_msg(msg) {
		$dialog.find(".error").append("<div>" + msg + "</div>");
	}
	
	// Download the final generated zip file.
	function download_zip(blob) {
		// Make sure there's a valid filename.
		zipfilename = zipfilename ? safe_filename(zipfilename) : "download.zip";
		if (canceled) {
			return;
		} else if (typeof navigator.msSaveBlob == "function") {
			// On IE, we can automatically download the file.
			navigator.msSaveBlob(blob, zipfilename);
			close_dialog();
		} else {
			// On other browsers, the user must click. Use the cancel button.
			var blob_url = URL.createObjectURL(blob);
			console.log("Saving zip (" + zipfilename + ") to: " + blob_url);
			$dialog
				.find(".status").text("Download complete.").end()
				.find(".substatus").text("").end()
				.find(".perc").text("100%").end()
				.find(".progress .bar").width("100%").end()
				.find('.cancel')
					.addClass("done")
					.removeClass("cancel")
					.attr('href', blob_url)
					.attr('download', zipfilename)
					.text('Save').end();
		}
	}
	
	var zipWriter = null;
	function zip_initialize(callback) {
		// initialize the zip library.
		$dialog
			// set a status message
			.find(".status").text("Creating zip file.").end()
			.find(".substatus").text("");
		$.getScript("/site_media/zipjs/zip.js", function () {
			zip.workerScriptsPath = '/site_media/zipjs/';
			// use a BlobWriter to store the zip into a Blob object
			zip.createWriter(new zip.BlobWriter("application/zip"), function(writer) {
				zipWriter = writer;
				callback();
			}, function _zip_create_error(error) {
				close_dialog();
				show_error_usermsg(error.message || error);
			});
		});
	}
	
	var _all_filenames = {};
	/**
	 * Keep track of all of the filenames and make sure they all have a
	 * unique value.
	 * @param filename The filename you want to uniqyify.
	 * @returns {string}
	 */
	function unique_filename(filename) {
		// Break the filename into an extension, make sure its a 2-array.
		var orig_filename = filename.split(".");
		orig_filename = orig_filename.length == 1 ? [orig_filename[0], ""]:
			[orig_filename.slice(0, -1).join("."), "." +
				orig_filename[orig_filename.length-1]];
		// Start trying stuff to append.
		var append_i = 0;
		while(_all_filenames[filename]) {
			append_i += 1;
			filename = orig_filename[0] + "-" + append_i + orig_filename[1];
		}
		// Make this one as used.
		_all_filenames[filename] = true;
		return filename;
	}

	// Zip one File
	var currently_zipping = false;
	function zip_file(filename, data, done, comment) {
		if(canceled) {
			return;
		}
		// The zip web worker is not thread safe, only one request at a time.
		if (currently_zipping) {
			// Wait until we're done zipping.
			setTimeout(function () { 
				zip_file(filename, data, done, comment);
			}, 100);
			return;
		}
		if(!filename) {
			console.error("No file name given, skipping: " + data.length);
			done();
			return;
		}
		currently_zipping = true;
		// Zip up downloaded file.
		zipWriter.add(unique_filename(safe_filename(filename)), {
				size : data.length,
				// We don't need to do anything to init.
				init : function (callback, onerror) { callback(); },
				// Reading is just creating a subarray
				readUint8Array : function(index, length, callback, onerror) {
						callback(new Uint8Array(data.subarray(index, index + length)));
				}
		}, function() {
			// onsuccess callback
			done();
			currently_zipping = false; // Unlock the zip pipeline.
		}, function(currentIndex, totalIndex) {
			// zipWriter onprogress callback
		}, {
			// The options structure.
			comment : comment || ""
		});
	}

	var failed_downloads = [];
	var successful_downloads = [];
	var start_time = new Date();
	function remove_query (q) {
		// Remove everything after the query, and the docs folder.
		return q.split("?")[0].replace("/docs/", "/").replace(/\.pdf$/, "");
	}
	function get_download_summary(done) {
		// Create an array, which lists the failed downloads in human readable.
		$dialog
			.find(".status").text("Generating Excel summary").end()
			.find(".substatus").text("").end();
		// Generate a human readable duration.
		var seconds = Math.floor((new Date() - start_time)/1000);
		var duration = seconds <= 120 ? seconds + " Seconds":
			Math.floor(seconds/60) + " Minutes " + (seconds%60) + " Seconds";
		var info = [
			["Successful Downloads", successful_downloads.length],
			["Failed Downloads", failed_downloads.length],
			["Download Time", start_time],
			["Download Duration", duration],
			["Source Page", window.location.href]
		];
		export_data_to_excel("Download Summary", [{
			name : 'Successful Downloads',
			info : info,
			listing_cols : ["Filename", "Download Link"],
			listing : successful_downloads.map(function (f) {
                return [f.filename || "", remove_query(f.download || "")];
            })
		},{
			name : 'Failed Downloads',
			info : info,
			listing_cols : ["Filename", "Error Message", "Download Link"],
			listing : failed_downloads.map(function (f) {
                return [f.f.filename || "", f.e || "",
					remove_query(f.f.download || "")];
            })
		}], function (success, raw_resp) {
			if(success) {
				done(new Uint8Array(raw_resp));
			} else {
				close_dialog();
				show_error_usermsg(e);
			}
		});
	}

	// Download the files.
	// Number of parallel downloads
	if(!download_parallel) {
		download_parallel = 3;
	}
	function get_filename_from_xhr(xhr) {
		var disposition = xhr.getResponseHeader('Content-Disposition');
		if (disposition) {
			var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
			var matches = filenameRegex.exec(disposition);
			if (matches != null && matches[1]) {
			  return matches[1].replace(/['"]/g, '');
			}
		}
		return null;
	}
	var TEST_ONLY = false;
	var MAX_TRIES = 5; 	// Number of times we'll try downloading each file.
	var bytesDownloaded = 0;
	// This is the structure, initialized further below
	var downloadsLeft = {files:null, groups:null, total:function () { return this.files + this.groups; }};
	// We allow certain files to be grouped together into a single larger file.
	var grouped_files = {};

	/**
	 * Update the status message, called after downloading each file.
	 * Relies on files and downloadsLeft, and bytesDownloaded
	 */
	function updateStatus(file) {
		// Calculate stats.
		var num_files = 0, num_grouped = 0;
		files.forEach(function (f) {
			if(f.group_key) { num_grouped++; } else { num_files++; }
		});
		var dl_files = num_files - downloadsLeft.files;
		var dl_groups = num_grouped - downloadsLeft.groups;
		var perc = (dl_files + dl_groups) / files.length * 100;
		// Status message.
		var msg = "Downloaded " + dl_files + " of " + plural_n(num_files, "file");
		if(num_grouped) {
			// We have grouped files.
			msg += " and " + dl_groups + " of " + plural_n(num_grouped, "task");
		}
		msg += " " + getSize() + ".";

		// Set a status message and progress bar.
		var title = num_grouped ? "Download and Analyze": "Batch Download";
		$dialog
			.find(".title").text(title).end()
			.find(".status").text(msg).end()
			.find(".perc").text(perc.toFixed(0) + "%").end()
			.find(".substatus").text("Downloading: " + file.filename).end()
			.find(".progress .bar").width(perc + "%");
	}
	// Filesize in user friendly format.
	function getSize() {
		return bytesDownloaded > 10 * 1024 * 1024 ?
				(bytesDownloaded / 1024 / 1024).toFixed(0) + "MB":
			bytesDownloaded > 2 * 1024 * 1024 ?
				(bytesDownloaded / 1024 / 1024).toFixed(1) + "MB":
				(bytesDownloaded / 1024 ).toFixed(0) + "kB";
	}
	function download_file(i, num_tries) {
		if(canceled) {
			return;
		} else if(i >= files.length) {
			console.log("Trying to download nonexistent file.");
			return;
		} else if (downloadsLeft.total() <= 0) {
			console.log("Negative downloads left: " + downloadsLeft.files);
			return;
		}
		var file = files[i];
		// One day, try to refactor.
		updateStatus(file);
		/**
		 * Asynchronously merge a group of files. Returns true if complete.
		 * @return {boolean} True we are grouping more files. False if complete.
		 */
		function merge_groups() {
			for(var group_key in grouped_files) {
				var group_files = grouped_files[group_key];
				// We use the first item in the list.
				var first = group_files[0];
				if(first.group_completed) {
					continue;
				}
				var data = first.file_info.group(grouped_files[group_key], function _callback(grouped_filename, data) {
					// Now zip that file up.
					zip_file(grouped_filename, data, function _on_zipped() {
						first.group_completed = true;
						// Go on to the next item.
						do_next();
					});
				});
				return true;
			}
			return false;
		}

		// Sets up the next download, or complete the zip file if done.
		function do_next(was_group) {
			if(was_group) {
				downloadsLeft.groups -= 1;
			} else {
				downloadsLeft.files -= 1;
			}
			if (downloadsLeft.total() <= 0) {
				// No more downloads left, build the grouped files.
				if(merge_groups()) {
					// If there are groups, downloadsLeft maybe negative.
					return;
				}
				// No more downloads left, build the excel file listing.
				get_download_summary(function (file_data) {
					// Now zip that file up.
					zip_file("Download Summary.xlsx", file_data, function () {
						// No finish the zip and be done.
						zipWriter.close(download_zip);
					}, null);
				});
			} else if (i + download_parallel < files.length) {
				// Downloads are in parallel, so add the next for this group.
				download_file(i + download_parallel);
			}
		}
		if(TEST_ONLY) {
			// Create a fake file.
			var fake_file = "this is the fake file for " + file.filename;
			bytesDownloaded += fake_file.length;
			// Add the file to the zip, and then go on to the next download.
			zip_file(file.filename, new TextEncoder("utf8").encode(fake_file),
				do_next);
			return;
		}
		function on_failure(e, status) {
			if(!num_tries) {
				num_tries = 1;
			}
			if (status != 403 && status != 401 && num_tries < MAX_TRIES) {
				// Try again.
				download_file(i, num_tries + 1);
			} else {
				// The download failed, try not to mess up everything.
				var fname = files[i].filename || 
					files[i].download.split("/").slice(-1)[0];
				add_error_msg("Download Failed - " + e + ": " + fname);
				failed_downloads.push({
					f : files[i],
					e : e
                });
				// Go on to the next file.
				do_next();
			}
		}

		if (file.function) {
			// This is a function, so call it and get the file.
			file.function(function _done(f) {
				successful_downloads.push(file);
				if(file.group_key) {
					if(!grouped_files[file.group_key]) {
						grouped_files[file.group_key] = [];
					}
					grouped_files[file.group_key].push({file_info:file, file:f});
					do_next(true);
				} else {
					zip_file(f.filename, f.data, do_next);
				}
			}, on_failure);
			return;
		}

		// Download the file
		var xhr = new XMLHttpRequest();
		xhr.open('GET', file.download, true);
		xhr.responseType = 'arraybuffer';
		xhr.onload = function(e) {
			if (this.status != 200) {
				// Bad Download, build an error message.
				var e_msg = xhr.getResponseHeader('X-Detailed-Error') || "";
				e_msg += e_msg.length ? " (Status: " + this.status + ")":
						"Bad Status: " + this.status;
				on_failure(e_msg, this.status);
				return;
			}
			bytesDownloaded += this.response.byteLength;
			
			// Get the filename from the server first, then from the files.
			var fname = this.getResponseHeader('x-filename') ||
					get_filename_from_xhr(xhr) || file.filename;
			if(!fname) {
				// Remove everything after the query.
				fname = file.download.split("?").slice(0)[0];
				// Now try to get the last soubstantive part of the URL.
				while(fname && fname.endsWith("/")) {
					fname = fname.slice(0, -1);
				}
				fname = fname.split("/").slice(-1);
			}
			if(!fname) {
				$dialog.find(".error").append("<div>No filename for " +
						"download: " + file.download + "</div>");
				failed_downloads.push({
					f : file,
					e : "No filename"
				});
				// Go on to the next file.
				do_next();
				return;
			}
			// Make sure the filename is trouble free. Set max length to 160
			// just to make sure they can fully open the files on windows.
			// It's the caller's job to provide user-friendly filenames.
			var safe_fname = safe_filename(fname, null, 160);
			if(safe_fname != fname) {
				console.log("Warning: Making bad filename safe: " + fname);
			}
			successful_downloads.push(file);
			if(file.group_key) {
				file.data = new Uint8Array(xhr.response);
				file.comment = this.getResponseHeader('x-comment');
				grouped_files[file.group_key].push({file_info:file, file:file});
				do_next(true);
			} else {
				// Add the file to the zip, and then go on to the next download.
				zip_file(safe_fname, new Uint8Array(xhr.response), do_next,
					this.getResponseHeader('x-comment'));
			}
		};
		xhr.onerror = function(e) {
			// Another way of failing.
			on_failure("Transfer Error: " + e);
		};
		xhr.send();
	}
	
	function auto_perc() {
		// Give the sensation of a continuously moving progress bar by moving the
		// progress bar up a notch on regular intervals.
		var total_left = downloadsLeft.total();
		if (canceled || total_left <= 0) {
			return;
		}
		// The minimum the percentage bar should be at.
		var perc_lo = (files.length - total_left) / files.length;
		// The maximum
		var perc_hi = (files.length - total_left + 1) / files.length;
		var perc_cur = Math.max(perc_lo, $dialog.find(".progress .bar").width() / 
			$dialog.find(".progress").width());
		// Get a bit closer to the next one. It will never reach it.
		perc_cur += (perc_hi - perc_cur) / 5;
		$dialog.find(".progress .bar").width((perc_cur*100) + "%");
		setTimeout(auto_perc, 150);
	}
	
	// Actually start the download process.
	function start_download() {
		console.log("Downloading multiple files with " + navigator.userAgent);
		if(navigator.userAgent.search(/iPhone|iPad/) >= 0) {
			$dialog
				.find(".status").text("Bulk downloads are not yet " +
					"supported on iPhones or iPads.").end()
				.find(".substatus").text("").end()
				.find(".perc").text("").end()
				.find(".progress").hide();
			return;
		}
		
		// Remove duplicates. We shouldn't have any, but just in case.
		var dnames = {}, fnames = {}, to_remove = [];
		files.forEach(function(f, idx) {
			if(f.download && f.download in dnames) {
				// These are duplicate downloads, remove them.
				to_remove.push(idx);
			} else if(f.filename && f.filename in fnames) {
				var count = fnames[f.filename];
				var filename_split = f.filename.split('.');
				var extension = filename_split.pop();
				var name = filename_split.join('.');
				while(f.filename in fnames) {
					count++;
					f.filename = name + " (" + (count + 1) + ")." + extension;
				}
				fnames[f.filename] = count;
				dnames[f.download] = true;
				console.log("Renaming File: " + f.filename);
            } else {
				dnames[f.download] = true;
				if(f.filename) {
					fnames[f.filename] = (fnames[f.filename] || 0) + 1;
				}
			}
		});
		if(to_remove.length) {
			console.log("Removing " + to_remove.length + " duplicates.");
			// Remove the files that we should remove.
			to_remove.reverse();
			to_remove.forEach(function (idx) { 
				files.splice(idx, 1);
			});
		}
		
		// Initialize our file counter.
		downloadsLeft.groups = files.filter(function (f) {return !!f.group_key; }).length;
		downloadsLeft.files = files.length - downloadsLeft.groups;
		zip_initialize(function _on_zip_init() {
			// Initialize the first set of parallel downloads.
			for(var j=0; j < download_parallel && j < files.length; j++) {
				download_file(j);
			}
			// Start the automatic progress bar mover.
			auto_perc();
		});
	}
	
	if (typeof files == "function") {
		// Before starting the download, we must generate the files.
		files($dialog, function (generated_files) {
			files = generated_files;
			if(files.length == 0) {
				close_dialog();
			}
			start_download();
		});
	} else {
        if(files.length == 0) {
			close_dialog();
        } else {
			start_download();
		}
	}
}


/**
 * A simple function that turns a form into an uploader. The form must have
 * an input[type=file] and should have a label and use the scss mixin
 * image-uploader.
 * @param $form The jquery object.
 * @param existing_image The url to an image if it's supposed to start out
 * with one.
 * @param endpoint Where to set the endpoint.
 * @param extra_data Additional data to be passed in via POST.
 */
function image_uploader($form, existing_image, endpoint, extra_data) {
	if(!$form || !$form.length) {
		return;
	}
	if($form[0].tagName != "FORM") {
		console.log("Not using a form: " + $form[0].tagName);
		return;
	}
	// Add the file input if it wasn't already there.
	if(!$form.find("input[type=file]").length){
		$form.append('<input type="file">');
	}
	// Add an image if one doesn't already exist.
	if(!$form.find("img").length) {
		$form.append('<img alt="Uploader" style="display: none;">');
	}
	$form
		.attr('action', endpoint || '/user/image/upload')
	 	.attr('method', 'POST')
	 	.find("input[type=file]").change(function () {
	 		$form.submit();
	 	}).end()
		 // Add in the action
		.ajaxForm({
			beforeSubmit: function (arr, $form) {
				$form.addClass('disabled').find(".loader").show();
			},
			success: function (resp, statusText, xhr, $form) {
				$form.removeClass('disabled').find(".loader").hide().end();
				if (resp.success) {
					setup_image(resp.links[0]);
				} else {
					show_error_usermsg(resp.error);
				}
			},
			dataType: 'json'
		});
	// Add in the extra data.
	for(var k in extra_data) {
		$form.append('<input type="hidden" name="' + k + '" value="' +
			(extra_data[k]||'') + '">');
	}

    function setup_image(url) {
        if(url) {
            $form.addClass('has_image').find("img").attr('src', url).show();
        } else {
            $form.removeClass('has_image').find("img").hide();
        }
    }
    setup_image(existing_image);
}

function show_support_overlay() {
	show_modal($("#SupportOverlay"), null, "auto", "auto", "support_overlay");
}

function init_support_overlay() {
	$("a[href='#SupportOverlay']").click(function (ev) {
		ev.preventDefault();
		show_support_overlay();
	});
	var $overlay = $('#SupportOverlay form, #MessageOverlay form')
	.ajaxForm({
		beforeSubmit:  	function (data, $form, options) {
			$form.find(".loader").show();
		},
		success: function(data, statusText, xhr, $form) {
			$form.find(".loader").hide();

			// Try to close the dialog
			var msg_overlay = $form;
			while(msg_overlay && !msg_overlay.hasClass("message_overlay"))
				msg_overlay = msg_overlay.parent();
			if(msg_overlay) msg_overlay.dialog("close");

			// Give the user a message
			if(data.success)
				show_success_usermsg("Successfully Sent", "email_support");
			else
				show_error_usermsg(data.error, "email_support");
		},
		type:     	'post', // Can override method attribute
		dataType:   'json'  // 'xml', 'script', or 'json' (expected server response type)
	})
	.find('input[type=submit]').button();
}
function init_forgot_password() {
	$("#ForgotPasswordOverlay form input[type=submit]").click(function () {
		$("#ForgotPasswordOverlay form .loader").show();
		var the_email = $("#ForgotPasswordOverlay form input[type=text]").val();
		$.post("/password_reset.ajax", {email:the_email}, function (resp) {
			$("#ForgotPasswordOverlay form .loader").hide();
			if(resp.success) {
				show_success_usermsg("Your new password has been emailed to you.");
				$("#ForgotPasswordOverlay").dialog("close");
			} else {
				show_error_usermsg(resp.error);
			}
		}, "json");

		return false;
	});
}
function init_hd_bd_holder() {
	// Set the body to at least about the size of the screen. This is a
	// remenant of old code that tries to get the footer down to the bottom of
	// the screen. If a page lacks a footer, it isn't needed: Add no_push_footer
	// to the bd class in the template.
	var $hd_bd = $(".hd_bd_holder");
	if(!$hd_bd.hasClass("no_push_footer")) {
		var $hd = $hd_bd.find("#hd");
		var min_height = get_window_height() - ($hd.height() +
			$("#search_login_menu_spacer").height() + $("#footer").height() + 50);
		$hd_bd.find("#bd").css("min-height", min_height);
	}
}
function init_pacer_tips() {
	// A tooltip that explains pacer
	var html = $("#PACER_explained").html();
	$(".PACER_tip").powerTip({
		smartPlacement	: true,
		mouseOnToPopup	: true,
		closeDelay 		: 400,
	}).data('powertip', html);
}
function init_float_menu() {
	// When we scroll down, tell the float menu
	if($("#float_menu:visible").length) {
		$(window).scroll(function() {
		  if ($(document).scrollTop() > 50) {
			$('#float_menu, #float_menu li a').addClass('shrink');
		  } else {
			$('#float_menu, #float_menu li a').removeClass('shrink');
		  }
		});
	}
}

function common_setup() {
	// Prevent IE (or anyone) from caching our ajax calls
	$.ajaxSetup({
		cache: false,
		timeout: 1000*65		// GAE timeout is 60 seconds?
	});
	// Enable the placeholder attribute for non-html5 browsers
	init_support_overlay();
	init_hd_bd_holder();
	init_float_menu();
	init_global_dropdown();
	$(":input[placeholder], textarea").placeholder();

	// These functions don't need to run synchronously on startup.
	setTimeout(function common_setup_later() {
		init_powertip_defaults();
		init_forgot_password();
		init_pacer_tips();
		init_close_buttons();
		init_godaddy_seal();
	}, 0);
}

$(document).ready(function _start() {
	common_setup();
});


///////////
// Support Chat
function get_admin_url(user_email) {
    if(!user_email || typeof user_email != "string") {
        return null;
    }
    return window.location.origin + "/msadmin/admin.html?user_detail=" +
        encodeURIComponent(user_email);
}

// 9/2023: Salesforce being deprecated.
var enable_support_chat = false;
var sf_chat_svc = null;

function show_salesforce_chat_window() {
	if(sf_chat_svc) {
		sf_chat_svc.onHelpButtonClick();
	}
}
function setup_salesforce_live_chat_window() {
    if(!user_logged_in || !enable_support_chat) {
        return;
    }
    var initESW = function(gslbBaseURL) {
        embedded_svc.settings.displayHelpButton = true;
        embedded_svc.settings.language = 'en';
        embedded_svc.settings.defaultMinimizedText = 'Chat with support';
        embedded_svc.settings.disabledMinimizedText = 'Support offline';
        embedded_svc.settings.offlineSupportMinimizedText = 'Contact Support';
        // Defaults to Loading
        //embedded_svc.settings.loadingText = '';
        // Sets the domain for your deployment so that visitors can navigate
        // subdomains during a chat session
        //embedded_svc.settings.storageDomain = 'yourdomain.com';
        // Settings for Live Agent
        //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
            // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
            // Returns a valid button ID.
        //};
        //Sets the auto-population of pre-chat form fields
        embedded_svc.settings.prepopulatedPrechatFields = {
            FirstName: user_first_name,
            LastName: user_last_name,
            Email: user_logged_in,
            // Subject: "Hello",
        };
        // Send the data as prechat fields as well.
        embedded_svc.settings.extraPrechatFormDetails = [{
            label: "ReferrerUri",
            value: window.location.href,
            displayToAgent: true,
            transcriptFields : ["ReferrerUri"],
        },{
            label: "AdminURL",
            value: get_admin_url(user_logged_in),
            displayToAgent: true,
            transcriptFields : ["AdminURL"],
        },{
            label: "FirstName",
            value: user_first_name,
            displayToAgent: true,
            transcriptFields : ["FirstName"],
        },{
            label: "LastName",
            value: user_last_name,
            displayToAgent: true,
            transcriptFields : ["LastName"],
        },{
            label: "Email",
            value: user_logged_in,
            displayToAgent: true,
            transcriptFields : ["Email"],
        }];
        //An array of button IDs, user IDs, or userId_buttonId
        //embedded_svc.settings.fallbackRouting = [];
        var tEl = document.createElement('div');
        tEl.setAttribute('class', 'salesforce_agent');
        document.body.appendChild(tEl);
        embedded_svc.settings.targetElement = tEl;
        embedded_svc.settings.enabledFeatures = ['LiveAgent'];
        embedded_svc.settings.entryFeature = 'LiveAgent';

        var ret = embedded_svc.init(
            'https://fastcase.my.salesforce.com',
            'https://fastcasesupport.force.com',
            gslbBaseURL, '00D3000000000Vb',
            'Docket_Alarm_Outreach_Agents', {
                baseLiveAgentContentURL:
                    'https://c.la1-c1-dfw.salesforceliveagent.com/content',
                deploymentId: '57238000000CbI7',
                buttonId: '5733800000001Ds',
                baseLiveAgentURL:
                    'https://d.la1-c1-dfw.salesforceliveagent.com/chat',
                eswLiveAgentDevName:
                    'EmbeddedServiceLiveAgent_Parent04I380000008OIUEA2_1679eb7aaf7',
                isOfflineSupportEnabled: true
            }
        );
        sf_chat_svc = embedded_svc;
    };
    if(window.location.hostname == 'localhost') {
    	console.log("Not loading Salesforce chat on localhost.");
    	return;
	}
    $.getScript("https://service.force.com/embeddedservice/5.0/esw.min.js", function () {
        initESW('https://service.force.com');
    });
}

///////////
// Special GUI Elements

/**
 * Sidebar.
 * Handles an autohiding, scrolling sidebar.
 * Returns a function that should be called on scrol and resize.
 */
function setup_common_sidebar(sidebar, footer, top_elements_with_padding) {
	var $sidebar = $(sidebar);
	// When we show the scrollbar on hover, we don't want it to shift things 
	// around. Reduce padding on elements to make room for the scrollbar.
	$sidebar.hover(function() {
		if($sidebar.get(0).scrollHeight <= $sidebar.height()) {
			return;
		}
		var width = getScrollbarWidth($sidebar.parent()[0]).toString();
		$sidebar.find(top_elements_with_padding).filter(":visible")
			.css('padding-right', "-=" + width + "px");
	}, function () {
		$sidebar.find(top_elements_with_padding).filter(":visible")
			.css('padding-right', '');
	});
	
	if($(".nosidebar:visible").length) {
		// If there is no sidebar, tell the footer so it can modify its css.
		$("#footer").addClass("nosidebar");
	}
	
	// Handle sidebar toggling.
	$(".toggle_sidebar").click(function () { 
		if($sidebar.offset().left >= 0) {
			$sidebar.css('left', -$sidebar.width());
		} else {
			$sidebar.animate({left: 0, duration:200});
		}
	});
}

/**
 * Actionbar
 * Automatically shrink down or hide elements in the action bar depending on 
 * the overall width.
 */
function adjust_actionbar_items($actionbar, $matchwidth) {
	if(!$actionbar) {
		$actionbar = $("#actionbar");
	}
	var total_width = $actionbar.width();
	var $items = $actionbar.css('padding-left', '')
		.find("> div").css("margin-left", "");
	$items.find("span").show();
	$actionbar.find("input:not(#hide_on_filter)").show().css("width", "");
	
	// Return a function which shrink the filter down to a size.
	function reduce_filter_to(width) { return function () {
		if($actionbar.find("input").width() > width) {
			$actionbar.find("input").css('width',
				$actionbar.find("input").width() - 15
			);
			return true;
		}
	} }
	// Try hiding a span label.
	function hide_span_label() {
		var $labels = $items.find("span:visible:not(.nohide)").first();
		if($labels.length) {
			$labels.hide();
			return true;
		}
	}
	// Hide the input.
	function hide_filter_input() {
		if($actionbar.find("input").is(":visible")) {
			$actionbar.find("input").hide();
			return true;
		}
	}
	function sqeeze_buttons_margin_to(min_margin) {
		return function (){
			var lefts = $items.map(function () {
				return parseInt($(this).css("margin-left")); 
			});
			var max_left = Array.max(lefts);
			if(max_left > min_margin) {
				$items.each(function () {
					if(parseInt($(this).css("margin-left")) == max_left) {
						$(this).css("margin-left", min_margin);
					}
				});
				return true;
			}
		}
	}
	var shrink_functions = [
		reduce_filter_to(150),
		hide_span_label,
		reduce_filter_to(90),
		sqeeze_buttons_margin_to(15),
		hide_filter_input,
		sqeeze_buttons_margin_to(5),
		sqeeze_buttons_margin_to(0)
	];
	var num_shrinks = 0;
	while(true) {
		var item_widths = 0;
		$items.each(function () {
			item_widths += $(this).outerWidth(true); 
		});
		if(item_widths < total_width) {
			break;
		}
		// Go through the various shrinking functions
		var found = false;
		for(var i = 0; !found && i < shrink_functions.length; i++) {
			found = shrink_functions[i]();
		}
		if(!found) {
			// Can't shrink anymore.
			break;
		}
		num_shrinks += 1;
	}
	// If we didn't shrink it down too much, and the action bar is far to 
	// the left, bring it in so it's more noticeable.
	if(num_shrinks == 0 && $matchwidth && $matchwidth.length) {
		// The left end of the action bar.
		var action_l = $actionbar.offset().left +
				parseInt($actionbar.css('padding-left'));
		var match_l = $matchwidth.offset().left + 
			parseInt($matchwidth.css('padding-left'));
		// The right end of the left most button
		var $last_btn = $actionbar.find(".btns_right_align")
			.prevUntil(":visible");
		// prevUntil stops before the :visible element, go one more to be on it.
		if($last_btn && $last_btn.length)
			$last_btn = $last_btn.prev();
		if(!$last_btn || !$last_btn.length) {
			// Everything is visible.
			$last_btn = $actionbar.find(".btns_right_align").prev(":visible");
		}
		if($last_btn && $last_btn.length) {
			var last_btn_right = $last_btn.offset().left + $last_btn.width();
			// Left end of the right buttons
			var action_right_btns = $actionbar.find(".btns_right_align").offset().left;
			if (action_l < match_l && 
				match_l + last_btn_right - action_l < action_right_btns) {
				$actionbar.css('padding-left', 
					"+=" + (match_l - action_l).toString());
			}
		}
	}
}

function init_close_buttons() {
	$(".close").click(function() {
		// Find the DOM object to minimize, it must be a parent of the button
		var to_close = $(this).parent();
		while(to_close.length && !to_close.hasClass("closeable")) {
			to_close = to_close.parent();
		}
		to_close.hide();
		// Close tooltips. There may be an error tip causing the user to close the dialog.
		$.powerTip.hide(null, true)
	});
}

var bgiframe_inner = "<html lang='en-us' title='Inner Frame'><head><style> body {" +
	"background-color : transparent;" +
	"opacity	: .3;" + 
	"filter		: alpha(opacity=30);" + 
	"overflow	: hidden;" + 
	"margin		: 0;" + 
	"padding	: 0;" + 
	"border		: 0;" + 
	"} </style></head><body>&nbsp;</body></html>";
var bgiframe = '<iframe class="bgiframe" frameborder="0" tabindex="-1" ' +
	' src="javascript:\'' + bgiframe_inner + '\';"' +
	' style="visibility:hidden;" onload="this.style.visibility =' +
		' \'visible\';"'+
	' allowTransparency="true"></iframe>';

/**
 * Open a dialog window with many of the default options already set
 */
function borderless_dialog(id, options) {
	if(options === undefined || options === null) {
		options = {};
	}
	// Close any active tips when we show a dialog.
	$.powerTip.hide()
	var position = options.position || { my: "center", at: "center", of: window };
	return $(id).dialog({
		dialogClass	: options.dialogClass || 'alert',
		autoOpen	: options.autoOpen || false,
		resizable	: options.resizable || false,
		draggable	: options.draggable || false,
		closeOnEscape: options.closeOnEscape !== undefined ? 
			options.closeOnEscape :  true,
		width		: options.width || "auto",
		height	: options.height || "auto",
		show 		: options.show || 'fade',
		modal		: options.modal != undefined ? options.modal : true,
		classes		: options.classes || {},
		position 	: position,
		open		: function _borderless_open(event, ui) {
			// Dont show the close button
			var $dialog = $(this);
			$dialog.parent()
				.children('.ui-dialog-titlebar').hide().end()
				// Add an iframe behind the overlay to make sure it
				// can be seen above embedded PDFs.
				.parent().find(".ui-widget-overlay").html(bgiframe).end();
			// We need to reposition after opening. This is a hack.
			setTimeout(function _post_open_resize() {
				$dialog.dialog("option", "position", position);
			}, 40);
			if(options.open) {
				return options.open(event, ui);
			}
		},
		focus : function _borderless_focus(event, ui) {
			var $this = $(this);
			var $dialog = $this;
			if(!options.position) {
                $this.parent().css('position', 'fixed');
            }
            if($this.is(":visible")) {
            	$dialog.dialog("option", "position", position);
			}
            if(options.focus) {
				return options.focus(event, ui);
			}
		}
	}).parent()
		.css("background", "transparent")
		.css("border", "none")
	.end();
}

// Search Name Constants.
var SEARCH_ALL_STR = "All Courts";
var COURT_ACRONYMS = ['PTAB', 'TTAB', 'ITC', 'Bankruptcies',
	'Federal Courts', 'SCOTUS', 'Trademarks', 'State Courts'
];

/**
 * Set all of the label widths to the same value within a given item
 */
function update_label_widths(item) {
	if(!item)
		item = $(document);
	var vals = $(item).hasClass("has_labels") ? 
				[item] : $(item).find(".has_labels");
	// Align all of the labels
	$(vals).each(function () {
		var label_width = $(this).attr('data-label_width');
		label_width = label_width ? parseInt(label_width): 10;
		var min_width = $(this).attr('data-min_width');
		var max = min_width ? parseInt(min_width): 0;
		
		$(this).find("label").not(".ignore_label_width")
			// Reset all the widths to the standard width
			.each(function () {
				$(this).css("width", "auto");
			})
			// Find the widest label
			.each(function(l) { 
				if ($(this).width() > max)  
					max = $(this).width(); 
			})
			// Set all labels to the widest
			.each(function(l) { 
				$(this).width(max+label_width); 
			});
	});
}

//////////////////////////////////
// Standardized Search Bar

/**
 * Initialize the search bar. Should only be called on page-load.
 */
function setup_search_bar() {
	// Set the <form> action
	set_search_bar_form_action();
	// Parse the current URL and set the text
	setup_search_bar_input_from_url();
	// Parse the facets.
	setup_search_bar_input_from_facets();
	// Certain courts have submenus in the drop down.
	setup_submenus();

	$(".query_builder")
		.find("input, select")
			.change(update_advanced_search)
			.keyup(update_advanced_search).end()
		.find(".add_filter").click(function () {
			var $qb = $(this).parents(".query_builder");
			$qb.find(".group.hidden").first().removeClass("hidden");
			if(!$qb.find(".group.hidden").length) {
				$(this).hide();
			}
			return false;
		}).data("powertip", "Add another search filter.").powerTip({
			smartPlacement:true
		}).end().find(".date_cell").datepicker({
			showOn: "button",
			buttonText: "<i class='fad fa-calendar-alt'></i>",
			buttonImageOnly: false,
			changeMonth: true,
			changeYear: true,
			beforeShow: function(input, inst) {
				setTimeout(function() {
					inst.dpDiv.css({"z-index": 1000});
				}, 0);
			}
		});
	// This enables the users to decide if they want to see dockets and documents or only dockets
	// it is set in the admin panel
	if (query_builder_display_dockets_only) {
		$(".query_builder").find('#q_chk_documents').prop("checked", false).change();
	}

	var $search_bar = $(".search_engine_form")
		.find(".show_search_options").click(function () {
			toggle_advanced_search(false, $(this));
			return false;
		}).powerTip({smartPlacement:true}).end()
		.find("input[type=text], textarea").keypress(function (ev) {
			// Make sure enter submits the form (necessary for chrome b/c of
			// https://code.google.com/p/chromium/issues/detail?id=45549)
			if(ev.keyCode == 13) {
					get_parent_with_tag($(this), "form")
						// Hide the search helper once we submit.
						.find(".search_helper").hide().end()
						.submit();
					return false;
			}
		}).end()
		.find(".selected_court").click(function () {
			// Toggle if we select the court.
			toggle_search_bar_court_dropdown(null, $(this).parent());
			return false;
		}).end();

	// Add a handler for all court_dropdowns so for use outside the search bar.
	$(".court_dropdown li:not(.has_submenu)").click(function () {
			$('.selected_court .selected').text($(this).text());
			set_search_bar_form_action($(this));

			var $form = get_parent_with_tag($(this), "form");
			toggle_search_bar_court_dropdown(false, $form);

			// The drop-down can automatically search if requested.
			var court_dropdown = get_parent_with_class($(this), "court_dropdown");
			if (court_dropdown && court_dropdown.hasClass("submitOnSelect")) {
				$('.search_engine_form').submit();
				// Since we just selected this, add the selected class.
				$(this).addClass("selected");
			}
		});

	$(".search_btn_holder, .search_btn_holder_middle").click(function () {
		var form = get_parent_with_tag($(this), "form");
		form.submit();
		return false;
	});

	// Grow the search bar when the user is typing into it.
	function check_grow($this) {
		// Calculate the width the of text that we have in the input
		var text_width = get_parent_with_class($this, "search_engine_form")
					.find(".widthcalc").text($this.val()).width();
		// If it is getting near a full line, then grow it.
		var enough_text = text_width > .8*$this.width();
		$this.toggleClass("grow", enough_text);
		$search_bar.toggleClass("grow", enough_text && $this.is(":focus"));
	}
	
	function get_court_context() {
		var c = $(".search_engine_form .selected_court .selected").text();
		return c == SEARCH_ALL_STR ? null : c;
	}
	function keydown_handler(ev) {
		if(ev.which == 9) { // TAB
			// Open up the court selector when they press tab.
			var $form = get_parent_with_tag($(ev.target), "form");
			if($form && $form.find(".inner").length) {
				toggle_search_bar_court_dropdown(true, $form);
				return false;
			}
		}
	}
	// The view that is shown when the user first enters the search bar.
	var DEFAULT_SEARCH_VIEW = "query_builder";

	$search_bar
		.find(".search_tabs_dropdown .tabs li").click(function _click_tab() {
			// When the user clicks a search bar tab.
			var $this = $(this);
			if($this.hasClass("disabled")) {
				return;
			}
			var type = $this.attr('for');
			searchbar_show_dropdown($search_bar, type);
			return false;
		}).end()
		.find("i.close").click(function _close_search_dropdown() {
			toggle_search_bar_court_dropdown(false, $search_bar);
			return false;
		}).end()
		.find(".inner textarea")
		// Event handling for the main search bar text area.
			.on("input", function _on_search_bar_input() {
				check_grow($(this));
			})
			.keydown(debouncer(get_suggest_handler(null, get_court_context,
				$search_bar.find(".suggestions"), null, null, keydown_handler), 300))
			.focus(function _textarea_focus() {
				var $this = $(this);
				check_grow($this);
				var no_dropdown = $this.prop("no_dropdown");
				if (no_dropdown) {
					$this.removeProp("no_dropdown");
				} else if($this.is(":focus")) {
					searchbar_show_dropdown($search_bar, DEFAULT_SEARCH_VIEW);
				}
			}).blur(function _textarea_blur() {
				check_grow($(this));
			})
		.end()
		.find(".suggestions").bind('cssClassChanged', function _suggest_change() {
			var $t = $(this);
			if($t.hasClass("autocomplete") && $t.find(".set").length) {
				if(!searchbar_isactive_dropdown($search_bar, "suggestions")) {
					searchbar_show_dropdown($search_bar, "suggestions");
				}
			} else {
				if(searchbar_isactive_dropdown($search_bar, "suggestions")) {
					$search_bar.find(".tabs [for='suggestions']").hide();
					searchbar_show_dropdown($search_bar, DEFAULT_SEARCH_VIEW);
				}
			}
		}).end()
		.submit(function _check_submit_search_engine(ev) {
			// Make sure the query is not too long.
			var f_len = 0;
			$(ev.target).find("[name]:enabled").each(function _chk_targ_part() {
				f_len += encodeURIComponent($(this).val().toString()).length +
					encodeURIComponent($(this).attr('name')).length;
			});
			// The GAE limit 2048
			if(f_len > 1950) {
				show_error_usermsg("Your query is too large (" + 
					f_len.toString() + " letters). " +
					"Shorten it and search again.");
				ev.preventDefault();
				return false;
			}
			var search_form = document.querySelector(".search_engine_form");
			$(this).find(".selected_court").addClass("loading");
		});
	
	var SCROLL_DEBOUNCE = 100;
	var MIN_SCROLL = 50; // Always show the scroll bar below here.
	var last_scroll = 0;
	var last_scroll_time = null;
	var bd_div = document.getElementById('bd');
	$(document).scroll(function() {
		var cur_scroll = $(document).scrollTop();
		// Don't update so often, otherwise it can cause jittery effects.
		var body_start = bd_div ? bd_div.getBoundingClientRect().top : 0;
		if(cur_scroll > MIN_SCROLL && last_scroll_time && 
				new Date() - last_scroll_time < SCROLL_DEBOUNCE) {
			// But do update scroll_past_body
			$("body").toggleClass("scroll_past_body", body_start <= 0);
			return;
		}
		if (cur_scroll > MIN_SCROLL && cur_scroll > last_scroll) {
			$("body")
				.addClass("scroll_down")
				.removeClass("scroll_up")
				.toggleClass("scroll_past_body", body_start <= 0);
		} else if (cur_scroll < last_scroll) {
			$("body")
				.removeClass("scroll_down")
				.addClass("scroll_up")
				.toggleClass("scroll_past_body", body_start <= 0);
		} else {
			$("body")
				.removeClass("scroll_down")
				.removeClass("scroll_up")
				.toggleClass("scroll_past_body", body_start <= 0);
		}
		last_scroll = cur_scroll;
		last_scroll_time = new Date();
	});
}

function searchbar_show_dropdown($search_bar, type) {
	var $tabs = $search_bar
		.find(".search_tabs_dropdown")
			.addClass("shown")
			.find(".tabs li.selected").removeClass("selected").end()
			.find(".tabs li[for='" + type + "']").addClass("selected").end()
			.find(".tab").hide().end()
			.find(".tab." + type).show().end();
	if(type == 'search_helper') {
	} else if(type == "query_builder") {
	} else if(type == "suggestions") {
		$tabs.find(".tabs [for='suggestions']").show();
	} else if (type =='court_chooser') {
		// Add a re-entry checker.
		setup_court_chooser($search_bar, function () {
			toggle_ptab_submenu(true);
			// Add a timeout to wait until after the animation completes.
			setTimeout(function () {
				$search_bar.find(".selected_court input[type=text]")
					.first().focus();
			}, 300);
		});
	} else {
		throw ("Unknown dropdown to show: " + type);
	}
}
function searchbar_isactive_dropdown($search_bar, type) {
	var $dropdown = $search_bar.find(".search_tabs_dropdown");
	if(!$dropdown.hasClass("shown")) {
		return false;
	}
	if(type) {
		var $sel = $dropdown.find(".tabs li.selected");
		if(!$sel.length || $sel.attr('for') != type){
			return false;
		}
	}
	return true;
}
function searchbar_hide_dropdown(force_hide, $el) {
	if(!$el) {
		$el = $(".search_tabs_dropdown")
	} else if(!$el.hasClass("search_tabs_dropdown")) {
		if($el.parents(".search_tabs_dropdown").length) {
			$el = $el.parents(".search_tabs_dropdown");
		} else {
			$el = $(".search_tabs_dropdown")
		}
	}
	var had_class = $el.hasClass("shown");
	$el.removeClass('shown');
	if(had_class) {
		// After closing the dropdown, give focus back to textarea so user can
		// continue with query. But only do so if it was actually closed.
		// Add a timeout to wait until after the animation completes.
		setTimeout(function () {
			if(!$el.hasClass("shown") &&
				!$(".search_sub_select").is(":visible")) {
				$el.parents(".search_engine_form").find("textarea").first().prop('no_dropdown', true).focus();
			}
		}, 300);
	}
}


/**
 * Get the current URL hash value.
 * @returns {any}
 */
function get_url_hash() {
	var hashloc = location.href.search("#");
	return hashloc > 0 ? location.href.substring(hashloc+1):null;
}

/**
 * Returns a keydown handler that handles autocompletes analytics requests.
 * When selected, the user will go to a analytics page of the entity. See
 * further below for a variation on this function that only makes
 * suggestions, and does not change the page when clicked.
 * @param entity if set, returns suggestions only for the given entity.
 * @param cur_court_context A function or string, that sets the context of 
							the suggestion, i.e., PTAB, ITC, etc.
 * @param get_suggest_div 	Function that returns the suggestion div.
 * @param selection_required If true, at least one item will be selected.
 * @param custom_formatter 	Optional function that takes formats the suggestions
							into HTML. Takes null if there is no suggestion.
 */
var suggest_supported = true;
var debounce_delay = 2000;
function get_suggest_handler(entity, court_context, get_suggest_div, selection_required, custom_formatter, keydown_handler, replace_div) {
	if (!get_suggest_div) {
	get_suggest_div = function($this) {
		return get_parent_with_class($this, "search_engine_form").find(".search_helper");
	};
	}
	if (!replace_div) {
	replace_div = $("textarea[name=q]");
	}

	// Store the debounced function outside the handler so it persists between calls
	var debouncedAjaxCall = debouncer(function(ev, $this, helper, $suggestions) {
	var text = $this.val();
	
	if (!text.strip().length || !suggest_supported) {
		helper.removeClass("autocomplete");
		$suggestions.html(custom_formatter ? custom_formatter(null) : "");
		return;
	}

	var cur_entity = typeof entity == "function" ? entity() : entity;
	var cur_court_context = typeof court_context == "function" ? court_context() : court_context;
	
	helper.addClass("loading");
	$.ajax({
		cache: true,
		dataType: "json",
		url: "/search/getsuggest.ajax",
		data: {
		text,
		entity: cur_entity,
		court_context: cur_court_context,
		args: get_url_hash()
		}
	}).success(function(resp) {
		helper.removeClass("loading");
		if (text != $this.val() || !resp.success) {
		return;
		}
		if (resp.suggestions_not_supported) {
		suggest_supported = false;
		return;
		}
		
		var html = custom_formatter ? custom_formatter(resp.suggestions) : resp.suggestions.map(function(t) {
		var options = t.options.map(function(o) {
			if (o.cursor) {
			return "<a class='suggestion cursor' href='#' data-cursor='" + o.cursor + "'>" + o.text + "</a>";
			}
			return "<a class='suggestion' href='" + o.link + "'>" + o.text + "</a>";
		}).join(" ");
		var title = t.title ? "<div class='title'>" + t.title + "</div>" : "";
		return "<div class='set'><div class='name'>" + t.name + "</div><div class='options'>" + title + options + "</div></div>";
		}).join(" ");
		helper.addClass("autocomplete");
		var replaced_query = null;
		$suggestions.html(html).toggleClass("entity_suggest", cur_entity !== void 0).find(".suggestion").hover(function() {
		helper.find(".suggestion").removeClass("selected");
		$(this).addClass("selected");
		}).bind("cssClassChanged", function() {
		if ($(this).hasClass("selected")) {
			var cursor = $(this).data("cursor");
			if (cursor) {
			if (!replaced_query) {
				replaced_query = replace_div.val();
			}
			replace_div.val($(this).text()).selectRange(cursor);
			} else if (replaced_query) {
			replace_div.val(replaced_query);
			replaced_query = null;
			}
		}
		});
		
		if (selection_required) {
		var sel = selected();
		if (sel.$selected === null) {
			$(sel.$[0]).addClass("selected");
		}
		}
	});
	}, debounce_delay);

	return function handle_suggest(ev) {
	var $this = $(this);
	var helper = typeof get_suggest_div == "function" ? get_suggest_div($this) : get_suggest_div;
	var $suggestions = helper.find(".suggestions").length ? helper.find(".suggestions") : helper;

	function selected() {
		var $sug = helper.find(".suggestion");
		for (var i = 0; i < $sug.length; i++) {
		if ($($sug[i]).hasClass("selected")) {
			return { $: $sug, selected_i: i, $selected: $($sug[i]) };
		}
		}
		return { $: $sug, selected_i: null, $selected: null };
	}

	// Handle navigation keys immediately
	if (keydown_handler && keydown_handler(ev, selected().$selected) === false) {
		ev.preventDefault();
		return false;
	}

	var sel = null;
	switch (ev.which) {
		case 38: // UP
		sel = selected();
		if (sel.$selected === null) {
			$(sel.$[sel.$.length - 1]).addClass("selected");
		} else {
			sel.$selected.removeClass("selected");
			$(sel.$[(sel.selected_i - 1 + sel.$.length) % sel.$.length]).addClass("selected");
		}
		return;
		case 40: // DOWN
		sel = selected();
		if (sel.$selected === null) {
			$(sel.$[0]).addClass("selected");
		} else {
			sel.$selected.removeClass("selected");
			$(sel.$[(sel.selected_i + 1) % sel.$.length]).addClass("selected");
		}
		return;
		case 13: // ENTER
		sel = selected();
		sel = sel.$selected && sel.$selected.attr("href");
		if (sel && sel != "#") {
			window.location = sel;
			return;
		}
		break;
	}

	// For all other keys, use the debounced AJAX call
	debouncedAjaxCall(ev, $this, helper, $suggestions);
	};
}

/**
 * Add a dropdown suggester to any text input field.
 * @param $text_input 	The text input field.
 * @param $suggest_div 	A div to store the suggestions. Use SCSS for styling:
 * 							%search_suggestions_window
 * 							%search_suggestions_window
 * @param entity		What entity to suggest (default: "court"). Can be
 * 						party, judge, attorney, firm, or court. Can also be a
 * 						function that takes no args and returns the entity name.
 * 	@param court_context	(Optional) Provide a court context to narrow down
 * 						the possible entities. Options are "PTAB", "TTAB",
 * 						"FederalCourts", and others in search_views.py.
 */
function add_entity_suggestion_to_input($text_input, $suggest_div, entity,
										court_context) {
	// Default to showing court names.
	if(!entity) { entity = "court"; }

	function make_selection($input, cur_entity){
		var val = $input.data(cur_entity);
		if(!val || !val.length) {
			val = $input.text();
		}
		// Be sure to trigger change.
		$text_input.val(val).trigger("change");
		// When selecting a suggestion, close the court search dropdown.
		$suggest_div.hide();
	}

	function court_search_results(results) {
		if(!results) {
			$suggest_div.hide();
			return false;
		}
		$suggest_div.show();
		// Entity might be
		var cur_entity = typeof entity == 'function' ? entity() : entity;
		// We're only interested in the court suggestions.
		var entities = results.filter(function(t) {
			return t.entity == cur_entity;
		});
		// Check if there are no suggestions
		if(!entities || !entities.length) {
			return false;
		}

		var $suggestions = join_jquery(entities[0].options.map(function (t) {
			var v = t.entity || '';
			// Each suggestions has several options, iterate and merge:
			return $("<li class='suggestion'>" + t.text + "</li>").data(cur_entity, v);
		}), "options", "ul")
		.find("li").click(function () {
			make_selection($(this), cur_entity);
			return false;
		}).end();
		return $("<div class='set'></div>").append($suggestions);
	}
	$text_input.keydown(debouncer(get_suggest_handler(
		entity, court_context, $suggest_div, false, court_search_results, null, $text_input),
		100, function _debounce_retval(ev) {
			if(ev.which == 13) {
				// ENTER Key
				// If they press enter while making a selection, we want to
				// do the selection. But if they press enter without a selecting,
				// assume they want to submit the form.
				if($suggest_div.is(":visible")) {
					// The dropdown is visible, see if we've selected anything.
					var $selected = $suggest_div.find(".selected");
					if($selected.length == 1) {
						// Make the selection.
						var cur_entity = typeof entity == 'function' ? entity() : entity;
						make_selection($selected, cur_entity);
						return false;
					}
					return undefined;
				} else {
					// Bubble up to form.
					return true;
				}
			}
			// If the user presses the enter key, we do want it to bubble up.
			return undefined;
	})).end();
}

/**
 * Add a list of suggestions to an autocomplete.
 * @param get_val The text input field with the autocomplete.
 * @param get_suggest_div The div to add the suggestions to.
 * @param get_entity A function that gets the current entity.
 * @param court_context The court context to use.
 * @param max_entities
 * @param url
 */
function add_contained_entities(get_val, get_suggest_div, get_entity,
                                court_context, max_entities, url, success) {
    var text_val = get_val();
    var entity = get_entity();
    var loading_msg = wrap_html("Loading list of " + plural(2, entity));
    var $suggest_div = get_suggest_div();
    $suggest_div.html(loading_msg).addClass("loading");
    // Disable the form from submitting.
    var $inputs = $suggest_div.parents("form").find("input").prop("disabled", true);
    var hard_max_entities = 50;
    if(!max_entities) {
        max_entities = 10;
    }

    // Use the other options to narrow.
    var params = {};
    if(url) {
        var hash = url.split("#")[1] || url.split("?")[1] || url;
        params = $.deparam(hash);
    }

    var data = {
        max_entities : max_entities,
        text : text_val,
        entity : entity,
        court_context : court_context,
        mode : 'query',
        date_filed_start: params.date_filed_start,
        date_filed_end: params.date_filed_end,
        f : params.f
    };
    $.ajax({
        cache: true,
        dataType: "json",
        url: "/search/getsuggest.ajax",
        data: $.param(data, true),
    }).success(function(resp) {
    	$suggest_div = get_suggest_div()
        $suggest_div.removeClass("loading");
        $inputs.prop("disabled", false);
        if(get_val() != text_val || get_entity() != entity) {
            // out of date.
            return;
        }
        if(!resp.success || resp.suggests_not_supported) {
            $suggest_div.text(resp.error);
            return;
        }
        // Clear the existing div.
        $suggest_div.html("");
        if(resp.suggestions.length != 1) {
            if(success) {
                success(resp.suggestions);
            }
            return;
        }
        var suggests = resp.suggestions[0];
        if(suggests.entity != entity) {
            return;
        }
        var items = suggests.options.map(function (opt) {
            var id = uniqueid();
            var count = opt.count ? wrap_html(number_with_abbrev(opt.count),
                "span", "count") : "";
            var label = wrap_html(escape_html(opt.entity) + count, "label",
                "", {}, {for : id});
            var only = suggests.options.length > 2 ?
                wrap_html("only", "a", "show_only") : "";
           var chkbox = "<input type=checkbox checked class='entity_exact' name='" + escape_html(opt.entity) + "' id='" + id + "'>";
           return wrap_html(chkbox + label + only, "li");
        }).join("");
        var extra_options = '';
        // Add a checkbox allowing them to limit results to exact matches.
        if(suggests.options.length >= max_entities) {
            var load_more = max_entities < hard_max_entities ?
                wrap_html(wrap_html("", "i", "far fa-plus-square") +
                    "Load More", "a", "load_more") : "";
            extra_options += load_more;
        }
        if(suggests.options.length > 1) {
            var id = uniqueid();
            var limit_check = wrap_html(
                "<input type=checkbox class='only_entity_exact' id='" + id + "'>" +
                wrap_html("Limit to exact " + plural(2, entity) + " above.", "label", "", {}, {for : id}),
            "div", "limit_check");
            extra_options += limit_check;
        }
        if(extra_options.length) {
            extra_options = wrap_html(extra_options, "div", "extra_options");
        }

        var ul_list = wrap_html(items, 'ul');
        var title = wrap_html("Confirm " + plural(2, entity) +
            " to include in analytics:", "div", "explain");
        $suggest_div.html(title + ul_list + extra_options).show()
            .find(".load_more").click(function () {
                max_entities = Math.min(max_entities*2, hard_max_entities);
                add_contained_entities(get_val, get_suggest_div, get_entity, court_context, max_entities, url, success);
                return false;
            }).end()
        .find(".show_only").click(function () {
            var $this = $(this);
            $suggest_div
                .find("input.entity_exact[type=checkbox]").prop("checked", "").end()
                // Default to exact search when they select show only.
                .find("input.only_entity_exact[type=checkbox]").prop("checked", true).end();
            $this.parents("li").first().find("input.entity_exact[type=checkbox]").prop("checked", true);
            if(success) {
                success(resp.suggestions);
            }
            return false;
        }).end();
        if(success) {
            success(resp.suggestions);
        }
    });
}

/**
 * Given a set of checkboxes in an entity selector, return the query that should be applied.
 * @param $suggest_div The div containing the checkboxes.
 * @param orig_val Original value of query.
 * @returns {string|string|*}
 */
function contained_entities_to_query($suggest_div, orig_val) {
    // Determine if they are limiting to a set of party names.
    var limit_checked = $suggest_div.find(".limit_check input[type=checkbox]:checked").length;

    // Get the checked if limiting, or the unchecked if not.
    var vals = $suggest_div.find(limit_checked ? "li input[type=checkbox]:checked" : "li input[type=checkbox]:not(:checked)").map(function () {
        return wrap_query($(this).attr('name'), false, '"');
    }).get();
    var joined_vals = wrap_query(vals.length ? vals.join(" OR ") : "", vals.length > 1);

    // Create the query from the joined values.
    return vals.length && limit_checked ? joined_vals:
        vals.length && !limit_checked ? orig_val + " AND NOT " + joined_vals:
            orig_val;
}

/**
 * Convert a url query string into an object. Does some special checks for
 * google webcache.
 * @param url_str
 * @returns {{}}
 */
function url_params_to_object(url_str) {
	if(!url_str && document.URL.split("?")[0]
			.search(/webcache\.googleusercontent\.com/g) != -1) {
		// When in google's webcache, get the actual query URL. 
		return url_params_to_object($.deparam.querystring().q);
	}
	return url_str == null ? $.deparam.querystring() : $.deparam(url_str, true);
}

/**
 * Convert a URL into a fragment. If the URL has no fragment, returns an empty.
 * @param url_str
 * @returns {string|string}
 */
function url_to_fragment(url_str) {
	var hash = new URL(event.newURL).hash;
	return hash ? hash.substring(1) : "";
}

/**
 * Convert a javascript dictionary object into a URL. The URL will have the
 * same domain and http protocol as the currently loaded page.
 * @param params	A dictionary where k->v will turn into query parameters.
 * @param pathname	A pathname to use. If blank, will use the current path.
 *					To override the protocol or hostname, you can specify it.
 * @returns {string}	A URL.
 */
function url_from_params(params, pathname) {
    // Jquery does most of the work. But set traditional to true otherwise
	// arrays will get messed up.
    var query_str = $.param(params, true);
    // Add the path.
    if(pathname && pathname.search("://") > 0) {
    	// The path has a host protocol already specified, so use it.
        return pathname + "?" + query_str; 
    }
    // Add the correct protocol.
    return location.protocol + "//" + location.host + 
                (pathname ? pathname : location.pathname) + "?" + query_str; 
}

function toggle_search_bar_court_dropdown(force, parent) {
	// Shows and hides the search bar dropdown
	// First find the full search bar.
	var $search_bar = $(parent || ".search_engine_form");
	if (!$search_bar.hasClass("search_engine_form")) {
		$search_bar = $search_bar.parents(".search_engine_form");
		if(!$search_bar.length) {
			console.log("Could not find search bar");
			return false;
		}
	}
	var $dropdown = $search_bar.find(".court_dropdown");
	if(!$dropdown.length) {
		console.log("Cannot find dropdown");
		return false;
	}
	// Get the dropdown inner. We expect the HTML to be well formed.
	var $inner = $search_bar.find(".inner");
	if(!$inner.length) {
		console.log("Expecting the parent of dropdown to be a search inner!");
		return;
	}
	
	var was_visible = searchbar_isactive_dropdown($search_bar, "court_chooser");
    if(force === false || (was_visible && force !== true)) {
		// Hide it
		searchbar_hide_dropdown(true, $dropdown);
		return;
    }
	// Show it.
	$search_bar = $dropdown.parents(".search_engine_form");
	if ($dropdown.hasClass("court_chooser")) {
		// Initialize the court chooser, then show.
		setup_court_chooser($search_bar, function () {
			searchbar_show_dropdown($search_bar, "court_chooser");
			toggle_ptab_submenu(true);
			$dropdown.show();
			// Add a timeout to wait until after the animation completes.
			setTimeout(function () {
				$inner.find(".selected_court input[type=text]").focus();
			}, 300);
		});
	} else {
        // Simply show it
        $dropdown.show();
    }
}

/**************************
 * Tree Selector
 * A data structure used to assist with selecting and unselecting objects
 * stored in a tree.
 **/
var TreeSelector = function _TreeSelector(tree) {
	this.tree = tree;
	this.selected = [];
};
/**
 * Return the keys of an object or values in an array ass a list
 */
TreeSelector.prototype.get_keys = function(ar_or_obj) {
	if(Array.isArray(ar_or_obj)) {
		return ar_or_obj;
	}
	var keys = [];
	for(var k in ar_or_obj) {
		keys.push(k);
	}
	return keys;
};

/**
 * Compare two arrays. 
 * Return true if equal.
 * Return 1 if first starts with second.
 * Return -1 if second starts with first.
 */
TreeSelector.prototype.compareArray = function(ar1, ar2) {
	for(var i = 0; i < ar1.length && i < ar2.length; i++) {
		if(ar1[i] != ar2[i]) {
			return false;
		}
	}
	return ar1.length == ar2.length ? true : 
		ar1.length > ar2.length ? 1 :
		ar1.length < ar2.length ? -1:
		false;
};

/**
 * Returns true if the given set of keys is selected.
 * Returns 1 if one of its children is selected.
 * Otherwise return false.
 **/
TreeSelector.prototype.isSelected = function(keys) {
	for(var i = this.selected.length - 1; i >= 0; i--) {
		var cmp = this.compareArray(keys, this.selected[i]);
		if(cmp == true || cmp == 1) {
			return true;
		} else if(cmp == -1) {
			return 1;
		}
	}
	return false;
};

TreeSelector.prototype.isIn = function(ar, array_list) {
	for(var i = 0; i < array_list.length; i++) {
		if(this.compareArray(ar, array_list[i]) === true) {
			return true;
		}
	}
	return false;
};
/**
 * Get the value at the node specified by keys.
 **/
TreeSelector.prototype.get = function(keys) {
	var groups = this.tree;
	for(var i = 0; i < keys.length; i++) {
		if(Array.isArray(groups)) {
			return null;
		}
		groups = groups[keys[i]];
	}
	return groups;
};

/**
 * Get the path to the value. Note that this is O(N).
 */
TreeSelector.prototype.find = function(value) {
	function search(node) {
		if(Array.isArray(node)) {
			return node.indexOf(value) == -1 ? null : [value];
		}
		for(var k in node) {
			var s = search(node[k]);
			if(s != null) {
				// We found the value.
				return [k].concat(s);
			}
		}
		return null;
	}
	return search(this.tree);
};

/**
 * Return an array of arrays, where each array lists the keys to a child node.
 */
TreeSelector.prototype.children = function(keys) {
	var parent_path = [];
	var groups = this.tree;
	for(var i = 0; i < keys.length; i++) {
		var p = keys[i];
		if(Array.isArray(groups)) {
			return [];
		} else {
			groups = groups[p];
			parent_path.push(p);
		}
	}
	// Now add the parent path into the name.
	return this.get_keys(groups).map(function (x) {
		return parent_path.concat([x]);
	});
};

/**
 * Clear the selection.
 */
TreeSelector.prototype.clear = function() {
	this.selected = [];
};

/**
 * Add a new selection. If the seletion is in the tree, and caused an entire 
 * set of leafnodes to fill up, then it will remove all the children and add 
 * the parent.
 * If the item is not in the tree, that's okay, it can still be selected, but 
 * the selection will not modify the tree state.
 */
TreeSelector.prototype.add = function(keys) {
	// Remove all items that start with this item.
	for(var i = this.selected.length - 1; i >= 0; i--) {
		var cmp = this.compareArray(this.selected[i], keys);
		if(cmp == true || cmp == 1) {
			this.selected.splice(i, 1);
		}
	}
	// Add this selection.
	this.selected.push(keys);
	var _this = this;
	
	function check_compact_children(parent_keys) {
		// If we added all children under a parent, then we need to remove the
		// children from the list and add the parent.
		var group = _this.tree;
		for(var p_i = 0; p_i < parent_keys.length; p_i++) {
			group = group[keys[p_i]];
			if(!group) {
				// The item is not in the tree. 
				return;
			}
		}
		var siblings = _this.get_keys(group).map(function(x) {
			return parent_keys.concat([x]);
		});
		for(var s_i = 0; s_i < siblings.length; s_i++) {
			if(!_this.isIn(siblings[s_i], _this.selected)) {
				// This court is not in the selected index, no need to compact.
				return;
			}
		}
		// We need to remove all elements that start with parent_keys.
		for(var i = _this.selected.length - 1; i >= 0; i--) {
			var cmp = _this.compareArray(_this.selected[i], parent_keys);
			if(cmp === true || cmp === 1) {
				_this.selected.splice(i, 1);
			}
		}
		_this.selected.push(parent_keys);
		// We may need to compact again
		if(parent_keys.length) {
			check_compact_children(parent_keys.slice(0, -1));
		}
	}
	check_compact_children(keys.slice(0, -1));
};

/**
 * Remove the given selection.
 */
TreeSelector.prototype.remove = function(keys) {
	// Remove the item and all of the children items.
	var removed_exact = false, removed_partial = [];
	for(var i = this.selected.length - 1; i >= 0; i--) {
		var cmp = this.compareArray(keys, this.selected[i]);
		if(cmp === true) {
			this.selected.splice(i, 1);
			removed_exact = true;
		} else if(cmp == 1) {
			removed_partial.push(this.selected[i]);
			this.selected.splice(i, 1);
		} else if(cmp == -1){
			console.log("Invalid state");
			this.selected.splice(i, 1);
		}
	}
	// If removing a child caused a parent to become indeterminate, 
	// add the other children.
	var _this = this;
	function add_children(parent_court) {
		var courts = _this.children(parent_court);
		for(var j = 0; j < courts.length; j++) {
			var cmp = _this.compareArray(keys, courts[j]);
			if(cmp === true) {
				; // Don't add the one we're removing.
			} else if(cmp == 1) {
				// Make a recursive call and add the children of this node.
				add_children(courts[j]);
			} else if(cmp === false) {
				// We can add the node and only this node.
				_this.selected.push(courts[j]);
			}
		}
	}
	for(var r_i = 0; r_i < removed_partial.length; r_i++) {
		add_children(removed_partial[r_i]);
	}
};

/**
 * Return a list of items to include and exclude. This list can be 
 * signifigantly smaller than items solely to include.
 **/
TreeSelector.prototype.selected_simplified = function() {
	// Group the seleted items by their parents.
	var parents = {};
	for(var t_i = 0; t_i < this.selected.length; t_i++) {
		var t = this.selected[t_i];
		// Get this parent. The root will be an empty array.
		var p_i = JSON.stringify(t.slice(0, -1));
		if(parents[p_i]) {
			parents[p_i].push(t);
		} else {
			parents[p_i] = [t];
		}
	}
	var selected = [];
	// Now go through the parents.
	for(var p in parents) {
		var parent_keys = JSON.parse(p);
		var children = this.children(parent_keys);
		// If roots, we need to include all.
		var are_roots = parent_keys.length == 0;
		if(are_roots || parents[p].length < children.length / 2) {
			// If including fewer than half the children, include them all.
			selected.push({
				include : parents[p],
				exclude : [],
			})
		} else {
			// It is more efficient to include the parent and exclude subitems.
			selected.push({
				include : [parent_keys],
				exclude : []
			});
			var p_include = {};
			// Make a set of the items we're including.
			for(var i = 0; i < parents[p].length; i++) {
				p_include[JSON.stringify(parents[p][i])] = true;
			}
			// Now iterate through all children.
			for(var c_i = 0; c_i < children.length; c_i++) {
				var c = children[c_i];
				// See if it isn't supposed to be included.
				if(!p_include[JSON.stringify(c)]) {
					// Exclude this one.
					selected[selected.length - 1].exclude.push(c);
				}
			}
		}
	}
	return selected;
};

// This will be calculated below.
var global_courts_selected = null;

/**
 * The court chooser is pretty complex, set things up here
 */
function setup_court_chooser($search_bar, onComplete) {
	// Find the elements we'll be working with.
	var $chooser = $search_bar.find(".court_chooser");
	var $inner = $search_bar.find(".inner");
	if(!$inner || !$inner.length) {
		throw "No search bar specified to setup";
	}
	if(!$chooser.length){
		throw "No court chooser specified to setup";
	}
	
	// Prevent reentry.
	if($chooser.data("chooser-init")) {
		if(onComplete) {
			onComplete($chooser);
		}
		return;
	}
	$chooser.data("chooser-init", 1);

	// We have a font set for representing states. We can use them here.
	var state_fonts = {
		"AL": "B", "AK": "A", "AZ": "D", "AR": "C", "CA": "E", "CO": "F", 
		"CT": "G", "DE": "H", "DC": "y", "FL": "I", "GA": "J", "HI": "K", 
		"ID": "M", "IL": "N", "IN": "O", "IA": "L", "KS": "P", "KY": "Q", 
		"LA": "R", "ME": "U", "MD": "T", "MA": "S", "MI": "V", "MN": "W", 
		"MS": "Y", "MO": "X", "MT": "Z", "NE": "c", "NV": "g", "NH": "d", 
		"NJ": "e", "NM": "f", "NY": "h", "NC": "a", "ND": "b", "OH": "i", 
		"OK": "j", "OR": "k", "PA": "l", "RI": "m", "SC": "n", "SD": "o", 
		"TN": "p", "TX": "q", "UT": "r", "VT": "t", "VA": "s", "WA": "u", 
		"WV": "w", "WI": "v", "WY": "x", "US": "z"
	};
	/**
	 * Get the full court list via cache or ajax asynchronously.
	 **/
	function get_court_list(onHasCourtList) {
		// Load the state icons if we have not done so already.
		if(!$("link.states").length) {
			$('<link class="states" href="/site_media/css/states.css" ' +
				'rel="stylesheet" type="text/css" />').appendTo("head");
		}
		
		var key = "da_court_list_3";
		var court_list = sessionGet(key, true);
		if(court_list) {
			onHasCourtList(court_list);
		} else {
			// Get a list of courts.
			$.getJSON("/search_dockets_params.ajax", {}, function (resp) {
				if(resp.success) {
					sessionSet(key, resp, 60*30, true);
					onHasCourtList(resp);	
				} else {
					show_error_usermsg(resp.error);
				}
			});
		}
	}

    /**
	 * When the screen is too small, we need to shrink the height of the
	 * court selector so other parts of the chooser doesn't get cut off.
     */
	function set_court_list_height($ul_parent) {
		if(window.innerHeight > 800) {
			return;
		}
		var $cc = $search_bar.find(".court_chooser");
		var search_height = $cc.height();
		var shown_height = $cc.find(".details:visible").map(function () {
			return $(this).height();
		}).toArray().reduce(function (t, n) {
			return t + n;
		});
		var min_height = search_height - shown_height;
		var new_height = Math.max(80, window.innerHeight - min_height);
		$ul_parent.find(".details > ul").css("max-height", new_height + "px");
	}
	function checkbox_to_path($checkbox, parent_path) {
		var group = $checkbox.data('key');
		if(!group || !group.length) {
			throw "Expecting data for " + $checkbox.attr('id');
		}
		return parent_path.concat([group]);
	}
	function set_checkbox_states(t, $checkboxes, parent_path) {
		if($checkboxes === null) {
			// If checkboxes are null, reset all of them. Start with top level.
			var $topchecks = $chooser.find("ul.court_list_tree > li > input");
			set_checkbox_states(t, $topchecks, []);
			// Close the details panes to invalidate them.
			unexpand($chooser.find(".expanded"));
			return;
		}
		for(var i = 0; i < $checkboxes.length; i++) {
			var $c = $($checkboxes[i]);
			var path = checkbox_to_path($c, parent_path);
			var cmp = t.isSelected(path);
			if(cmp === true) {
				// Set to checked.
				$c.prop("indeterminate", false)
					.prop("checked", true);
			} else if (cmp === 1) {
				// Set to indeterminate.
				$c.prop("checked", false)
					.prop("indeterminate", true);
			} else {
				$c.prop("checked", false)
					.prop("indeterminate", false);
			}
		}
	}

	/**
	 * Get an abbreviated description of the selected courts.
	 * selected: The selected courts.
	 * abbreviations: A dictionary of abbreviations we can use.
	 */
	function get_description(selected, abbreviations) {
		// Generate an inverse abbreviation list for shorter descriptions.
		var rev_abbrev = {};
		for(var abbrev in (abbreviations || {})) {
			rev_abbrev[abbreviations[abbrev]] = abbrev;
		}
		// Prepare a full description.
		var full_desc = selected.map(function (sel) {
			// We don't have much space, so try to use a abbreviations.
			var last_abbrev = rev_abbrev[sel[sel.length-1]];
			if(last_abbrev) {
				// The last term can be abbreviated. Do it.
				return last_abbrev;
			}
			var expanded = sel.map(function (shortened) {
				return abbreviations[shortened] || shortened;
			});
			// Special case state courts.
			if(expanded[0] == "State") {
				if(expanded.length == 2) {
					return expanded[1] + " State";
				} else if (expanded.length >= 4) {
					return expanded[expanded.length - 1];
				}
			}
			// Special case Federal courts.
			if(expanded.length >= 3 && expanded[0] == "Federal") {
				return expanded[expanded.length - 1];
			}
			return expanded.join(", ");
		}).join(" | ");
		if(full_desc.length == 0) {
			full_desc = SEARCH_ALL_STR;
		}
		
		// Get a truncated version.
		var truncated = null;
		if(full_desc.length > 30) {
			truncated = '';
			var f_split = full_desc.split(" ");
			for(var i = 0; i < f_split.length; i++) {
				truncated += f_split[i] + " ";
				if(truncated.length > 25) {
					truncated += "...";
					break;
				}
			}
		}
		
		return {
			full : full_desc,
			truncated : truncated,
			// Prepare the short description.
			shorter : full_desc.length <= 10 ? full_desc:
				// If it's too long, cite the number of courts.
				selected.length + ' Court' + (selected.length == 1 ? "" : "s")
		};
	}

	/**
	 * Given the selection tree, return a query to find the courts and
	 * optionally, the base query.
	 **/
	function get_url_and_query(t, court_list) {
		// Find all of the queries first.
		var select_queries = [];
		for(var s_i = 0; s_i < t.selected.length; s_i++) {
			var sel = t.selected[s_i];
			var qlist = court_list.queries[sel.toString()];
			select_queries.push(qlist ? qlist : sel[sel.length - 1]);
		}

		// Try doing a url search (eg, /search/PTAB/), because it's cleaner.
		// First get all of the URLs.
		var all_urls = select_queries.map(function (sub_qs) {
			return Array.isArray(sub_qs) ? sub_qs.filter(function (q) {
				return q.url;
			}) : [];
		});
		var has_url = false;
		for(var i = 0; i < all_urls.length; i++) {
			var qs_i = all_urls[i];
			if(!qs_i.length) {
				break;
			}
			for(var j = 0; j < qs_i.length; j++) {
				has_url = qs_i[j];
				for(var k = 0; k < all_urls.length; k++) {
					// Look for this query in the other selected item.
					if(all_urls[k].indexOf(has_url) == -1) {
						has_url = false;
						break;
					}
				}
				if(has_url) {
					// We found one, we can break.
					break;
				}
			}
			if(has_url) {
				break;
			}
		}

		// Now set the form status and attributes.
		var use_query = null;
		if(has_url) {
			// We only use queries with a url component.
			use_query = function (sq_j) { return sq_j.q && sq_j.url; };
			has_url = has_url.url;
		} else {
			// Don't use queries with a url component.
			use_query = function (sq_j) { return sq_j.q && !sq_j.url; };
		}

		function get_query(keys) {
			var sq = court_list.queries[keys] || keys[keys.length - 1];
			if(typeof sq == "string") {
				// Put the court name in quotes. #2455.
				return 'court:("' + sq + '")';
			}
			for(var j = 0; j < sq.length; j++) {
				if(use_query(sq[j])) {
					return "(" + sq[j].q + ")";
				}
			}
			// This can occur if the key should be a url query.
			return null;
		}

		var query = t.selected_simplified().map(function (s) {
			var q = '';
			if(s.include.length) {
				q += s.include.map(get_query).filter(function (sq) {
					return sq && sq.length;
				}).join(" OR ");
			}
			if(s.exclude.length) {
				var excludes = s.exclude.map(get_query).filter(function (sq) {
					return sq && sq.length;
				}).join(" OR ");
				if(excludes.length) {
					if(q.length) {
						q += " AND ";
					}
					q += "NOT (" + excludes + ")";
				}
			}
			return q && q.length ? "(" + q + ")" : "";
		}).filter(function (sq) { return sq && sq.length; }).join(" OR ");
		return {
			url : has_url,
			query : query,
			hash : gen_string_hash((has_url || '') + query)
		}
	}
	
	/**
	 * Set the Selected Court section towards the top of the chooser.
	 */
	function set_selected_court_states(t, $chooser, court_list) {
		var num_courts = t.selected.length;
		if(num_courts == 1 && t.selected.length == 1 && 
				t.selected[0].length == 0) {
			num_courts = 0;
		}
		// Build the selected courts html section.
		var select_html = '';
		for(var i = 0; i < t.selected.length; i++) {
			var name = t.selected[i].join(" | ");
			var key = JSON.stringify(t.selected[i]);
			select_html += '<li data-jsonkey=\'' + key + '\'>' + name + 
				' <a class="close" href="#">&#x2718;</a></li>';
		}
		
		// Get the descriptions.
		var desc = get_description(t.selected, court_list.abbreviations);
		$chooser
			.find(".clear_all").toggleClass("disabled", num_courts == 0)
			.click(function() {
				t.clear();
				set_checkbox_states(t, null);
				set_selected_court_states(t, $chooser, court_list);
				return false;
			}).end()
			.find(".selected_courts")
				.toggle(num_courts > 0)
				.find("ul").html(select_html).end()
				.find("a.close").click(function () {
					var keys = $(this).parent().data("jsonkey");
					t.remove(keys);
					set_checkbox_states(t, null);
					set_selected_court_states(t, $chooser, court_list);
					return false;
				}).end()
			.end()
			// Set the court description.
			.parents(".search_engine_form")
				.find(".selected_court .selected").text(desc.shorter);
		
		// Get the query.
		var query = get_url_and_query(t, court_list);
		// Set the form to the url.
		set_search_bar_form_action(query.url || SEARCH_ALL_STR, null, 
			query.query, desc.full);
		
		// Put the focus on the text box so if they hit enter, it closes.
		get_parent_with_tag($chooser, "form")
			.find(".court_chooser_search").first().focus();
		
		// Save the selected courts in the session data so 
		if((query.query && query.query.length) || query.url) {
			var qkey = "court_choice_" + query.hash.toString();
			sessionSet(qkey, t.selected, null, true);
			sessionSet(qkey + "_description", desc, null, true);
		}
	}
	function unexpand($expanded){
		$expanded.removeClass("expanded");
	}

	var re_num = /^(\d*)(.*)$/;
	function compare_courts(a, b) {
		// Try to extract any numbers in a court.
		var m_a = a.match(re_num);
		var m_b = b.match(re_num);
		// Not sure why, but turning this into a simple return breaks sorting on Chrome.
		var cmp =
			// If the digits are the same, then use normal compare
			m_a[1] == m_b[1] ? m_a[2].localeCompare(m_b[2]):
			// If they both exist, compare the numbers.
			m_a[1] && m_b[1] ? parseInt(m_a[1]) - parseInt(m_b[1]):
			// Otherwise, numbers come first.
			m_a[1] ? 1:
			m_b[1] ? -1:
			// We shouldn't get here.
			0;
		return cmp;
	}

	/**
	 * Setup the details pane within one of the courts. Only triggered if
	 * one of the parents is clicked on by the user.
	 **/
	function setup_details(t, court_list, $parent, path) {
		// Remove all instances of expanded.
		unexpand($parent.parent().find(".expanded"));
		// Start building the details.
		var html_details = '';
		if(path.length > 1) {
			html_details += "<a href='#' class='back'>&lt; Back</a> ";
		}
		// Build the breadcrumbs.
		html_details += "<div class='breadcrumb'>";
		for(var i = 1; i < path.length; i++) {
			var name = path[i];
			if(court_list.abbreviations[name]) {
				name = court_list.abbreviations[name];
			}
			// Try to generate a font for the state as a visual cue.
			var state_font = state_fonts[path[i]];
			if(state_font) {
				state_font = "<span class='state' " + 
					"style='font-family: StateFaceRegular;'>" + state_font + 
					"</span> ";
			} else {
				state_font = "";
			}
			if(i > 0 && i < path.length - 1) {
				html_details += "<a href='#' class='crumb' data-idx='" + i + 
					"'>" + state_font + name + "</a> &gt; ";
			} else {
				html_details += state_font + name + " ";
			}
		}
		html_details += "</div><ul>";

		// Get the selected group and it's parent.
		var selected_group = t.get(path);
		if(Array.isArray(selected_group)) {
			for(var g_i=0; g_i < selected_group.length; g_i++) {
				var g = selected_group[g_i];
				var user_k = (court_list.user_facing && 
					court_list.user_facing[g]) || g;
				var g_id = uniqueid();
				html_details += "<li class='courts'><input id='" + g_id +
					"' type='checkbox' data-key='" + g + "'><label for='" +
					g_id + "'>" + user_k + "</li>";
			}
		} else {
			var keys = [];
			for(var sel_k in selected_group) {
				keys = keys.concat([sel_k]);
			}
			keys.sort(compare_courts);
			for(var k_i=0; k_i < keys.length; k_i++) {
				var k = keys[k_i];
				var id = uniqueid();
				html_details += "<li class='subgroup'><input id='" + id +
					"' type='checkbox' data-key='" + k + "'><label for='" + 
					id + "'><a href='#' class='subgrouplink'>" + k + 
						" &gt;</a></label></li>";
			}
		}
		
		html_details += "</ul>";
		var cur_path = path.slice();
		$parent.addClass("expanded")
			.find(".details").html(html_details)
			.find(".back").click(function () {
				setup_details(t, court_list, $parent, cur_path.slice(0, -1));
				return false;
			}).end()
			.find(".crumb").click(function () {
				var subgroup_idx = parseInt($(this).data("idx"));
				setup_details(t, court_list, $parent, 
					cur_path.slice(0, subgroup_idx + 1));
				return false;
			}).end()
			.find(".subgrouplink").click(function () {
				var subgroup = $(this).parent().parent()
					.find("input").data("key");
				setup_details(t, court_list, $parent, 
					cur_path.concat([subgroup]));
				return false;
			}).end()
			.find("input").change(function () {
				var click_path = checkbox_to_path($(this), cur_path);
				if($(this).is(":checked")) {
					t.add(click_path);
				} else {
					t.remove(click_path);
				}
				// Reset the top level checkbox.
				set_checkbox_states(t, $parent.find("> input[type=checkbox]"), []);
				set_selected_court_states(t, $chooser, court_list);
			}).end();
		// Set the height after we've setup the UI.
		set_court_list_height($parent);
		set_checkbox_states(t, $parent.find(".details input[type=checkbox]"), path);
		set_selected_court_states(t, $chooser, court_list);
		$chooser.trigger('details_changed', [path, $parent, t, court_list]);
		return false;
	}
	
	var extra_top_level_html = {
		'Federal' : '<a class="extra" ' +
			'data-powertiptarget="fedcourts_tip" ' +
			'href="/search/supplemental/#search_type=federal">supplemental search</a>',
		'State' : '<a class="extra" ' +
			'data-powertiptarget="fedcourts_tip" ' +
			'href="/search/supplemental/#search_type=all_courts">' +
				'supplemental search</a>',
		'Patent' : '<a class="extra ptabsubmenu" href="#" ' + 
			'data-powertiptarget="ptabsubmenu_tip" ' +
			'onclick="toggle_search_bar_court_dropdown(false); ' +
			'toggle_ptab_submenu(); return false;">' + 
			'more research options</a>',
		'International' : '<a class="extra" ' +
			'data-powertiptarget="fedcourts_tip" ' +
			'href="/search/supplemental/#search_type=international_courts">' +
				'supplemental search</a>',
	};
	
	var still_loading = true;
	// We may make an ajax call here. Setup a loader if it'll take time.
	setTimeout(function () {
		if(still_loading) {
			get_parent_with_tag($chooser, "form")
				.find(".selected_court").addClass("loading");
		}
	}, 50);
	
	// Get the court list  and then perform most of the setup once we have it.
	get_court_list(function (court_list) {
		//////
		// Turn off the loader.
		still_loading = false;
		get_parent_with_tag($chooser, "form")
			.find(".selected_court").removeClass("loading");
		
		//////
		// Initialize the tree data.
		// Start by sorting the list of keys.
		var group_list = [];
		for(var k in court_list.grouped) {
			group_list.push(k);
		}
		group_list.sort();
		var t = new TreeSelector(court_list.grouped);
		// Build the html for the main court tree.
		var html = '';
		group_list.forEach(function(k) {
			var id = escape_html(uniqueid());
			k = escape_html(k);
			html += "<li class='group' id='" + uniqueid() + "'><input id='" + 
				id +  "' type='checkbox' data-key='" + k + "'><label for='" + 
				id + "'>" + k + "</label>" +
				(extra_top_level_html[k] || '') +
				"<i class='all fas fa-chevron-right'></i>" +
				"<div class='details'></div></li>";
		});
		// If there is global courts selected, add them here.
		$chooser
			.find("ul.court_list_tree").html(html)
			.find("[data-powertiptarget]").powerTip({smartPlacement:true}).end()
			.find(".all").click(function () {
				if($(this).parent().hasClass("expanded")) {
					// Close
					unexpand($(this).parent());
					return false;
				}
				var court_group = $(this).parent().find("input").data("key");
				setup_details(t, court_list, $(this).parent(), [court_group]);
				return false;
			}).end()
			.find("input").change(function () {
				var click_path = checkbox_to_path($(this), []);
				if($(this).is(":checked")) {
					t.add(click_path);
				} else {
					t.remove(click_path);
				}
				set_checkbox_states(t, 
					$(this).parent().find(".details input[type=checkbox]"), 
					click_path);
				set_selected_court_states(t, $chooser, court_list);
			}).end().end()
			.find(".done").click(function() {
				var $form = get_parent_with_tag($(this), "form");
				toggle_search_bar_court_dropdown(false, $form);
				return false;
			}).end();
		if(global_courts_selected && global_courts_selected.length) {
			for(var c_i = 0; c_i < global_courts_selected.length; c_i++) {
				t.add(global_courts_selected[c_i]);
			}
			set_checkbox_states(t, null);
		}
		set_selected_court_states(t, $chooser, court_list);
		
		//////
		// Setup the court suggestion bar.
		var $court_list_search_results = $chooser.find(".court_list_search");
		function select_result(selected_li) {
			var path = t.find(selected_li);
			if(!path && court_list.abbreviations[selected_li]) {
				// Try looking it up as an abbreviation.
				path = t.find(court_list.abbreviations[selected_li]);
			}
			// Sometimes "the" is prepended. This is a hack, should be fixed
			// elsewhere. #1601.
			if(!path && selected_li.startsWith("the ")) {
				var abrev = court_list.abbreviations[selected_li.substr(4)];
				if(abrev) {
					path = t.find(abrev)
				}
			}
			if(path) {
				t.add(path);
				set_checkbox_states(t, null);
				set_selected_court_states(t, $chooser, court_list);
			} else if (court_list.queries[selected_li]) {
				// This court is not in our tree view, but we still 
				// know how to run a query to search for it.
				t.add([selected_li]);
				set_selected_court_states(t, $chooser, court_list);
			} else {
				console.log("Problem finding court: " + selected_li);
			}
			$chooser.parents("form.search_engine_form")
				.removeClass("court_suggest_mode")
				// Clear the text area from the search.
				.find(".court_chooser_search").val("");
		}
		function court_search_results(results) {
			var $form = get_parent_with_tag($chooser, "form");
			if(!results) {
				$form.removeClass("court_suggest_mode");
				return '';
			}
			$form.addClass("court_suggest_mode");
			// We're only interested in the court suggestions.
			var courts = results.filter(function(t) { return t.name == 'Court' });
			if(!courts.length) {
				return '';
			}
			return $(courts[0].options.map(function (t) {
				// Each suggestions has several options, iterate and merge:
				return "<li class='suggestion'>" + t.text + "</li>";
			}).join("")).click(function () {
				select_result($(this).text());
				// When selecting a suggestion, close the court search dropdown.
				// toggle_search_bar_court_dropdown(false, $form);
				return false;
			});
		}
		// Key handler for navigating through the search results.
		function keydown_handler(ev, $selected) {
			var $form = get_parent_with_tag($(ev.target), "form");
			switch(ev.which) {
				case 13: // ENTER
					if($selected && $selected.length && $selected.is(":visible")) {
						select_result($selected.text());
						return false;
					}
					toggle_search_bar_court_dropdown(false, $form);
					return false;
				case 27: // ESCAPE
				case 9: // TAB
					toggle_search_bar_court_dropdown(false, $form);
					return false;
				default:
					$form.addClass("court_suggest_mode");
			}
		}
		// Install the court search suggester.
		$chooser.find("input[type=text].court_chooser_search").keydown(
			debouncer(get_suggest_handler(
				"court", null, $court_list_search_results, false,
				court_search_results, keydown_handler), 100,
				function _debounce_retval(ev) {
					// If the user presses the enter key, we don't want it to 
					return ev.which == 13 ? false : undefined;
				}));
		
		//////
		// Populate Recent Courts.
		var MAX_RECENT_COURTS = 5;
		var RECENT_KEY = "court_search_recent_court_list_key";
		var recent_courts = sessionGet(RECENT_KEY, true);
		if(recent_courts) {
			// Generate html for the recent courts.
			var recent_html = '';
			for(var i = 0; i < recent_courts.length; i++) {
				var obj = recent_courts[i];
				var key = JSON.stringify(obj.selected);
				var desc = get_description(obj.selected, 
					court_list.abbreviations);
				var tip = desc.truncated ?
					'data-powertip="' + desc.full + '"' : '';
				recent_html += '<li><a data-jsonkey=\'' + key + '\' href="#" ' +
					tip + '>' + (desc.truncated || desc.full) + '</a></li>';
			}
			$chooser.find(".recent_courts").find("ul").html(recent_html)
				.find("li a").click(function (ev) {
					// Update the data.
					t.selected = $(ev.target).data('jsonkey');
					// Update the UI.
					set_checkbox_states(t, null);
					set_selected_court_states(t, $chooser, court_list);
					// Close the chooser.
					var $form = get_parent_with_tag($(this), "form");
					toggle_search_bar_court_dropdown(false, $form);
					return false;
				}).powerTip({smartPlacement : true}).end().end().show();
		} else {
			$chooser.find(".recent_courts").hide();
		}
		// When the user submits, save the search so we can populate it later.
		get_parent_with_tag($chooser, "form").submit(function () {
			if($chooser.is(":visible")) {
				toggle_search_bar_court_dropdown(false, $(this));
			}
			
			if(!t.selected.length) {
				return;
			}
			var obj = { 
				selected : t.selected,
				hash : gen_string_hash(t.selected.toString()),
				date : (new Date()).toString()
			};
			// Get a fresh copy (could have been changed in another tab.)
			var recent_courts = sessionGet(RECENT_KEY, true) || [];
			// Remvoe this query from the existing list.
			for(var i = recent_courts.length - 1; i >= 0; i--) {
				if (recent_courts[i].hash == obj.hash) {
					recent_courts.splice(i, 1);
				}
			}
			// Add the court to the list.
			recent_courts.unshift(obj);
			// If there are too many, truncate.
			if (recent_courts.length > MAX_RECENT_COURTS) {
				recent_courts.splice(MAX_RECENT_COURTS, 
					recent_courts.length - MAX_RECENT_COURTS);
			}
			// Save it back in the session.
			sessionSet(RECENT_KEY, recent_courts, 60*60*24, true);
		});
		if(onComplete) {
			onComplete($chooser);
		}
	});
}

/**
 * Convert a given court chooser to a coverage graph.
 * Requirements: d3, colorbrewer, rickshaw, font awesome 5.0.
 * Make sure they are included in the base page.
 * @param $chooser
 */
function transform_court_chooser_to_coverage($chooser) {
	var cols = ["Court Name", "Years Covered", "Total Cases", {
			k : "Supported Fields",
			sub_cols : ["Judge", "Firm", "Attorney", "Type", "Status",
				"Contact", "Docs"]
		}, {
			k : "Last 7 Days",
			sub_cols : [
				// "Cases 24h", "Docs 24h",
				"Cases", "Docs"
			]
	}];
	var params = url_params_to_object();
	if(params.admin) {
		cols.push({
            k: 'Last 30 Days',
			sub_cols : [params.admin.search(/get/ig) >= 0 ? "Get" : "Created"]
        });
	}
	var to_key = function _to_key(k) { return k.replaceAll(" ", "_"); };
	var num_cols = 0;
	var first_head_r = cols.map(function _get_col(name, col_i) {
		var has_sub = typeof name != "string";
		var col_name = has_sub ? name.k : name;
		var col_k = to_key(col_name);
		var row_span = has_sub ? 1 : 2;
		var col_span = has_sub ? name.sub_cols.length : 1;
		var sorter = has_sub ? "" :
			"<ul class='sort'><li>Ascending</li><li>Decending</li></ul>";
		num_cols += col_span;
		return "<th rowspan=" + row_span + " colspan=" + col_span +
			" class='" + col_k + "'>" + col_name + sorter + "</th>";
	}).join("");
	var second_head_r = cols.map(function _get_sec_row(name) {
		if(typeof name == "string") {
			return "";
		}
		return name.sub_cols.map(function _sub(sname) {
			var col_k = sname.replaceAll(" ", "_");
			return "<th class='" + col_k + "'>" + sname + "</th>";
		}).join("");
	}).join("");
	var $table = $("<table><thead><tr>" + first_head_r + "</tr>" +
		"<tr class='second'>" + second_head_r +
		"</tr></thead><tbody></tbody></table>");


	function get_query(path, court_list) {
		var comb_path = path.join(",");
		var qs = court_list.queries[comb_path];
		if(qs) {
			for(var q_i=0; q_i<qs.length; q_i++) {
				var q = qs[q_i];
				if(q.q && !q.url) {
					return q.q;
				}
			}
		} else {
			return 'court:"' + path[path.length-1] + '"';
		}
	}

	 var monthNames = ["January", "February", "March", "April", "May", "June",
		  "July", "August", "September", "October", "November", "December"
	 ];

	var widgets = {
		/**
		 * Get the histogram widget.
         * @param doc_aggs
         * @returns {{$cell: (*|jQuery|HTMLElement), afterinsert: _afterinsert}}
         */
		histo : function _histo(doc_aggs) {
			// Come up with a cell with a random id.
			var obj_id= "histo_" + Math.random().toString().replace(".", "");
			var $cell = $("<td class='histo'><div id='" + obj_id + "'>" +
				"<div class='graph'></div></div></td>");
			function conv_data(d) {
				return d.buckets.map(function (d) {
                    return {
                        x: d.key,
                        y: d.doc_count
                    }
                });
			}
			return {
				$cell : $cell,
				// After the cell is inserted, we need to call a setup function.
				afterinsert : function _afterinsert() {
					if(!$cell.is(":visible")) {
						// It disappeared before we could draw it.
						return;
					}
					var data_series = [];
					// There are two series: cases and documents
					if(doc_aggs["0"].sub.Date) {
						data_series.push({
							name : "Cases",
							className : "Cases",
							tooltip : "Cases",
							color : "blue",
							data : conv_data(doc_aggs["0"].sub.Date)
						})
					}
					if(doc_aggs["1"].sub.Date) {
						data_series.push({
							name : "Documents",
							tooltip : "Documents",
							className : "Documents",
							color : "orange",
							data : conv_data(doc_aggs["1"].sub.Date)
						})
					}
					if(data_series.length) {
						var graph = new Rickshaw.Graph({
							width	: 130,
							height	: 30,
							element	: $cell.find(".graph")[0],
							renderer: 'line',
							series	: data_series
						});

						//hover details
						 var hoverDetail = new Rickshaw.Graph.HoverDetail( {
							 graph: graph,
							 xFormatter : function(x) {
								var d = new Date(x);
								return '<div class="date">' +
									monthNames[d.getUTCMonth()] +
									', ' + d.getUTCFullYear() + '</div>';
							 },
							 formatter: function(series, x, val) {
								var swatch = '<span class="detail_swatch ' +
									series.className + '"></span>';
								return swatch + series.tooltip + ": " +
									number_with_commas(val) + '<br>';
							}
						});
						graph.render();
						// Initially hide all tooltips.
						$cell.find(".detail").addClass("inactive");
					}
				}
			};
		},
		amount : function _amount(agg_key, msg) {
			var count = (agg_key && (agg_key.count || agg_key.doc_count)) || 0;
			var amt = number_with_abbrev(count);
			var $cell = $("<td class='amount'>" + amt + "</td>");
			if(amt != count.toString() || msg) {
				if(msg) {
					msg = "There are " + number_with_commas(count) + " " + msg;
				} else {
					msg = number_with_commas(count);
				}
				$cell.data('powertip', msg).powerTip();
			}
			return $cell;
		},
		icon : function _icon(resp, k, fa, val, msg) {
			var count = val !== undefined ? val :
				(resp.aggs[k] && resp.aggs[k].doc_count) || 0;
			var v = !!count;
			var $cell = $("<td class='icon " + k + "'><i class='fas " + fa +
				(v ? "":" disabled") + "'></i></td>");
			if(count) {
				if(!msg) {
					msg = "cases searchable on the " + k + " field."
				}
				$cell.data('powertip', "There are " +
					number_with_commas(count) + " " + msg).powerTip();
			}
			return $cell;
		},
		loader : function _loader() {
			return "<td class='loader' colspan=" + (num_cols-1) +
				"><i class='fas fa-spinner fa-spin'></i> Loading</td>";
		},
		error : function _error(msg) {
			return "<td class='error' colspan=" + (num_cols-1) +
				"><i class='fas fa-error'></i> " + (msg || "Error") + "</td>";
		},
		viewmore : function _viewmore() {
			return "<div class='viewmore'><i class='fas fa-plus'></i>" +
				"<span>Details</span></div>";
		},
	};

	function transform_details(ev, path, $parent, t, court_list) {
		var json_requests = [];
		// Add a new table to the details view.
		$parent.find(".details").append($table.clone());
		// We'll be adding a number of rows to it.
		var $tbody = $(".details table tbody");
		$parent.find("li.courts, .subgroup").each(function _make_row() {
				var $t = $(this);
				var court_key = $t.find("input").data("key");
				var court_full = court_list.abbreviations[court_key] || court_key;
				var query = get_query(path.concat([court_key]), court_list);
				var selected_group = t.get(path.concat([court_key]));
				var $row = $("<tr><td class='" + to_key(cols[0]) +
					"'></td>" + widgets.loader() + "</tr>");
				$t.find("label a").text(court_full).filter(".subgrouplink")
					.append(widgets.viewmore());
            	$t.appendTo($row.find("td:first"));
            	$row = $row.appendTo($tbody);
				var j_filter = { q : query };
				if(params.admin) {
					j_filter.viewargs = "admin-" + params.admin;
				}
            	// Add the row to the request itself to manipulate it later.
				json_requests.push({
					views : ['Coverage'],
					filter : j_filter,
					$row : $row
				});
        });

		function split_doc_buckets(doc_buckets) {
			doc_buckets.filter(function (d) { return d.key == 0 });
			return {
				documents : dock_buckets.length
			}
		}

		get_json_results({
			requests : json_requests,
			base_url : "/analytics/Coverage/",
			// Called when every ajax request finishes, except for the last one.
			on_finished_request : function _on_finished(i, resp, num_finished) {
				var $row = json_requests[i].$row;
				$row.find(".loader").remove().end();
				if(!resp || resp.error){
					$row.append(widgets.error(resp.error));
					return;
				}
				var doc_aggs = agg_to_dict(resp.aggs.Documents, ['0','1']);
				var histo = widgets.histo(doc_aggs), histo2 = null;
				// Need to use appendTo for the histograph to update the query.
				histo.$cell = histo.$cell.appendTo($row);
				// Now add the rest of the widget columns.
				$row.append(widgets.amount(doc_aggs["0"]))
					.append(widgets.icon(resp, 'Judge', 'fa-gavel'))
					.append(widgets.icon(resp, 'Firm', 'fa-briefcase'))
					.append(widgets.icon(resp, 'Attorney', 'fa-user'))
					.append(widgets.icon(resp, 'Type', 'fa-table-cells-large'))
					.append(widgets.icon(resp, 'Status', 'fa-sync-alt'))
					.append(widgets.icon(resp, 'Contact', 'fa-phone',
						undefined, "cases with attorney contact information."))
					.append(widgets.icon(resp, 'Docs', 'fa-file',
						doc_aggs["1"].count, "OCRed and searchable documents."))
					.append(widgets.amount(doc_aggs[0].sub.Create_7d,
						"new cases added in the last 7 days."))
					.append(widgets.amount(doc_aggs[1].sub.Create_7d,
						"new documents added in the last 7 days."));
				if(params.admin) {
					var admin_docs = agg_to_dict(resp.aggs.Documents_Admin, ['0','1']);
					histo2 = widgets.histo(admin_docs);
					histo2.$cell = histo2.$cell.appendTo($row);
					histo2.afterinsert();
				}
				histo.afterinsert();
			},
			// Called when all ajax requests finish.
			on_success : function _on_success(resp) {

			},
			// Called, when one request fails (no success messages will be sent).
			on_fail : function _on_fail(xhr) {
				var error = xhr.getResponseHeader('X-Detailed-Error');
				$tbody
					.find("tr").remove().end()
					.append("<tr></tr>").find("tr").append(widgets.error(error));
			}
		});
	}

	$chooser.addClass("coverage_viewer").on("details_changed", transform_details);
}

/**
 * Sets up the specialized PTAB order searcher.
 **/
function setup_ptab_order_search() {
	var ptab_motions = [
        // 'Improper Communications',
        'Final Written Decision',
        'Motion for Additional Discovery',
        'Motion for Extension of Time',
        'Motion for Joinder',
        'Motion for Observation on Cross-Examination',
        'Motion for Page Extension',
        'Motion for Pro Hac Vice',
        'Motion for Protective Order',
        'Motion for Sanctions',
        'Motion for Supplemental Information',
        'Motion to Accelerate',
        'Motion to Amend Claims',
        'Motion to Bifurcate',
        'Motion to Compel',
        // 'Motion to Correct Clerical Error',
        'Motion to Disqualify',
        'Motion to Exclude',
        'Motion to Expedite',
        'Motion to Expunge',
        'Motion to File Objections',
        'Motion to Limit Claims',
        'Motion to Reassign',
        'Motion to Seal',
        'Motion to Stay',
        'Motion to Strike',
		'Motion to Terminate',
        'Motion to Withdraw',
        'Petition Institution',
        'Rehearing Request',
        'Request for Adverse Judgment',
        'Setting Initial Conference',
	];
	var motion_outcomes = {
		''	: [
				{value:"", desc:"Any outcome"},
				{value:"Granted", desc:"Granted"},
				{value:"Denied", desc:"Denied"},
				{value:"Granted and Denied", desc:"Granted and Denied"},
		],
		"Final Written Decision" : [
			{value:"", desc:"Any outcome"},
			{value:"Granted",	desc:"All Claims Canceled"},
            {value:"Denied", 	desc:"No Claims Canceled"},
            {value:"Granted and Denied", desc:"Some Claims Canceled"},
		]
	};
	// Populate the motion list
	var motion_options = "";
	for(i in ptab_motions) {
		var m = ptab_motions[i];
		motion_options += '<option data-motion="' + m + '" ' + 
				(i==0 ? "selected":"") + '>' + m + '</option>';
	}
    $(motion_options).appendTo(".ptab_orders select.order_type");
    
	// Populate the outcome list depending on the value in the motion list.
	function update_selector($form) {
		if($form == null)
			$form = $(".ptab_orders");
		// Get the selected motion
		var motion = $form.find("select[name=f]").val();
		// If it's not a special type, then use the default 
		var outcomes = motion_outcomes[motion] != null ? 
							motion_outcomes[motion]:
							motion_outcomes[''];
		// Build the new selections
		var new_selections = "";
		for(i in outcomes) {
			new_selections += '<option value="' + outcomes[i].value + '">' + 
									outcomes[i].desc + '</option>';
		}
		$form.find("select.outcome_type").html(new_selections);
    }
	// Bind it to a change in the selector
    $('.ptab_orders select[name=f]').change(function () {
		update_selector(get_parent_with_class($(this), "ptab_orders"));
	});
	// Run it once to do initial setup
	update_selector();
	
	// Handle form submission
    $('.ptab_orders').submit(function (ev) {
		var $this = $(this);
		
		// Figure out the outcome type
		var out_t = $this.find(".outcome_type").val();
		// Get the motion type
        var mot_t = $this.find("[name=f] :selected").attr('data-motion');
		// Modify the motion type value to take into account the outcome
		var new_value = out_t.length ? 
							'outcome_exact-' + mot_t + " - " + out_t:
							'outcome-' + mot_t;
		$this.find("[name=f] :selected").attr('value', new_value);
        return true;
	});
	
	// We also need to bind 
	$(".ptabsubmenu").click(function () {
		return toggle_ptab_submenu();
	})
	.powerTip({smartPlacement : true})
	.data('powertiptarget', "ptabsubmenu_tip");
}

function setup_submenus () {
	// Setup the Federal Courts direct search.
	setup_fedcourts_search();
	// Setup the PTAB orders drop-down
	setup_ptab_order_search();
	// Setup TTAB Orders dropdown.
	setup_trademark_submenu();
}
	
function toggle_submenu(selector) {
	return function (force_hide, $target) {
		if(force_hide || $(selector + ":visible").length) {
			$(selector).hide();
		} else {
			update_label_widths($(selector).show().focus());
		}
	}
}

var toggle_ptab_submenu = toggle_submenu(".ptab_orders");
function setup_fedcourts_search() {
	// Bind the arrow to bring up the view
	$(".fedcourtsubmenu").powerTip({
		smartPlacement : true,
		mouseOnToPopup	: true
	}).data('powertiptarget', "fedcourts_tip");
}

var toggle_trademark_submenu = toggle_submenu(".trademark_options");
function setup_trademark_submenu() {
	// Bind the arrow to bring up the view
	$(".trademarksubmenu").click(function () {
		toggle_search_bar_court_dropdown(false, $(this).parent());
		return toggle_trademark_submenu()
	});
}

function set_search_bar_form_action($court, $doc, query, query_name) {
	// Set the search form's "action" parameter, which determines which court
	// and type of document to search.
	var base_action = window.location.pathname;
	var courttext = $court && $court.text ? $court.text() : $court;
	var court_url = "";
	if (courttext != SEARCH_ALL_STR) {
		for(var i = 0; i < COURT_ACRONYMS.length; i++) {
			var a = COURT_ACRONYMS[i];
			// Remove spaces, and add an end slash.
			var a_url = a.replaceAll(" ", "") + "/";
			if(courttext == a || courttext == a_url.slice(0, -1))  {
				// If the court text matches, it gets precedence.
				court_url = a_url;
				break;
			} else if (base_action.search("/" + a_url) > 0) {
				court_url = a_url;
			}
		}
	}
	
	// Figure out whether we're searching documents dockets, or both.
	var docid = $doc ? $doc.attr("id") : null;
	var doc =	docid == "documents_only" ? "documents/": 
				docid == "dockets_only" ? "dockets/":
				base_action.search("/documents/") > 0 ? "documents/":
				// >1 b/c if it's the start of the pathname, it's the dashboard.
				base_action.search("/dockets/") > 1 ? "dockets/":
				"";
	var form_base = "/search/" + court_url + doc; 
	var $search_form =  $(".search_engine_form")
		.attr("action", form_base)
		// Set the links in the search helper are also correct.
		.find(".exampleblock a").each(function (i, a) {
				var $a = $(a);
				$a.attr('href', form_base + $a.attr('href').replace("/search/", ""));
		}).end()
		.find(".added_q").remove().end()
		.find("input[name=fname_q_court_choice]").remove().end()
		.find("input[name=f][value^='q_court_choice']").remove().end();
	// Add 
	if(query) {
		$search_form.append('<input type="hidden" class="added_q" '+
			'name="f" value="q_court_choice-' + 
			query.replaceAll('"', "&quot;") + '">');
		if(query_name) {
			$search_form.append('<input type="hidden" class="added_q" '+
				'name="fname_q_court_choice" value="'  +
				query_name.replaceAll('"', "&quot;") + '">');
		}
	}
}
/**
 * Parse the current URL, and set the search bar's info based on it. Should
 * only be called initially when the page loads.
 **/
function setup_search_bar_input_from_url() {
	var base_action = document.URL.split("?")[0];
	var $form = $('.search_engine_form');
	
	// First set the search bar's court dropdown.
	var court_dropdown = SEARCH_ALL_STR;
	for(var i = 0; i < COURT_ACRONYMS.length; i++) {
		var a = COURT_ACRONYMS[i];
		var a_url = a.replaceAll(" ", "") + "/";
		if(base_action.search("/" + a_url) > 0) {
			court_dropdown = a;
			break;
		}
	}
	$form.find('.selected_court .selected').text(court_dropdown);
	 
	$(".court_dropdown li:contains('" + court_dropdown + "')")
		.addClass("selected");
	
	// The main search input.
	var params = url_params_to_object();
	var $textarea = $form.find('[name=q]');
	if(params.q) {
		$textarea.val(params.q)
	}
	function get_width(text) {
		return $form.find(".widthcalc").text(text).width();
	}
	// Shorten the placeholder text if there isn't much room.
	var text_area_width = $textarea.width();
	['Search by case number, title, keyword, company, patent, ...',
		'Search by case number, title, keyword, company, ...',
		'Search by case number, keyword, company, ...',
		'Search by case number, keyword, ...',
		'Search across litigation ...',
		'Search for cases ...',
		'Search ...'
	].forEach(function (text, i) {
		var cur_text = $textarea.attr("placeholder");
		if(get_width(cur_text) < text_area_width) {
			// It fits within the text area, stop iterating.
			return false;
		}
		// Change the placeholder text.
		$textarea.attr("placeholder", text);
	});
    
	// If we have facets, add them as hidden inputs
	var hidden_input = "";
	if (typeof facets != 'undefined' && facets) {
		for(i in facets) {
			var f = facets[i];
			if (f.name == "Search Type" || f.name == 'Date filed' )
				continue;
			for(var fci in f.counts) {
				var fval = f.counts[fci][0];
				var exists = f.counts[fci][3];
				if(exists && fval) {
					var val = (f.is_bool ? f.facet_name + "-" + fval:
									  f.facet_name + "_exact-" + fval);
					hidden_input += '<input type="hidden" name="f" value="' +
										escape_html(val) + '">';
				}
			}
		}
	}
	// Also add their names too.
	for(var k in params) {
		if(k.startsWith('fname_')) {
			hidden_input += '<input type="hidden" name="' + escape_html(k) + 
				'" value="' + escape_html(params[k]) + '">';
		}
	}
	$form.append(hidden_input);
	
	// Even if no date_filed_data, setup hidden input fields for date facets.
	$form
			.find("input[name=date_filed_start]")
					.attr("value", params.date_filed_start)
					.prop('disabled', params.date_filed_start==null).end()
			.find("input[name=date_filed_end]")
					.attr("value", params.date_filed_end)
					.prop('disabled', params.date_filed_end==null)
	.find("input[name=order_by]")
		.attr("value", params.order_by)
					.prop('disabled', params.order_by==null);
				
	$form.find(".search_helper li").powerTip({
		smartPlacement	: true,
		mouseOnToPopup	: false,
		intentSensitivity : 5,
		intentPollInterval : 200,
	});
}

/**
 * Look at the facets applied to the current page and change the advanced 
 * chooser accordingly.
 **/
function setup_search_bar_input_from_facets() {
	var $form = $("form.search_engine_form");
	var $chooser = $form.find(".court_chooser");
	if(!$chooser.length) {
		// No point in parsing the url if we don't have a chooser.
		return;
	}
	// Look for facets that start with the court choice keyword.
	var facets = $.deparam.querystring().f;
	if(!facets) {
		facets = [];
	} else if(!Array.isArray(facets)) {
		facets = [facets];
	}
	// Determine the query.
	var query = '';
	for(var i = 0; i < facets.length; i++) {
		// Ignore all irrelevant facets.
		if(facets[i].startsWith('q_court_choice-')) {
			query = facets[i];
			break;
		}
	}
	
	// Determine the URL query.
	var url_q = window.location.pathname.split("/").filter(function (s) {
			return s.length && s != 'search' && s != 'analytics'; 
		});
	url_q = url_q.length ? url_q[0] : '';
	
	// Get the hash of this facet.
	var qhash = gen_string_hash(url_q + query.substring('q_court_choice-'.length));
	var qkey = "court_choice_" + qhash.toString();
	var selected_items = sessionGet(qkey, true);
	if(Array.isArray(selected_items)) {
		global_courts_selected = selected_items;
		var desc = sessionGet(qkey + "_description", true);
		if(desc) {
			$form.find(".selected_court .selected").text(desc.shorter);
		}
	} else {
		// Can occur if a user clicks on a link to a search.
		console.log("Could not find selected_items: " + qkey);
	}
}

/**
 * Show or hide the Advanced Search Bar (the gear icon on the search bar).
 **/
function toggle_advanced_search(force_hide, $link) {
	// query_builder is the name of the advanced search dialog.
	var $search_bar = $link.parents(".search_engine_form");
    if(force_hide || searchbar_isactive_dropdown($search_bar, "query_builder")) {
        // Hide it
		searchbar_hide_dropdown(true, $search_bar)
    } else {
        // Show it
		searchbar_show_dropdown($search_bar, "query_builder")
    }
}

/**
 * Build a query based on the values entered by the user.
 */
function update_advanced_search() {
	var $t = $(this);
	var $qb = $t.parents("form");
	if (!$qb || !$qb.length) {
		$qb = $(".query_builder");
	}
	update_docket_documents_chk($t, $qb);
	// Set the query
	$(".search_engine_form [name=q]").val(query_builder_to_query($qb));
}

function update_docket_documents_chk($t, $qb) {
	// If they changed the document type, we need to validate.
	var $doc_type = $qb.find(".group.doc_type");
	if ($doc_type.length) {
		var is_checked = $t.is(":checked");
		switch ($t.attr("id")) {
			case 'q_chk_dockets':
				// Don't need to do anything special if checking dockets.
				break;
			case 'q_chk_documents':
				// If they uncheck documents, then uncheck all sub docs.
				$doc_type.find(".more input[type=checkbox]")
					.prop("checked", is_checked);
				break;
			default:
				// If they check/uncheck subdocs, may need to change documents.
				var d_chks = $doc_type.find(".more input").map(function () {
					return $(this).is(":checked");
				}).toArray();
				var all_true = d_chks.every(function (i) { return i; });
				var one_true = d_chks.some(function (i) { return i; });
				$doc_type.find("#q_chk_documents")
					.prop("checked", all_true)
					.prop("indeterminate", !all_true && one_true);
				break;
		}
		if (!is_checked && !$doc_type.find("input:checked").length) {
			// If none of them are checked, check all of them.
			$doc_type.find("input[type=checkbox]").prop("checked", true);
		}
	}
}

/**
 * Build a query based on the values entered by the user.
 * @param $qb A query builder object.
 * @returns {string}
 */
function query_builder_to_query($qb) {
	// Get the values
	var all = $qb.find("#all_these_words").val();
	var any = $qb.find("#any_these_words").val();
	var none = $qb.find("#none_these_words").val();
	var exact = $qb.find("#exact_these_words").val().strip();
	var with_a = $qb.find("#within_a").val().strip();
	var with_b = $qb.find("#within_b").val().strip();
	var with_n = $qb.find("#within_n").val().strip();
	var party_name = $qb.find("#filter_by_party").val().strip();
	var party_type = $qb.find("#filter_by_party_type").val().strip();
	var party_firm = $qb.find("#filter_by_party_firm").val().strip();
	var party_atny = $qb.find("#filter_by_party_attorney").val().strip();
	var party_public = $qb.find("#filter_by_party_public").val().strip();
	var f_atleast = $qb.find("#filter_by_atleast").val().strip();
	var f_filed_date_start = ($qb.find("#filter_date_filed_start").val() || '').strip();
	var f_filed_date_end = ($qb.find("#filter_date_filed_end").val() || '').strip();
	var f_filing_date_start = ($qb.find("#filter_date_last_filing_start").val() || '').strip();
	var f_filing_date_end = ($qb.find("#filter_date_last_filing_end").val() || '').strip();
	var f_filed_date = ($qb.find("#filter_by_filed_date").val() || '').strip();

	var deadline = $qb.find("#filter_by_deadline").val(); // Don't strip
	var deadline_date = $qb.find("#filter_by_deadline_date").val().strip();
	var filters = [];
	for (var i=0; i<4; i++) {
		if(!$qb.find("#filter_by_field" + i).length)
			break;
		var f = $qb.find("#filter_by_field" + i).val().strip();
		var f_txt = $qb.find("#filter_by_field_txt" + i).val().strip();
		if(f && f_txt && f.length && f_txt.length)
			filters = filters.concat([[f, f_txt]]);
	}

	var splitp = function (x) {
		return x.strip().split(" ").filter(function(x) { return x.length>0});
	};
	var wrapifspace = function(x, always) {
		return wrap_query(x, always);
	};

	// Construct the query
	var q = [];
	if(all && all.length)
		q.push(wrapifspace(splitp(all).join(" ")));
	if(any && any.length)
		q.push(wrapifspace(splitp(any).join(" OR ")));
	if(exact && exact.length)
		q.push('"' + exact + '"');
	if(with_a && with_a.length && with_b && with_b.length) {
		var w_q = wrapifspace(splitp(with_a).join(" ")) + " " + with_n + " " +
			wrapifspace(splitp(with_b).join(" "));
		if(q.length)
			w_q = "(" + w_q + ")";
		q.push(w_q);
	}
	if(party_firm && !party_type && !party_public && !party_atny && !party_name) {
		// Only searching for a party.
		q.push("firm:" + wrapifspace(party_firm));
	} else if(!party_firm && !party_type && !party_public && party_atny && !party_name) {
		// Only searching for an attorney.
		q.push("attorney:" + wrapifspace(party_atny));
	} else if(party_type || party_public || party_firm || party_atny) {
		var p_q = '';
		if(party_name) {
			p_q += "name:" + wrapifspace(party_name) + " ";
		}
		if(party_firm) {
			if(party_atny) {
				p_q += "firm:(name:" + wrapifspace(party_firm) +
					" attorney:" + wrapifspace(party_atny) + ") ";
			} else {
				p_q += "firm:(name:" + wrapifspace(party_firm) + ") ";
			}
		} else if (party_atny) {
			p_q += "firm:(attorney:" + wrapifspace(party_atny) + ") ";
		}
		if(party_type) {
			p_q += "type:" + wrapifspace(party_type) + " ";
		}
		if(party_public == 'yes') {
			p_q += "fact:(type:Exchange) ";
        } else if(party_public == 'no') {
			p_q += "not fact:(type:Exchange) ";
        }
        p_q = "party:" + "(" + p_q.strip() + ")";
        q.push(p_q);
	} else if(party_name) {
		q.push("party:" + wrapifspace(party_name));
	}
	if(f_atleast.length) {
		q.push(f_atleast);
	}
	if(f_filed_date.length) {
		q.push(f_filed_date);
	}
	if(f_filed_date_start) {
		q.push("from:" + wrapifspace(f_filed_date_start));
	}
	if(f_filed_date_end) {
		q.push("to:" + wrapifspace(f_filed_date_end));
	}
	if(f_filing_date_start) {
		if(f_filing_date_end) {
			q.push("date_last_filing:(from:" + wrapifspace(f_filing_date_start)+
				" to:" + wrapifspace(f_filing_date_end) + ")");
		} else {
			q.push("date_last_filing:(from:" +
				wrapifspace(f_filing_date_start) + ")");
		}
	} else if(f_filing_date_end) {
		q.push("date_last_filing:(to:" +
				wrapifspace(f_filing_date_end) + ")");
	}

	if(deadline.length) {
		var d_q = deadline.strip();
		if(deadline_date) {
			d_q += " " + deadline_date;
		}
		d_q = d_q.strip();
		d_q = d_q.length ? wrapifspace(d_q, true) : '""';
		q.push("deadline:" + d_q);
	} else if (deadline_date) {
		// Always wrap deadlines, we can get errors if not.
		q.push("deadline:" + wrapifspace(deadline_date, true));
	}
	// Iterate over all filters, adding 1 by 1
	for(var f_i=0; f_i<filters.length; f_i++) {
		q.push(filters[f_i][0] + ":(" + filters[f_i][1] + ")");
	}

	// Add the document types.
	var $chk_dock = $qb.find("#q_chk_dockets");
	var $chk_docu = $qb.find("#q_chk_documents");
	if($chk_docu.prop("indeterminate")) {
		// Documents are indeterminate, look at document syb-types.
		var chks = [], unchks = [];
		// Fill our arrays of checked and unchecked.
		$doc_type.find(".more [type=checkbox]").each(function () {
			var $t = $(this);
			var is = $t.data("is");
			$t.is(":checked") ? chks.push(is) : unchks.push(is);
		}).toArray();
		// Determine how many are checekd.
		var num_true = chks.length;
		var doc_q = '';
		var additive = true;
		if(chks.length == 0) {
			// Something should be checked for docs to be indeterminate.
			console.warn("Should have at least on checked.");
		} else if(unchks.length == 0) {
			// All are selected, just view all documents.
			console.warn("Documents should not be indeterminate");
			doc_q = "is:document";
		} else if(unchks.length == 1) {
			// They've unchecked just one item, exclude that one.
			doc_q = unchks.map(function (i) { return "not is:" + i; }).join(" OR ");
			// We are not adding, we are removing.
			additive = false;
		} else if(chks.length == 1) {
			// They've checked one item, use an "is" filter.
			doc_q = "is:" + chks[0];
		} else {
			// They've checked more than one, use multiple "is".
			doc_q = chks.map(function (i) { return "is:"+i; }).join(" OR ");
		}
		// We may need to wrap in parenthesis.
		doc_q = wrapifspace(doc_q);
		if ($chk_dock.is(":checked")) {
			// Add dockets as well.
			doc_q = "(is:docket OR " + doc_q + ")";
		} else if(!additive) {
			q.push("is:document")
		}
		q.push(doc_q);
	} else if ($chk_dock.is(":checked")) {
		// Dockets are checked.
		if (!$chk_docu.is(":checked"))
			q.push("is:docket");
	} else if($chk_docu.is(":checked")) {
		q.push("is:document");
	} else {
		console.warn("Nothing is checked.")
	}
	// Put not at the end, not sure about its parsing.
	if(none && none.length)
		q.push("NOT " + wrapifspace(splitp(none).join(" OR ")));
	q = q.join(" AND ");

	return q;
}

/////////////////////////////////
// Handle Drop-Down Menus
var drop_downs = [];
function add_global_dropdown(selector, shower, func) {
	var saved_selector = selector + ':visible';
	// Prevent duplicates
	var exists = drop_downs.filter(function (d) {
		return saved_selector == d.selector;
	}).length > 1;
	if(exists) {
		return
	}
	drop_downs.push({
		// Add the ":visible" selector, because we only care about closing
		// visible dialogs.
		selector : saved_selector,
		shower 	 : shower,
		func 	 : func,
	});
}

var debug_global_dropdown = true;
function init_global_dropdown() {
	add_global_dropdown(
		'.ptab_orders'	,
		'.ptabsubmenu',
		toggle_ptab_submenu
	);
	add_global_dropdown(
		'.trademark_options',
		'.trademarksubmenu',
		toggle_trademark_submenu
	);
	add_global_dropdown(
		'.search_tabs_dropdown',
		'.query_builder, .selected_court, .search_engine_form textarea',
		searchbar_hide_dropdown
	);
	// Any CSS that shows/hides controls can have problems on iPhone:
	// https://www.nczonline.net/blog/2012/07/05/ios-has-a-hover-problem/
	// By hiding it and resetting its state, we can 
	add_global_dropdown(
		'.user_submenu',
		'.user_menu .user_icon',
		function () { $('.user_submenu').hide().css("display", ""); }
	);
	add_global_dropdown(
		'#float_menu .pages ul',
		'#float_menu .pages',
		function () { $('#float_menu .pages').hide().css("display", ""); }
	);
	
	
	// Track where mousedown occurred to prevent closing dropdowns when text selection
	// starts inside but ends outside the dropdown
	var mousedown_target = null;
	
	// Helper function to check if a target is inside a dropdown or its trigger elements
	function isInsideDropdown(target, $dropdown, $showers) {
		if (!target) return false;
		var $targ = $(target);
		var is_inside = $targ.is($dropdown) || $targ.parents().index($dropdown) != -1 ||
		                $targ.is($showers) || $targ.parents().index($showers) != -1;
		
		// Special case: jQuery UI datepicker creates elements outside the DOM tree
		// If we're checking the query_builder, also check if click is on datepicker UI
		if (!is_inside && $dropdown.hasClass('search_tabs_dropdown')) {
			// Check if target is inside datepicker container or has datepicker-related classes
			is_inside = $targ.closest('.ui-datepicker').length > 0 ||
			            $targ.hasClass('ui-datepicker-trigger') ||
			            $targ.closest('.ui-datepicker-header').length > 0 ||
			            $targ.parents('[class*="ui-datepicker"]').length > 0 ||
			            $targ.is('[class*="ui-datepicker"]');
		}
		
		return is_inside;
	}
	
	// Hide various windows when you click outside of them
	function onHTMLClick(event) {
		// Hide the dropdown only if BOTH mousedown and mouseup happened outside.
		// This prevents closing during text selection that starts inside but ends outside.
		for(var i in drop_downs) {
			var d = drop_downs[i];
			var $dropdown = $(d.selector);
			if(!$dropdown || !$dropdown.length || $dropdown.css("visibility") == "hidden")
				continue;
			
			var $showers = $(d.shower);
			var click_outside = !isInsideDropdown(event.target, $dropdown, $showers);
			var mousedown_outside = !isInsideDropdown(mousedown_target, $dropdown, $showers);
			
			if(click_outside && mousedown_outside) {
				if(debug_global_dropdown){
					console.log("Click outside: " + d.selector + ", closing.");
				}
				if(d.func) {
					d.func(true, $dropdown);
				} else {
					console.log("No close function for: " + d.selector);
				}
			} else if (debug_global_dropdown) {
				console.log("Click inside or text selection: " + d.selector + ", keeping.");
			}
		}
	}
	
	// Bind to mousedown/touchstart to track where selection/touch starts
	$('html').on('mousedown touchstart', function(event) {
		mousedown_target = event.target;
	});
	// Bind to BOTH click and touch events of non clickable elements.
	$('html').click(onHTMLClick).bind("touchend", onHTMLClick);

	// Make sure the drop-down can be seen over a PDF
	if ($("#EmbeddedPDF").length) {
		$(".search_engine_form .court_dropdown")
			.prepend(bgiframe).end();
	}
	
	setup_search_bar();
}

//////////////////////////////////
// Common to Docket and Search Page (e.g., exporting dockets)

/**
 * Export a set of search results or a docket either as an email and provides a 
 * download link to download the export.
 * data:        Information identifying the search or docket to send.
 * success:     Callback function that takes a URL to download the export.
 * canceled:    Callback that should return true if the user cancels. Even if 
 *              the user cancels, the export will be emailed to them.
 * error:       Error with a message parameter.
 */
function export_docket_report(options) {
    var data = options.data;
    var canceled = options.canceled || function () { return false; }; 
    var success = options.success;
    var error = options.error;
    // Callback for py3 exports (email will be sent instead of download)
    var py3Export = options.py3Export || function (msg) {
        // Default: treat as success with no download URL
        if (success) success(null, msg);
    };

    function clean_msg(jqXHR) {
    	var msg = $(jqXHR.responseText).text().replace(/\s+/ig, " ").strip();
    	// Sometimes we get weird messages we need to clean up. See #1070.
    	return msg.replace(/\s*Bad\s+(Response|Request)/ig, "");
	}

    var checks = 0;
    function check_export_ready(chk_options) {
		var ready = chk_options.ready;
		var notready = chk_options.notready;
		var py3ExportTriggered = chk_options.py3ExportTriggered;
		var url = '/export_docket_report.ajax?' + $.param(data);
		checks += 1;
		$.getJSON(url + "&check_ready", function (resp) {
			if(resp.success && resp.ready) {
				// Download the export.
				ready(url);
			} else if (resp.success && resp.py3_export) {
				// Py3 export - user will receive email, stop polling
				py3ExportTriggered(resp.message || 'Your export is being processed. You will receive an email when ready.');
			} else if (resp.success) {
				// Cannot download yet.
				notready();
			} else if(error) {
				// Error
				error(resp.error);
			}
		})
		.fail(function (jqXHR, textStatus, errorMsg) {
			if(error) {
				error("Can't " + (checks <= 1 ? "start" : "check") +
					" export " + textStatus + ": " + clean_msg(jqXHR));
			}
		});
	}
    function on_ready(url) {
        if(!canceled()) {
            success(url);
        }
    }
    function on_py3_export(msg) {
        if(!canceled()) {
            py3Export(msg);
        }
    }
    function on_notready() {
        if(canceled()) {
            return;
        }
        setTimeout(function () {
            check_export_ready({
                ready : on_ready,
                notready : on_notready,
                py3ExportTriggered : on_py3_export,
            });
        }, 2000);
    }
    
    check_export_ready({
        ready : on_ready,
        py3ExportTriggered : on_py3_export,
        notready : function () {
            // Make the post call to start the export.
            $.post("/export_docket_report.ajax", data, function(resp) {
                if(resp.success && resp.py3_export) {
                    // Py3 export started - user will receive email, stop polling
                    on_py3_export(resp.message || 'Your export is being processed. You will receive an email when ready.');
                } else if(resp.success) {
                    on_notready();
                } else {
                    error(resp.error);
                }
            }, "json")
			.fail(function (jqXHR, textStatus, errorMsg) {
				if(error) {
					error("Can't start export " + textStatus + ": " + clean_msg(jqXHR));
				}
			});
        },
    });
}

/**
 * Export a Docket (Full Case Information) into a PDF document.
 * data:        Information identifying the search or docket to send.
 * success:     Callback function that takes a URL to download the export.
 * canceled:    Callback that should return true if the user cancels. Even if
 *              the user cancels, the export will be emailed to them.
 * error:       Error with a message parameter.
 */
function print_docket(options) {
    var data = options.data;
    var canceled = options.canceled || function () { return false; };
    var success = options.success;
    var error = options.error;

    function clean_msg_print(jqXHR) {
    	var msg = $(jqXHR.responseText).text().replace(/\s+/ig, " ").strip();
    	// Sometimes we get weird messages we need to clean up. See #1070.
    	return msg.replace(/\s*Bad\s+(Response|Request)/ig, "");
	}

    var checks = 0;
    function check_print_ready(chk_options) {
		var ready = chk_options.ready;
		var notready = chk_options.notready;
		var url = '/print_docket.ajax?' + $.param(data);
		checks += 1;
		$.getJSON(url + "&check_ready", function (resp) {
			if(resp.success && resp.ready) {
				// Download the export.
				ready(url);
			} else if (resp.success) {
				// Cannot download yet.
				notready();
			} else if(error) {
				// Error
				error(resp.error);
			}
		})
		.fail(function (jqXHR, textStatus, errorMsg) {
			if(error) {
				error("Can't " + (checks <= 1 ? "start" : "check") +
					" export " + textStatus + ": " + clean_msg_print(jqXHR));
			}
		});
	}
    function on_ready_print(url) {
        if(!canceled()) {
            success(url);
        }
    }
    function on_notready_print() {
        if(canceled()) {
            return;
        }
        setTimeout(function () {
            check_print_ready({
                ready : on_ready_print,
                notready : on_notready_print,
            });
        }, 2000);
    }

    check_print_ready({
        ready : on_ready_print,
        notready : function () {
            // Make the post call to start the export.
            $.post("/print_docket.ajax", data, function(resp) {
                if(resp.success) {
                    on_notready_print();
                } else {
                    error(resp.error);
                }
            }, "json")
			.fail(function (jqXHR, textStatus, errorMsg) {
				if(error) {
					error("Can't start Print " + textStatus + ": " + clean_msg_print(jqXHR));
				}
			});
        },
    });
}

/**
 * Convert raw data into excel file.
 * See the backend code for the proper format.
 * @param filename The name of the file to export into.
 * @param pages The data to export.
 * @param raw_data If a function, then return the excel document as raw data.
 * 	to the provided async function.
 */
function export_data_to_excel(filename, pages, raw_data) {
	var exportable = {
		filename : safe_filename(filename),
		pages : pages,
	};
	var exportable_json = JSON.stringify(exportable);

	if(raw_data) {
		// Download the file
		var xhr = new XMLHttpRequest();
		xhr.open('POST', "/export_data.ajax", true);
		xhr.responseType = 'arraybuffer';
		xhr.onload = function(e) {
			if (this.status != 200) {
				// Bad Download
				raw_data(false, e);
				return;
			}
			raw_data(true, xhr.response);
		};
		// Another way of failing.
		xhr.onerror = function(e) { on_failure(false, e); };
		xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
		xhr.send("data=" + encodeURIComponent(exportable_json));
		return;
	}

	// Create a POST form to submit the data.
	var form = document.createElement("form");
	form.setAttribute("method", "POST");
	form.setAttribute("action", "/export_data.ajax");
	var hiddenField = document.createElement("input");
	hiddenField.setAttribute("type", "hidden");
	hiddenField.setAttribute("name", "data");
	hiddenField.setAttribute("value", exportable_json);
	form.appendChild(hiddenField);
	document.body.appendChild(form);

	// Submit it, and get the file back.
	form.submit();
}

//////////////////////////////////
// Go Daddy Seal
function init_godaddy_seal() {
	$(".godaddyseal")
		.html('<img style="cursor:pointer;cursor:hand" width="132" height="31" ' +
			'src="/site_media/img/godaddy_seal.gif" alt="GoDaddy Seal"/>')
		.click(function() {
			var bgHeight = "460";
			var bgWidth = "593";
			var url = "https://seal.godaddy.com/verifySeal?sealID=9LzCSAFyXWQYGU7DSvqhI3VbzHewnrfszUZP2FgzsTOKvNw94aXWcjH";
			window.open(url,'SealVerification','menubar=no,toolbar=no,personalbar=no,location=yes,status=no,resizable=yes,fullscreen=no,scrollbars=no,width=' + bgWidth + ',height=' + bgHeight);
		});
};

function html_escape(text) {
    // escape a string that would have possible cross-scripting embedded into it.
    return sanitize_dom_url(text);
}

// Work in progress transition to modern javascript. For now, we have many
// global functions, but we're not making any new ones, and can refactor each in pieces.
export {
	// Google Analytics Usage tracking.
	analytics_track,
	analytics_dimension,

	// General Number Utility functions.
	// gen_string_hash,
	capitalize,
	get_abbreviation,
	plural_have,
	plural,
	plural_n,
	escape_html,
	human_list,
	humanize_time,
	humanize_time_utc,
	humanize_time_granular,
	is_number,
	number_with_commas,
	number_with_abbrev,
	roundNumber,

	uniqueid,

	sanitize_dom_url,
	open_url,
	debouncer,

	// Array Utils
	sum_array,
	unique_array,

	join_jquery,
	wrap_html,
	html_tag,
	wrap_query,

	create_html_from_json,
	json_html_expander,
	create_html_from_markdown,
	create_html_table,

	// Events
	makeCustomEvent,
	onEvent,
	dispatchEvent,

	// Class Helpers. Pretty duplicative of jquery.
	getClassList,
	addClass,
	removeClass,
	toggleClass,
	getParentElement,
	get_parent_with_tag,
	get_parent_with_class,

	// Local cache
	sessionSet,
	sessionGet,
	sessionClear,

	load_css,
	load_drawing_js,

	// get_window_height,
	// getScrollbarWidth,

	init_powertip_defaults,

	show_success_usermsg,
	show_error_usermsg,
	show_usermsg,
	show_confirm_usermsg,

	get_gravatar,

	setup_marketing_inquiry_form,

	copy_to_clipboard,
	// copy_to_clipboard_inner,

	show_modal,
	modal_progress_start,
	modal_progress_set,
	modal_progress_error,
	modal_progress_close,

	download_file,
	safe_filename,
	map_parallel,
	create_download_dialog,
	download_files,
	ai_task_document_summarize,
	ai_task_options,
	download_to_ai_task,

	image_uploader,

	show_support_overlay,
	// init_support_overlay,
	// init_forgot_password,
	// init_hd_bd_holder,
	// init_pacer_tips,
	// init_float_menu,
	// common_setup,

	get_admin_url,
	show_salesforce_chat_window,
	setup_salesforce_live_chat_window,

	setup_common_sidebar,
	adjust_actionbar_items,
	init_close_buttons,

	// Paywall Related
	borderless_dialog,

	update_label_widths,

	// Search Bar Related
	// setup_search_bar,
	searchbar_show_dropdown,
	SEARCH_ALL_STR,
	// searchbar_isactive_dropdown,
	// searchbar_hide_dropdown,
	get_url_hash,
	get_suggest_handler,
	add_entity_suggestion_to_input,
	add_contained_entities,
	contained_entities_to_query,
	url_params_to_object,
	url_to_fragment,
	url_from_params,
	// toggle_search_bar_court_dropdown,
	setup_court_chooser,
	transform_court_chooser_to_coverage,
	// setup_ptab_order_search,
	// setup_submenus,
	// toggle_submenu,
	// setup_fedcourts_search,
	// setup_trademark_submenu,
	// set_search_bar_form_action,
	// setup_search_bar_input_from_url,
	// setup_search_bar_input_from_facets,
	// toggle_advanced_search,
	// update_advanced_search,
	// update_docket_documents_chk,
	// query_builder_to_query,

	add_global_dropdown,
	init_global_dropdown,

	export_docket_report,
	export_data_to_excel,
	print_docket,

	// init_godaddy_seal,
	html_escape
}

////////// Recaptcha functions
//Catch click on signup to varify recaptcha
$(document).ready(function() {
  // Call the initialization function to set up reCAPTCHA and form submission
  initRecaptchaSignup();
});

// Main function to initialize reCAPTCHA and handle form submission
function initRecaptchaSignup() {
  // Select the form element with ID "signup" using jQuery
  var $form = $("#signup");
  // Select the hidden input field for storing the reCAPTCHA token
  var $recaptchaInput = $("#recaptcha_token_signup");
  // Select the submit button (input[type="submit"]) inside the form
  var $submitButton = $form.find('input[type="submit"]');
  // Select the loader image (class="loader") inside the form
  var $loader = $form.find(".loader");

  // Check if all required elements exist in the DOM
  if ($form.length === 0 || $recaptchaInput.length === 0 || $submitButton.length === 0 || $loader.length === 0) {
    // Schedule a retry after 500ms to handle dynamic loading of the form
    setTimeout(initRecaptchaSignup, 500);
    // Exit the function to avoid further execution until elements are found
    return;
  }

  // Define a function to generate a reCAPTCHA token
  function refreshRecaptchaToken() {
    // Check if the reCAPTCHA Enterprise API is loaded
    if (!window.grecaptcha?.enterprise) {
      // Return a resolved promise with null to indicate failure
      return Promise.resolve(null);
    }
    // Call the reCAPTCHA Enterprise API to generate a token
    // Uses the site key and action "login" for verification
    return grecaptcha.enterprise.execute(
      "6LeK5wkrAAAAAKTlL1SEjkdshS_RvoQ01X_BWwOK",
      { action: "login" }
    ).then(function(token) {
      // Set the token value in the hidden input field
      $recaptchaInput.val(token);
      // Return the token for use in form submission
      return token;
    }).catch(function(error) {
      // Log any errors during token generation (e.g., network issues)
      console.error("reCAPTCHA error:", error);
      // Return null to indicate failure
      return null;
    });
  }

  // Remove any existing submit event handlers to prevent duplicates
  $form.off("submit").on("submit", function(e) {
    // Prevent the default form submission (e.g., native POST request)
    e.preventDefault();
    // Stop the event from bubbling to other handlers (e.g., click-outside scripts)
    e.stopPropagation();
    // Show the loader by explicitly setting CSS properties
    // Overrides the inline visibility: hidden and ensures display is block
    $loader.css({ visibility: "visible", display: "block" });
    // Disable the submit button to prevent multiple submissions
    $submitButton.prop("disabled", true);

    // Generate a reCAPTCHA token asynchronously
    refreshRecaptchaToken().then(function(token) {
      // Check if token generation failed
      if (!token) {
        // Alert the user to retry
        alert("Failed to get reCAPTCHA token. Please try again.");
        // Hide the loader by resetting CSS properties
        $loader.css({ visibility: "hidden", display: "none" });
        // Re-enable the submit button for another attempt
        $submitButton.prop("disabled", false);
        // Exit the submission process
        return;
      }

      // Create a FormData object to collect all form input values
      var formData = new FormData($form[0]);

      // Send an AJAX request to the form's action URL
      $.ajax({
        // Use the form's action attribute (/create.ajax) as the URL
        url: $form.attr("action"),
        // Use the form's method attribute (POST)
        method: $form.attr("method"),
        // Send the form data, including the reCAPTCHA token
        data: formData,
        // Prevent jQuery from processing the FormData object
        processData: false,
        // Let the browser set the correct content type for FormData
        contentType: false,
        // Indicate this is an AJAX request
        headers: { "X-Requested-With": "XMLHttpRequest" },
        // Handle successful server response
        success: function(data) {
          // Check if the response is a string (needs parsing)
          if (typeof data === "string") {
            // Attempt to parse the string into a JSON object
            try {
              data = JSON.parse(data);
            } catch (e) {
              // Log parsing errors
              console.error("Failed to parse response:", e);
              // Alert the user of a server error
              alert("Server error. Please try again.");
              // Hide the loader
              $loader.css({ visibility: "hidden", display: "none" });
              // Re-enable the submit button
              $submitButton.prop("disabled", false);
              // Exit the success handler
              return;
            }
          }
          // Check if the server indicates a successful signup
          if (data.success) {
            // Redirect the user to the /dockets page
            window.location.href = "/dockets";
          } else {
            // Extract an error message with fallbacks
            const errorMsg = data.error || data.error_stack?.split('\n').slice(-2)[0] || "Signup failed. Please try again.";
            // Display the error using a custom function
            show_error_usermsg(errorMsg);
            // Hide the loader
            $loader.css({ visibility: "hidden", display: "none" });
            // Re-enable the submit button
            $submitButton.prop("disabled", false);
          }
        },
        // Handle AJAX request errors (e.g., network issues)
        error: function(xhr) {
          // Log the error for debugging
          console.error("AJAX error:", xhr);
          // Display a generic error message
          show_error_usermsg("Signup error. Please try again.");
          // Hide the loader
          $loader.css({ visibility: "hidden", display: "none" });
          // Re-enable the submit button
          $submitButton.prop("disabled", false);
        }
      });
    });
  });

  // Remove any existing click event handlers on the submit button
  $submitButton.off("click").on("click", function(e) {
    // Prevent the default click behavior
    e.preventDefault();
    // Stop the click event from bubbling to other handlers (e.g., click-outside scripts)
    e.stopPropagation();
    // Programmatically trigger the form's submit event
    $form.trigger("submit");
  });
}

// Initialize reCAPTCHA handler when DOM loads
$(document).ready(function() {
    initRecaptchaSignup();
});

//Catch clik on ptab-analytics web page -> land_join.html -. intercept click on <form id='more_info_email_form'... </form>
function initRecaptchaPtab() {
    var $form = $('#more_info_email_form_ptab');
    var $recaptchaInput = $('#recaptcha_token_support_message');

    if ($form.length === 0 || $recaptchaInput.length === 0) {
        console.warn("reCAPTCHA elements not found. Skipping initialization.");
        return; // Exit if elements don't exist
    }
    function refreshRecaptchaToken() {
        return grecaptcha.enterprise.execute(
            '6LePNg4rAAAAAAQR_BKxwZu6V8ctUA-x7f5Rqjc1',
            { action: 'submit' }
        ).then(function(token) {
            $recaptchaInput.val(token);
            return token;
        }).catch(function(error) {
            console.error('reCAPTCHA error:', error);
            return null;
        });
    }
    // Initialize on page load
    grecaptcha.enterprise.ready(refreshRecaptchaToken);

    // Handle form submission
    $form.on('submit', function(e) {
        e.preventDefault();
        refreshRecaptchaToken().then(function(token) {
            if (!token) {
                alert('Failed to get reCAPTCHA token. Please refresh and try again.');
                return;
            }
            var formData = new FormData($form[0]);
            $.ajax({
                url: $form.attr('action'),
                method: $form.attr('method'),
                data: formData,
                processData: false,
                contentType: false,
                headers: { "X-Requested-With": "XMLHttpRequest" },
                success: function(data) {
                    console.log("Response from server:", data);
                    if (data.success) {

                        $form.trigger("reset");
                    } else {
                        console.log("Form submission failed. Please check your details.");
                    }
                }
            });
        });
    });
}

//Initialize reCAPTCHA handler when DOM loads
$(document).ready(function() {
    initRecaptchaPtab();
});

//Catch click on enhance web page -> enhance.html -. intercept click on <form id='more_info_email_form'... </form>
function initRecaptchaEnhance() {
    var $form = $('#more_info_email_form_enhance');
    var $recaptchaInput = $('#recaptcha_token_support_message');

    if ($form.length === 0 || $recaptchaInput.length === 0) {
        console.warn("reCAPTCHA elements not found. Skipping initialization.");
        return; // Exit if elements don't exist
    }
    function refreshRecaptchaToken() {
        return grecaptcha.enterprise.execute(
            '6Ldb9g0rAAAAAMsmvgbg5RiS_3neOBgLi7meMPCf',
            { action: 'submit' }
        ).then(function(token) {
            $recaptchaInput.val(token);
            return token;
        }).catch(function(error) {
            console.error('reCAPTCHA error:', error);
            return null;
        });
    }
    // Initialize on page load
    grecaptcha.enterprise.ready(refreshRecaptchaToken);
    // Handle form submission
    $form.on('submit', function(e) {
        e.preventDefault();
        refreshRecaptchaToken().then(function(token) {
            if (!token) {
                alert('Failed to get reCAPTCHA token. Please refresh and try again.');
                return;
            }
            var formData = new FormData($form[0]);
            $.ajax({
                url: $form.attr('action'),
                method: $form.attr('method'),
                data: formData,
                processData: false,
                contentType: false,
                headers: { "X-Requested-With": "XMLHttpRequest" },
                success: function(data) {
                    console.log("Response from server:", data);
                    if (data.success) {
                        $form.trigger("reset");
                    } else {
                        console.log("Form submission failed. Please check your details.");
                    }
                }
            });
        });
    });
}

// Initialize reCAPTCHA handler when DOM loads
$(document).ready(function() {
    initRecaptchaEnhance();
});
//Catch click on land orange web page -> land_orange_infographic.html -. intercept click on <form id='more_info_email_form'... </form>
function initRecaptchaBigPharma() {
    var $form = $('#more_info_email_form_big_pharma');
    var $recaptchaInput = $('#recaptcha_token_support_message');
    if ($form.length === 0 || $recaptchaInput.length === 0) {
        console.warn("reCAPTCHA elements not found. Skipping initialization.");
        return; // Exit if elements don't exist
    }
    function refreshRecaptchaToken() {
        return grecaptcha.enterprise.execute(
            '6Lcgsw0rAAAAANCYS2QFfZZTG6GkypSNzyPgmHnO',
            { action: 'submit' }
        ).then(function(token) {
            $recaptchaInput.val(token);
            return token;
        }).catch(function(error) {
            console.error('reCAPTCHA error:', error);
            return null;
        });
    }
    // Initialize on page load
    grecaptcha.enterprise.ready(refreshRecaptchaToken);
    // Handle form submission
    $form.on('submit', function(e) {
        e.preventDefault();
        refreshRecaptchaToken().then(function(token) {
            if (!token) {
                alert('Failed to get reCAPTCHA token. Please refresh and try again.');
                return;
            }

            var formData = new FormData($form[0]);
            $.ajax({
                url: $form.attr('action'),
                method: $form.attr('method'),
                data: formData,
                processData: false,
                contentType: false,
                headers: { "X-Requested-With": "XMLHttpRequest" },
                success: function(data) {
                    console.log("Response from server:", data);
                    if (data.success) {
                        $form.trigger("reset");
                    } else {
                        console.log("Form submission failed. Please check your details.");
                    }
                }
            });
        });
    });
}

// Initialize reCAPTCHA handler when DOM loads
$(document).ready(function() {
    initRecaptchaBigPharma();
});